import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Dil dosyaları
const resources = {
  tr: {
    translation: {
      // Ana sayfa
      'hero.title': 'Utkan eSIM',
      'hero.subtitle': 'Dijital Bağlantının Geleceği',
      'hero.description': 'Yeni nesil dijital bağlantı deneyimiyle sınırları kaldırıyoruz.',
      'hero.description2': 'Dünya çapında hızlı, güvenli ve uygun fiyatlı eSIM çözümleri.',

      // Özellikler
      'features.countries': '150+ Ülke',
      'features.activation': 'Anında Aktivasyon',
      'features.support': '7/24 Destek',

      // Sayaç
      'countdown.title': 'Web Sitemiz Çok Yakında!',
      'countdown.days': 'Gün',
      'countdown.hours': 'Saat',
      'countdown.minutes': 'Dakika',
      'countdown.seconds': 'Saniye',
      'countdown.launch': 'Web Sitemiz Açıldı!',
      'countdown.loading': 'Yükleniyor...',

      // Uygulamalar
      'apps.title': 'Mobil Uygulamalarımız',
      'apps.ios.label': 'Download on the',
      'apps.ios.name': 'App Store',
      'apps.android.label': 'GET IT ON',
      'apps.android.name': 'Google Play',

      // İletişim
      'contact.title': 'Lansmana Kadar Bize Ulaşın',
      'contact.whatsapp': 'WhatsApp: +43 676 555 1 333',
      'contact.email': 'E-posta: info@utkanesim.com',

      // About sayfası
      'about.hero.title': 'Utkan eSIM Hakkında',
      'about.hero.description': 'Kişisel verilerinizin güvenliği bizim için çok önemlidir. Bu politika, verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar.',
      'about.story.title': 'Hikayemiz',
      'about.story.content': '2024 yılında tutkulu gezginler ve teknoloji meraklılarından oluşan bir ekip tarafından kurulan Utkan eSIM, insanların yurtdışında internete bağlanma şeklini devrim yaratacak şekilde değiştirmeyi hedefliyor. 190\'dan fazla ülke ve bölge için yüksek kaliteli, güvenilir eSIM veri planları sunarak, indiğiniz andan itibaren hızlı internet erişiminizi sağlıyoruz.',
      'about.mission.title': 'Misyonumuz',
      'about.mission.content': 'Gezginlere dünya çapında basit, uygun fiyatlı ve anında bağlantı sağlayarak, sınırlar olmadan keşfetmelerini, çalışmalarını ve iletişimde kalmalarını sağlamak.',
      'about.vision.title': 'Vizyonumuz',
      'about.vision.content': 'Dijital bağlantı çözümleri için önde gelen global platform olmak, dünyayı herkes için daha küçük ve daha bağlantılı bir yer haline getirmek.',
      'about.features.title': 'Neden Bizi Seçmelisiniz?',
      'about.features.instant.title': 'Anında Teslimat',
      'about.features.instant.content': 'Satın alma sonrası QR kod ile eSIM\'inizi anında alın.',
      'about.features.global.title': 'Global Kapsama',
      'about.features.global.content': '190\'dan fazla ülke ve bölge için veri planları.',
      'about.features.affordable.title': 'Uygun Fiyatlar',
      'about.features.affordable.content': 'Roaming ücretlerinde %90\'a kadar tasarruf edin.',
      'about.features.support.title': '7/24 Destek',
      'about.features.support.content': 'Dedikli destek ekibimiz her zaman yardımınızda.',
      'about.features.secure.title': 'Güvenli Bağlantı',
      'about.features.secure.content': 'En son güvenlik protokolleri ile korunan bağlantı.',
      'about.features.fast.title': 'Hızlı İnternet',
      'about.features.fast.content': '4G/5G hızlarında kesintisiz internet deneyimi.',
      'about.cta.title': 'Dijital Bağlantının Geleceğine Katılın',
      'about.cta.content': 'Utkan eSIM\'i seçtiğiniz için teşekkür ederiz. İyi seyahatler!',
      'about.cta.whatsapp': 'WhatsApp ile İletişim',
      'about.cta.email': 'E-posta Gönder',

      // Contact sayfası
      'contact.hero.title': 'Bizimle İletişime Geçin',
      'contact.hero.description': 'eSIM\'lerimiz hakkında sorularınız, teknik destek ihtiyacınız veya sadece geri bildirim vermek istiyorsanız, sizden haber almaktan mutluluk duyarız.',
      'contact.info.title': 'İletişim Bilgilerimiz',
      'contact.whatsapp.title': 'WhatsApp',
      'contact.whatsapp.subtitle': '7/24 Hızlı Destek',
      'contact.email.title': 'E-posta',
      'contact.email.subtitle': 'Genel İletişim',
      'contact.support.title': 'Teknik Destek',
      'contact.support.subtitle': 'eSIM Sorunları',
      'contact.business.title': 'İş Ortaklığı',
      'contact.business.subtitle': 'Kurumsal İletişim',
      'contact.hours.title': 'Destek Saatleri',
      'contact.hours.subtitle': '7/24 Teknik Destek',
      'contact.hours.detail': 'Pazartesi - Pazar: 00:00 - 23:59',
      'contact.form.title': 'Mesaj Gönderin',
      'contact.form.name': 'Adınız Soyadınız',
      'contact.form.name.placeholder': 'Adınızı ve soyadınızı girin',
      'contact.form.email': 'E-posta Adresiniz',
      'contact.form.email.placeholder': 'ornek@email.com',
      'contact.form.subject': 'Konu',
      'contact.form.subject.placeholder': 'Konu seçin',
      'contact.form.subject.general': 'Genel Bilgi',
      'contact.form.subject.technical': 'Teknik Destek',
      'contact.form.subject.billing': 'Fatura Soruları',
      'contact.form.subject.partnership': 'İş Ortaklığı',
      'contact.form.subject.feedback': 'Geri Bildirim',
      'contact.form.message': 'Mesajınız',
      'contact.form.message.placeholder': 'Mesajınızı buraya yazın...',
      'contact.form.submit': 'Mesaj Gönder',
      'contact.faq.title': 'Sık Sorulan Sorular',
      'contact.faq.esim.title': 'eSIM nasıl çalışır?',
      'contact.faq.esim.content': 'eSIM, fiziksel SIM kartına ihtiyaç duymadan telefonunuzda çalışan dijital SIM kartıdır. QR kod ile anında aktifleştirilir.',
      'contact.faq.phones.title': 'Hangi telefonlar eSIM destekler?',
      'contact.faq.phones.content': 'iPhone XS ve üzeri, Samsung Galaxy S20 ve üzeri, Google Pixel 3 ve üzeri modeller eSIM destekler.',
      'contact.faq.validity.title': 'Veri paketim ne kadar süre geçerli?',
      'contact.faq.validity.content': 'Paketlerin geçerlilik süresi seçtiğiniz plana göre 1-30 gün arasında değişir.',
      'contact.faq.payment.title': 'Ödeme nasıl yapılır?',
      'contact.faq.payment.content': 'Kredi kartı, PayPal ve banka havalesi ile güvenli ödeme yapabilirsiniz.',

      // Privacy sayfası
      'privacy.hero.title': 'Gizlilik Politikası',
      'privacy.hero.description': 'Kişisel verilerinizin güvenliği bizim için çok önemlidir. Bu politika, verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar.',
      'privacy.overview.title': 'Genel Bakış',
      'privacy.overview.content': 'Bu Gizlilik Politikası, Hizmetimizi kullandığınızda bilgilerinizin toplanması, kullanılması ve ifşa edilmesi konusundaki politikalarımızı ve prosedürlerimizi açıklar. Ayrıca gizlilik haklarınızı ve yasanın sizi nasıl koruduğunu anlatır.',
      'privacy.data.title': 'Topladığımız Veriler',
      'privacy.data.personal.title': 'Kişisel Bilgiler',
      'privacy.data.personal.name': 'Ad ve soyad',
      'privacy.data.personal.email': 'E-posta adresi',
      'privacy.data.personal.phone': 'Telefon numarası',
      'privacy.data.personal.payment': 'Ödeme bilgileri',
      'privacy.data.usage.title': 'Kullanım Verileri',
      'privacy.data.usage.ip': 'IP adresi',
      'privacy.data.usage.browser': 'Tarayıcı türü',
      'privacy.data.usage.device': 'Cihaz bilgileri',
      'privacy.data.usage.stats': 'Kullanım istatistikleri',
      'privacy.security.title': 'Veri Güvenliği',
      'privacy.security.ssl.title': 'SSL Şifreleme',
      'privacy.security.ssl.content': 'Tüm veri transferleri 256-bit SSL şifreleme ile korunur.',
      'privacy.security.servers.title': 'Güvenli Sunucular',
      'privacy.security.servers.content': 'Verileriniz ISO 27001 sertifikalı güvenli sunucularda saklanır.',
      'privacy.security.access.title': 'Erişim Kontrolü',
      'privacy.security.access.content': 'Sadece yetkili personel verilerinize erişebilir.',
      'privacy.usage.title': 'Veri Kullanımı',
      'privacy.usage.intro': 'Topladığımız verileri aşağıdaki amaçlarla kullanırız:',
      'privacy.usage.service.title': 'Hizmet Sağlama',
      'privacy.usage.service.content': 'eSIM hizmetlerimizi size sunmak ve yönetmek',
      'privacy.usage.support.title': 'Müşteri Desteği',
      'privacy.usage.support.content': 'Teknik destek ve müşteri hizmetleri sağlamak',
      'privacy.usage.security.title': 'Güvenlik',
      'privacy.usage.security.content': 'Hesabınızı ve hizmetlerimizi korumak',
      'privacy.usage.improvement.title': 'İyileştirme',
      'privacy.usage.improvement.content': 'Hizmetlerimizi geliştirmek ve yeni özellikler eklemek',
      'privacy.sharing.title': 'Veri Paylaşımı',
      'privacy.sharing.intro': 'Kişisel verilerinizi üçüncü taraflarla paylaşmayız, ancak aşağıdaki durumlarda paylaşım gerekebilir:',
      'privacy.sharing.legal': 'Yasal zorunluluk durumunda',
      'privacy.sharing.providers': 'Hizmet sağlayıcılarımızla (ödeme işlemcileri gibi)',
      'privacy.sharing.threats': 'Güvenlik tehditlerini önlemek için',
      'privacy.sharing.consent': 'Açık rızanız olduğunda',
      'privacy.rights.title': 'Haklarınız',
      'privacy.rights.access.title': 'Erişim Hakkı',
      'privacy.rights.access.content': 'Hakkınızda sakladığımız verilere erişim talep edebilirsiniz.',
      'privacy.rights.correction.title': 'Düzeltme Hakkı',
      'privacy.rights.correction.content': 'Yanlış veya eksik verilerinizi düzeltebiliriz.',
      'privacy.rights.deletion.title': 'Silme Hakkı',
      'privacy.rights.deletion.content': 'Belirli koşullar altında verilerinizi silebiliriz.',
      'privacy.rights.objection.title': 'İtiraz Hakkı',
      'privacy.rights.objection.content': 'Veri işleme faaliyetlerimize itiraz edebilirsiniz.',
      'privacy.contact.title': 'İletişim',
      'privacy.contact.intro': 'Bu Gizlilik Politikası hakkında herhangi bir sorunuz varsa, aşağıdaki kanallardan bizimle iletişime geçebilirsiniz:',

      // Navigation
      'nav.about': 'Hakkımızda',
      'nav.contact': 'İletişim',
      'nav.privacy': 'Gizlilik',
      'nav.login': 'Giriş',
      'nav.account': 'Hesabım',
      'nav.logout': 'Çıkış yap',

      // Auth - marka paneli
      'auth.brand.eyebrow': 'KÜRESEL KAPSAMA',
      'auth.brand.title': '150+ ülkede, indiğin an internet.',
      'auth.brand.subtitle': 'Fiziksel SIM yok, roaming faturası yok. eSIM’ini saniyeler içinde etkinleştir.',

      // Auth - giriş
      'auth.login.eyebrow': 'HESABINA GİRİŞ',
      'auth.login.title': 'Tekrar hoş geldin',
      'auth.login.subtitle': 'eSIM’lerini yönet ve yenilerini keşfet.',

      // Auth - kayıt
      'auth.signup.eyebrow': 'YENİ HESAP',
      'auth.signup.title': 'Aramıza katıl',
      'auth.signup.subtitle': 'Birkaç adımda ilk eSIM’ine hazır ol.',

      // Auth - alanlar
      'auth.field.identifier': 'E-posta veya telefon',
      'auth.field.identifier.ph': 'ornek@email.com veya +90…',
      'auth.field.email': 'E-posta',
      'auth.field.email.ph': 'ornek@email.com',
      'auth.field.fullName': 'Ad soyad',
      'auth.field.fullName.ph': 'Adın ve soyadın',
      'auth.field.password': 'Şifre',
      'auth.field.password.ph': '••••••••',

      // Auth - aksiyonlar
      'auth.action.login': 'Giriş yap',
      'auth.action.loggingIn': 'Giriş yapılıyor…',
      'auth.action.signup': 'Hesap oluştur',
      'auth.action.signingUp': 'Hesap oluşturuluyor…',
      'auth.toSignup.q': 'Hesabın yok mu?',
      'auth.toSignup.link': 'Kayıt ol',
      'auth.toLogin.q': 'Zaten hesabın var mı?',
      'auth.toLogin.link': 'Giriş yap',
      'auth.password.show': 'Şifreyi göster',
      'auth.password.hide': 'Şifreyi gizle',

      // Auth - koşullar & hatalar
      'auth.terms.prefix': 'Devam ederek ',
      'auth.terms.link': 'Kullanım Koşulları ve Gizlilik Politikası',
      'auth.terms.suffix': '’nı kabul ediyorum.',
      'auth.error.required': 'Lütfen gerekli alanları doldur.',
      'auth.error.terms': 'Devam etmek için koşulları kabul etmelisin.',

      // E-posta doğrulama
      'verify.eyebrow': 'E-POSTA DOĞRULAMA',
      'verify.title': 'E-postanı doğrula',
      'verify.subtitle': '{{email}} adresine 6 haneli bir kod gönderdik. Doğrulamak için kodu gir.',
      'verify.code': 'Doğrulama kodu',
      'verify.code.ph': '••••••',
      'verify.action': 'Doğrula',
      'verify.verifying': 'Doğrulanıyor…',
      'verify.resend': 'Kodu tekrar gönder',
      'verify.resendIn': '{{seconds}} sn sonra tekrar gönder',
      'verify.resent': 'Yeni kod gönderildi.',
      'verify.skip': 'Şimdilik atla',

      // Şifremi unuttum
      'auth.forgot.link': 'Şifreni mi unuttun?',
      'forgot.eyebrow': 'ŞİFRE SIFIRLAMA',
      'forgot.email.title': 'Şifreni sıfırla',
      'forgot.email.subtitle':
        'Hesabının e-posta adresini gir; sana 6 haneli bir sıfırlama kodu gönderelim.',
      'forgot.email.action': 'Kod gönder',
      'forgot.email.sending': 'Gönderiliyor…',
      'forgot.reset.title': 'Yeni şifreni belirle',
      'forgot.reset.subtitle':
        '{{email}} adresine gönderdiğimiz 6 haneli kodu ve yeni şifreni gir.',
      'forgot.reset.action': 'Şifreyi güncelle',
      'forgot.reset.updating': 'Güncelleniyor…',
      'forgot.field.code': 'Sıfırlama kodu',
      'forgot.field.code.ph': '••••••',
      'forgot.field.newPassword': 'Yeni şifre',
      'forgot.field.newPassword.ph': 'En az 6 karakter',
      'forgot.resend': 'Kodu tekrar gönder',
      'forgot.resendIn': '{{seconds}} sn sonra tekrar gönder',
      'forgot.resent': 'Yeni kod gönderildi.',
      'forgot.backToLogin': 'Girişe dön',
      'forgot.changeEmail': 'E-postayı değiştir',
      'forgot.help.noMail':
        'Kod gelmediyse spam kutunu kontrol et veya e-posta adresini doğrula.',
      // Sunucu sonuç kodları → kullanıcı metni
      'reset.RESET_CODE_SENT': 'Kod gönderildi. Lütfen e-postanı kontrol et.',
      'reset.RATE_LIMITED':
        'Çok fazla deneme yaptın. Lütfen bir süre bekleyip tekrar dene.',
      'reset.MAIL_SEND_FAILED':
        'Bir şeyler ters gitti. Lütfen daha sonra tekrar dene.',
      'reset.RESET_CODE_VALID': 'Kod doğrulandı.',
      'reset.INVALID_RESET_CODE': 'Yanlış kod. Lütfen tekrar dene.',
      'reset.EXPIRED_RESET_CODE':
        'Kodun geçerlilik süresi doldu. Lütfen yeni kod iste.',
      'reset.WEAK_PASSWORD': 'Şifre en az 6 karakter olmalı.',
      'reset.PASSWORD_RESET_SUCCESS':
        'Şifren güncellendi. Yeni şifrenle giriş yapabilirsin.',
      'reset.generic': 'Bir şeyler ters gitti. Lütfen tekrar dene.',
      'login.resetSuccess':
        'Şifren güncellendi. Yeni şifrenle giriş yapabilirsin.',

      // Mağaza navigasyonu
      'store.nav.shop': 'Mağaza',

      // Ana sayfa (mağaza)
      'home.hero.title1': 'Birkaç dakikada bağlan,',
      'home.hero.title2': 'sınırların ötesinde kal.',
      'home.hero.subtitle': '190+ ülkede geçerli, güvenilir eSIM paketleri. Fiziksel SIM yok, roaming faturası yok.',
      'home.search.placeholder': 'Nereye seyahat ediyorsun?',
      'home.tabs.local': 'Yerel eSIM’ler',
      'home.tabs.regional': 'Bölgesel eSIM’ler',
      'home.tabs.lifetime': 'Ömürlük eSIM’ler',
      'home.empty': 'Aramanızla eşleşen sonuç bulunamadı.',
      'home.error.title': 'İçerik yüklenemedi',
      'home.error.retry': 'Tekrar dene',
      'home.from': 'başlangıç',
      'home.popular': 'Popüler destinasyonlar',
      'home.coverage': '190+ ülke · anında aktivasyon',
      'home.detail.soon': 'Bu seçimin paketleri çok yakında burada listelenecek.',
      'home.detail.back': 'Mağazaya dön',

      // eSIM detay / paketler
      'detail.plans': 'Paketler',
      'detail.count': '{{count}} paket',
      'detail.validity': '{{days}} gün',
      'detail.validityLifetime': 'Süresiz',
      'detail.buy': 'Satın al',
      'detail.empty': 'Bu seçim için şu an paket bulunmuyor.',
      'detail.checkoutSoon': 'Ödeme akışı çok yakında eklenecek.',
      'detail.loginToBuy': 'Satın almak için giriş yapmalısın.',
      'detail.basicFeatures': 'Temel Özellikler',
      'detail.dataAmount': 'Veri miktarı',
      'detail.validityLabel': 'Geçerlilik süresi',
      'detail.coverageArea': 'Kapsama alanı',
      'detail.activationNetworks': 'Aktivasyon ve Ağlar',
      'detail.activationMethod': 'Aktivasyon yöntemi',
      'detail.esimActivation': 'eSIM — QR kod ile anında',
      'detail.supportedNetworks': 'Desteklenen ağlar',
      'detail.description': 'Açıklama',
      'detail.price': 'Fiyat',

      // Giriş daveti modalı
      'authprompt.title': 'Devam etmek için giriş yap',
      'authprompt.message': 'eSIM satın almak için hesabına giriş yap ya da saniyeler içinde yeni bir hesap oluştur.',
      'authprompt.close': 'Kapat',

      // Footer
      'footer.tagline': 'Dünya çapında hızlı, güvenli ve uygun fiyatlı eSIM. İndiğin an internete bağlan.',
      'footer.explore': 'Keşfet',
      'footer.support': 'Destek',
      'footer.legal': 'Yasal',
      'footer.shop': 'Mağaza',
      'footer.help': 'Sıkça Sorulan Sorular',
      'footer.terms': 'Kullanım Koşulları',
      'footer.rights': '© {{year}} Utkan eSIM. Tüm hakları saklıdır.',
      'footer.apps': 'Uygulamayı indir',

      // WhatsApp destek butonu
      'whatsapp.label': 'WhatsApp’tan yaz',
      'whatsapp.message': 'Merhaba, bir eSIM destek talebim var.',

      // 404
      'notfound.eyebrow': 'SİNYAL YOK',
      'notfound.title': 'Bu sayfaya ulaşılamıyor',
      'notfound.message': 'Aradığın sayfa taşınmış ya da hiç var olmamış olabilir. Hadi seni kapsama alanına geri götürelim.',

      // Sipariş başarılı
      'order.congrats': 'Tebrikler!',
      'order.message': 'eSIM’in hazır. Aşağıdaki QR kod ile birkaç adımda kurabilirsin.',
      'order.details': 'Sipariş özeti',
      'order.activation': 'Aktivasyon',
      'order.activationDesc': 'eSIM’ini kurmak için cihazının kamerasıyla QR kodu tarat ya da kurulum kodunu elle gir.',
      'order.qrTitle': 'eSIM QR kodu',
      'order.manualLabel': 'Kurulum kodu',
      'order.copy': 'Kopyala',
      'order.copied': 'Kopyalandı',
      'order.howTo': 'Nasıl etkinleştirilir?',
      'order.step1': 'Cihazında Ayarlar > Hücresel / Mobil Veri > eSIM Ekle’ye git.',
      'order.step2': '“QR kodu kullan”ı seç ve yukarıdaki QR kodu tarat (veya kurulum kodunu elle gir).',
      'order.step3': 'Kurulum tamamlanınca eSIM planını etkinleştir.',
      'order.step4': 'Veri dolaşımının açık olduğundan emin ol — artık bağlısın!',
      'order.cta': 'Ana sayfaya dön',

      // Ödeme (checkout)
      'checkout.title': 'Ödeme',
      'checkout.summary': 'Sipariş özeti',
      'checkout.total': 'Toplam',
      'checkout.eurNote': 'Tutar PayPal’da euro (€) olarak tahsil edilir.',
      'checkout.processing': 'Ödemen doğrulanıyor…',
      'checkout.error': 'Ödeme tamamlanamadı. Lütfen tekrar dene.',
      'checkout.cancelled': 'Ödeme iptal edildi.',

      // Hesabım
      'account.title': 'Hesabım',
      'account.tab.profile': 'Profil',
      'account.tab.esims': 'eSIM’lerim',
      'account.tab.security': 'Güvenlik',
      'account.profile.title': 'Profil bilgileri',
      'account.field.phone': 'Telefon',
      'account.field.phone.ph': '+90…',
      'account.memberSince': 'Üyelik tarihi',
      'account.save': 'Kaydet',
      'account.saving': 'Kaydediliyor…',
      'account.saved': 'Bilgilerin güncellendi.',
      'account.esims.title': 'eSIM’lerim',
      'account.esims.empty': 'Henüz bir eSIM’in yok.',
      'account.esims.emptyCta': 'Mağazaya göz at',
      'account.esims.data': 'Veri',
      'account.esims.expires': 'Bitiş tarihi',
      'account.esims.viewQr': 'QR kodu göster',
      'account.esims.hideQr': 'QR kodu gizle',
      'account.esims.active': 'Aktif',
      'account.esims.passive': 'Pasif',
      'account.esims.noActive': 'Aktif eSIM’in yok.',
      'account.esims.noPassive': 'Pasif eSIM’in yok.',
      'account.esims.readyHint': 'Kullanıma hazır — süre ilk kullanımda başlar.',
      'account.esims.unavailableHint': 'Durum şu an yüklenemedi. Daha sonra tekrar deneyin.',
      'esimStatus.active': 'Aktif',
      'esimStatus.readyToUse': 'Kullanıma hazır',
      'esimStatus.inactive': 'Pasif',
      'esimStatus.unavailable': 'Durum yüklenemedi',
      'account.security.title': 'Şifre değiştir',
      'account.field.oldPassword': 'Mevcut şifre',
      'account.field.newPassword': 'Yeni şifre',
      'account.field.confirmPassword': 'Yeni şifre (tekrar)',
      'account.changePassword': 'Şifreyi güncelle',
      'account.passwordChanged': 'Şifren güncellendi.',
      'account.error.passwordMismatch': 'Yeni şifreler eşleşmiyor.',
      'account.danger.title': 'Hesap işlemleri',
      'account.delete': 'Hesabı sil',
      'account.delete.confirm': 'Hesabını kalıcı olarak silmek üzeresin. Bu işlem geri alınamaz.',
      'account.delete.confirmBtn': 'Evet, sil',
      'account.cancel': 'Vazgeç',

      // Satın alınmış eSIM detayı
      'esimDetail.back': 'Geri',
      'esimDetail.dataUsage': 'Veri kullanımı',
      'esimDetail.left': 'kalan',
      'esimDetail.leftData': 'Kalan veri',
      'esimDetail.usedData': 'Kullanılan',
      'esimDetail.totalData': 'Toplam veri',
      'esimDetail.qrDesc': 'Bu QR kodu cihazının kamerasıyla taratarak eSIM’ini kur.',
      'esimDetail.validity': 'Geçerlilik',
      'esimDetail.daysLeft': '{{days}} gün kaldı',
      'esimDetail.expired': 'Süresi doldu',
      'esimDetail.notYetActive': 'Henüz etkin değil',
      'esimDetail.leftDate': 'Kalan süre',
      'esimDetail.activationDate': 'Aktivasyon tarihi',
      'esimDetail.endDate': 'Bitiş tarihi',
      'esimDetail.technical': 'Teknik bilgiler',
      'esimDetail.activationCode': 'Aktivasyon kodu (Android)',
      'esimDetail.smdp': 'SM-DP+ adresi (iOS)',
      'esimDetail.matchingId': 'Eşleştirme kimliği (iOS)',
      'esimDetail.support': 'Teknik destek',
      'esimDetail.supportDesc': 'Bir sorun mu var? Sana yardımcı olalım.',
      'esimDetail.email': 'E-posta gönder',

      // eSIM rehberi
      'guide.eyebrow': 'eSIM REHBERİ',
      'guide.title': 'eSIM nedir, nasıl kurulur?',
      'guide.intro.title': 'eSIM nedir?',
      'guide.intro.body': 'eSIM, fiziksel SIM kartına gerek kalmadan cihazına gömülü çalışan dijital bir SIM’dir. Bir QR kod taratarak saniyeler içinde hattını kurar; 190+ ülkede kart değiştirmeden, roaming faturası olmadan internete bağlanırsın.',
      'guide.steps.title': 'Nasıl etkinleştirilir?',
      'guide.devices.title': 'Desteklenen cihazlar',
      'guide.devices.desc': 'eSIM’in çalışması için cihazının eSIM destekli olması gerekir. Markana göz at.',
      'guide.faq.title': 'Sık sorulan sorular',
      'nav.guide': 'eSIM Rehberi',
      'currency.label': 'Para birimi',

      // Statik sayfalar (About/Contact/Privacy) — yükleme & hata durumları
      'staticPage.loading': 'Sayfa yükleniyor...',
      'staticPage.errorTitle': 'Hata Oluştu',
      'staticPage.retry': 'Tekrar Dene',
      'staticPage.loadFailed': 'Sayfa içeriği yüklenemedi. Lütfen daha sonra tekrar deneyin.',

      // Genel
      'last.updated': 'Son güncelleme: 8 Temmuz 2024',

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      'home.tabs.unlimited': 'Sınırsız eSIM’ler',
      'detail.unlimited': 'Sınırsız',
      'detail.unlimitedNote': 'Bu pakette veri limiti yoktur — geçerlilik süresi boyunca sınırsız internet kullanırsın.',
      'detail.notPriced': 'Bu paket şu an web’den satın alınamıyor.',
      'checkout.priceUpdated': 'Bu paketin fiyatı güncellendi. Lütfen mağazaya dönüp paketi yeniden seç.',
      'order.pending.title': 'eSIM’in hazırlanıyor',
      'order.pending.message': 'Ödemen alındı. Sınırsız paketlerde hattın açılması birkaç dakika sürebilir.',
      'order.pending.waiting': 'Sipariş durumun kontrol ediliyor…',
      'order.pending.ready': 'eSIM’in hazır!',
      'order.pending.timeout': 'Hazırlanma beklenenden uzun sürüyor. Ödemen güvende — eSIM’in hazır olduğunda “eSIM’lerim” bölümünde görünecek.',
      'order.pending.cta': 'eSIM’lerime git',
      'account.esims.unlimited': 'Sınırsız',
      'account.esims.unlimitedHint': 'Sınırsız veri — bu pakette veri limiti yoktur.',
      'esimDetail.unlimitedData': 'Bu pakette veri limiti yoktur; kalan süreyi aşağıda görebilirsin.',


      // Hesap silme sayfası (/hesap-sil · /account-deletion) — Google Play “Data deletion” şartı
      'del.eyebrow': 'Hesap silme',
      'del.title': 'Hesabımı sil',
      'del.intro': 'Utkan eSIM hesabını ve kişisel verilerini buradan kalıcı olarak silebilirsin. Uygulamanın kurulu olması gerekmez — silmek istediğin hesapla giriş yapman yeterli.',
      'del.deleted.title': 'Silinen veriler',
      'del.deleted.identity': 'Adın, soyadın, e-posta adresin ve telefon numaran',
      'del.deleted.credentials': 'Parolan ve oturum bilgilerin',
      'del.deleted.codes': 'E-posta doğrulama ve şifre sıfırlama kodların',
      'del.deleted.esim': 'eSIM hat numaran (MSISDN), QR/aktivasyon kodun ve kullanım verilerin',
      'del.kept.title': 'Saklanan veriler ve nedeni',
      'del.kept.orders': 'Satın alma kayıtları (sipariş numarası, tarih, tutar, ödeme durumu) mali mevzuat gereği saklanır. Bu kayıtlarda adın, e-postan veya ödeme bilgilerin yer almaz; yalnızca seninle ilişkilendirilemeyen bir numara bulunur.',
      'del.kept.period': 'Saklama süresi: 5 yıl (Vergi Usul Kanunu m. 253).',
      'del.warn.title': 'Silmeden önce bilmen gerekenler',
      'del.warn.irreversible': 'Bu işlem geri alınamaz.',
      'del.warn.esim': 'Aktif eSIM’lerin cihazında çalışmaya devam eder, ancak QR koduna ve kalan kullanımına bir daha erişemezsin. Silmeden önce QR kodunu kaydet.',
      'del.warn.rejoin': 'Aynı e-posta ile yeniden kayıt olabilirsin, ancak eski eSIM’lerin yeni hesapta görünmez.',
      'del.support': 'Giriş yapamıyorsan silme talebini e-posta ile de iletebilirsin:',
      'del.login.title': 'Önce giriş yap',
      'del.login.subtitle': 'Hesabın sana ait olduğunu doğrulamak için e-posta ve şifreni gir.',
      'del.login.action': 'Giriş yap',
      'del.login.loading': 'Giriş yapılıyor...',
      'del.forgot': 'Şifremi unuttum',
      'del.confirm.title': 'Emin misin?',
      'del.confirm.subtitle': '{{email}} hesabı ve kişisel verilerin kalıcı olarak silinecek.',
      'del.confirm.field': 'Onaylamak için e-posta adresini tekrar yaz',
      'del.confirm.action': 'Hesabımı kalıcı olarak sil',
      'del.confirm.deleting': 'Siliniyor...',
      'del.confirm.cancel': 'Vazgeç',
      'del.done.title': 'Hesabın silindi',
      'del.done.body': 'Kişisel verilerin kalıcı olarak silindi.',
      'del.done.retained': 'Kişisel verilerin kalıcı olarak silindi. {{n}} satın alma kaydın mali mevzuat gereği saklandı; bu kayıtlar seninle ilişkilendirilemez.',
      'del.done.home': 'Mağazaya dön',
      'del.error.required': 'Lütfen e-posta ve şifreni gir.',
      'del.error.credentials': 'E-posta veya şifre hatalı.',
      'del.error.suspended': 'Hesabın askıya alınmış. Lütfen destek ile iletişime geç.',
      'del.error.session': 'Oturumunun süresi doldu. Lütfen tekrar giriş yap.',
      'del.error.network': 'Bağlantı kurulamadı. İnternet bağlantını kontrol edip tekrar dene.',
      'del.error.generic': 'Bir sorun oluştu. Lütfen tekrar dene.',
      'footer.deleteAccount': 'Hesabımı sil',


      // Ses paketleri (veri + sınırsız konuşma & SMS) — docs/ses-paketleri.md
      'home.tabs.voice': 'Konuşmalı eSIM’ler',
      'detail.voice': 'Konuşma + SMS',
      'detail.voiceNote': 'Bu paket veriye ek olarak sınırsız konuşma ve SMS içerir; aynı eSIM ile hem internete bağlanır hem arama yaparsın.',
      'detail.calls': 'Konuşma',
      'detail.sms': 'SMS',
      'plan.unlimitedCalls': 'Sınırsız konuşma',
      'plan.unlimitedSms': 'Sınırsız SMS',
      'plan.minutes': '{{n}} dk konuşma',
      'plan.sms': '{{n}} SMS',
      'loading': 'Yükleniyor...',
    }
  },
  en: {
    translation: {
      // Main page
      'hero.title': 'Utkan eSIM',
      'hero.subtitle': 'The Future of Digital Connectivity',
      'hero.description': 'We are removing boundaries with the new generation digital connectivity experience.',
      'hero.description2': 'Fast, secure and affordable eSIM solutions worldwide.',

      // Features
      'features.countries': '150+ Countries',
      'features.activation': 'Instant Activation',
      'features.support': '24/7 Support',

      // Countdown
      'countdown.title': 'Our Website is Coming Soon!',
      'countdown.days': 'Days',
      'countdown.hours': 'Hours',
      'countdown.minutes': 'Minutes',
      'countdown.seconds': 'Seconds',
      'countdown.launch': 'Our Website is Live!',
      'countdown.loading': 'Loading...',

      // Apps
      'apps.title': 'Our Mobile Applications',
      'apps.ios.label': 'Download on the',
      'apps.ios.name': 'App Store',
      'apps.android.label': 'GET IT ON',
      'apps.android.name': 'Google Play',

      // Contact
      'contact.title': 'Contact Us Until Launch',
      'contact.whatsapp': 'WhatsApp: +43 676 555 1 333',
      'contact.email': 'Email: info@utkanesim.com',

      // About page
      'about.hero.title': 'About Utkan eSIM',
      'about.hero.description': 'Your trusted partner for staying connected wherever you go. We believe that global travel should be seamless and affordable, without the hassle of physical SIM cards and expensive roaming charges.',
      'about.story.title': 'Our Story',
      'about.story.content': 'Founded in 2024 by a team of passionate travelers and tech enthusiasts, our goal is to revolutionize the way people connect to the internet abroad. We provide high-quality, reliable eSIM data plans for over 190 countries and regions, ensuring you have fast internet access from the moment you land.',
      'about.mission.title': 'Our Mission',
      'about.mission.content': 'To provide travelers with simple, affordable, and instant connectivity worldwide, empowering them to explore, work, and stay in touch without boundaries.',
      'about.vision.title': 'Our Vision',
      'about.vision.content': 'To be the leading global platform for digital connectivity solutions, making the world a smaller, more connected place for everyone.',
      'about.features.title': 'Why Choose Us?',
      'about.features.instant.title': 'Instant Delivery',
      'about.features.instant.content': 'Receive your eSIM via QR code immediately after purchase.',
      'about.features.global.title': 'Global Coverage',
      'about.features.global.content': 'Data plans for over 190 countries and regions.',
      'about.features.affordable.title': 'Affordable Rates',
      'about.features.affordable.content': 'Save up to 90% on roaming charges.',
      'about.features.support.title': '24/7 Support',
      'about.features.support.content': 'Our dedicated support team is always here to help.',
      'about.features.secure.title': 'Secure Connection',
      'about.features.secure.content': 'Connection protected with the latest security protocols.',
      'about.features.fast.title': 'Fast Internet',
      'about.features.fast.content': 'Seamless internet experience at 4G/5G speeds.',
      'about.cta.title': 'Join the Future of Digital Connectivity',
      'about.cta.content': 'Thank you for choosing Utkan eSIM. Happy travels!',
      'about.cta.whatsapp': 'Contact via WhatsApp',
      'about.cta.email': 'Send Email',

      // Contact page
      'contact.hero.title': 'Contact Us',
      'contact.hero.description': 'We\'re here to help! Whether you have a question about our eSIMs, need technical support, or just want to give us feedback, we\'d love to hear from you.',
      'contact.info.title': 'Contact Information',
      'contact.whatsapp.title': 'WhatsApp',
      'contact.whatsapp.subtitle': '24/7 Quick Support',
      'contact.email.title': 'Email',
      'contact.email.subtitle': 'General Contact',
      'contact.support.title': 'Technical Support',
      'contact.support.subtitle': 'eSIM Issues',
      'contact.business.title': 'Partnership',
      'contact.business.subtitle': 'Corporate Contact',
      'contact.hours.title': 'Support Hours',
      'contact.hours.subtitle': '24/7 Technical Support',
      'contact.hours.detail': 'Monday - Sunday: 00:00 - 23:59',
      'contact.form.title': 'Send Us a Message',
      'contact.form.name': 'Your Name',
      'contact.form.name.placeholder': 'Enter your name and surname',
      'contact.form.email': 'Your Email',
      'contact.form.email.placeholder': 'example@email.com',
      'contact.form.subject': 'Subject',
      'contact.form.subject.placeholder': 'Select subject',
      'contact.form.subject.general': 'General Information',
      'contact.form.subject.technical': 'Technical Support',
      'contact.form.subject.billing': 'Billing Questions',
      'contact.form.subject.partnership': 'Partnership',
      'contact.form.subject.feedback': 'Feedback',
      'contact.form.message': 'Your Message',
      'contact.form.message.placeholder': 'Write your message here...',
      'contact.form.submit': 'Send Message',
      'contact.faq.title': 'Frequently Asked Questions',
      'contact.faq.esim.title': 'How does eSIM work?',
      'contact.faq.esim.content': 'eSIM is a digital SIM card that works in your phone without needing a physical SIM card. It is activated instantly via QR code.',
      'contact.faq.phones.title': 'Which phones support eSIM?',
      'contact.faq.phones.content': 'iPhone XS and above, Samsung Galaxy S20 and above, Google Pixel 3 and above models support eSIM.',
      'contact.faq.validity.title': 'How long is my data package valid?',
      'contact.faq.validity.content': 'Package validity period varies between 1-30 days depending on the plan you choose.',
      'contact.faq.payment.title': 'How can I pay?',
      'contact.faq.payment.content': 'You can make secure payments with credit card, PayPal and bank transfer.',

      // Privacy page
      'privacy.hero.title': 'Privacy Policy',
      'privacy.hero.description': 'The security of your personal data is very important to us. This policy explains how your data is collected, used and protected.',
      'privacy.overview.title': 'Overview',
      'privacy.overview.content': 'This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.',
      'privacy.data.title': 'Data We Collect',
      'privacy.data.personal.title': 'Personal Information',
      'privacy.data.personal.name': 'Name and surname',
      'privacy.data.personal.email': 'Email address',
      'privacy.data.personal.phone': 'Phone number',
      'privacy.data.personal.payment': 'Payment information',
      'privacy.data.usage.title': 'Usage Data',
      'privacy.data.usage.ip': 'IP address',
      'privacy.data.usage.browser': 'Browser type',
      'privacy.data.usage.device': 'Device information',
      'privacy.data.usage.stats': 'Usage statistics',
      'privacy.security.title': 'Data Security',
      'privacy.security.ssl.title': 'SSL Encryption',
      'privacy.security.ssl.content': 'All data transfers are protected with 256-bit SSL encryption.',
      'privacy.security.servers.title': 'Secure Servers',
      'privacy.security.servers.content': 'Your data is stored on ISO 27001 certified secure servers.',
      'privacy.security.access.title': 'Access Control',
      'privacy.security.access.content': 'Only authorized personnel can access your data.',
      'privacy.usage.title': 'Data Usage',
      'privacy.usage.intro': 'We use the data we collect for the following purposes:',
      'privacy.usage.service.title': 'Service Provision',
      'privacy.usage.service.content': 'To provide and manage our eSIM services to you',
      'privacy.usage.support.title': 'Customer Support',
      'privacy.usage.support.content': 'To provide technical support and customer service',
      'privacy.usage.security.title': 'Security',
      'privacy.usage.security.content': 'To protect your account and our services',
      'privacy.usage.improvement.title': 'Improvement',
      'privacy.usage.improvement.content': 'To improve our services and add new features',
      'privacy.sharing.title': 'Data Sharing',
      'privacy.sharing.intro': 'We do not share your personal data with third parties, but sharing may be required in the following cases:',
      'privacy.sharing.legal': 'In case of legal obligation',
      'privacy.sharing.providers': 'With our service providers (such as payment processors)',
      'privacy.sharing.threats': 'To prevent security threats',
      'privacy.sharing.consent': 'When you give explicit consent',
      'privacy.rights.title': 'Your Rights',
      'privacy.rights.access.title': 'Right of Access',
      'privacy.rights.access.content': 'You can request access to the data we store about you.',
      'privacy.rights.correction.title': 'Right of Correction',
      'privacy.rights.correction.content': 'We can correct your incorrect or incomplete data.',
      'privacy.rights.deletion.title': 'Right of Deletion',
      'privacy.rights.deletion.content': 'We can delete your data under certain conditions.',
      'privacy.rights.objection.title': 'Right of Objection',
      'privacy.rights.objection.content': 'You can object to our data processing activities.',
      'privacy.contact.title': 'Contact',
      'privacy.contact.intro': 'If you have any questions about this Privacy Policy, you can contact us through the following channels:',

      // Navigation
      'nav.about': 'About',
      'nav.contact': 'Contact',
      'nav.privacy': 'Privacy',
      'nav.login': 'Sign in',
      'nav.account': 'Account',
      'nav.logout': 'Log out',

      // Auth - brand panel
      'auth.brand.eyebrow': 'GLOBAL COVERAGE',
      'auth.brand.title': 'Online the moment you land, in 150+ countries.',
      'auth.brand.subtitle': 'No physical SIM, no roaming bills. Activate your eSIM in seconds.',

      // Auth - login
      'auth.login.eyebrow': 'SIGN IN',
      'auth.login.title': 'Welcome back',
      'auth.login.subtitle': 'Manage your eSIMs and discover new ones.',

      // Auth - signup
      'auth.signup.eyebrow': 'NEW ACCOUNT',
      'auth.signup.title': 'Create your account',
      'auth.signup.subtitle': 'A few steps to your first eSIM.',

      // Auth - fields
      'auth.field.identifier': 'Email or phone',
      'auth.field.identifier.ph': 'you@email.com or +1…',
      'auth.field.email': 'Email',
      'auth.field.email.ph': 'you@email.com',
      'auth.field.fullName': 'Full name',
      'auth.field.fullName.ph': 'Your full name',
      'auth.field.password': 'Password',
      'auth.field.password.ph': '••••••••',

      // Auth - actions
      'auth.action.login': 'Sign in',
      'auth.action.loggingIn': 'Signing in…',
      'auth.action.signup': 'Create account',
      'auth.action.signingUp': 'Creating account…',
      'auth.toSignup.q': "Don't have an account?",
      'auth.toSignup.link': 'Sign up',
      'auth.toLogin.q': 'Already have an account?',
      'auth.toLogin.link': 'Sign in',
      'auth.password.show': 'Show password',
      'auth.password.hide': 'Hide password',

      // Auth - terms & errors
      'auth.terms.prefix': 'By continuing, I agree to the ',
      'auth.terms.link': 'Terms of Use and Privacy Policy',
      'auth.terms.suffix': '.',
      'auth.error.required': 'Please fill in the required fields.',
      'auth.error.terms': 'Please accept the terms to continue.',

      // Email verification
      'verify.eyebrow': 'EMAIL VERIFICATION',
      'verify.title': 'Verify your email',
      'verify.subtitle': 'We sent a 6-digit code to {{email}}. Enter it to verify.',
      'verify.code': 'Verification code',
      'verify.code.ph': '••••••',
      'verify.action': 'Verify',
      'verify.verifying': 'Verifying…',
      'verify.resend': 'Resend code',
      'verify.resendIn': 'Resend in {{seconds}}s',
      'verify.resent': 'A new code was sent.',
      'verify.skip': 'Skip for now',

      // Forgot password
      'auth.forgot.link': 'Forgot your password?',
      'forgot.eyebrow': 'PASSWORD RESET',
      'forgot.email.title': 'Reset your password',
      'forgot.email.subtitle':
        "Enter your account email and we'll send you a 6-digit reset code.",
      'forgot.email.action': 'Send code',
      'forgot.email.sending': 'Sending…',
      'forgot.reset.title': 'Set a new password',
      'forgot.reset.subtitle':
        'Enter the 6-digit code we sent to {{email}} and your new password.',
      'forgot.reset.action': 'Update password',
      'forgot.reset.updating': 'Updating…',
      'forgot.field.code': 'Reset code',
      'forgot.field.code.ph': '••••••',
      'forgot.field.newPassword': 'New password',
      'forgot.field.newPassword.ph': 'At least 6 characters',
      'forgot.resend': 'Resend code',
      'forgot.resendIn': 'Resend in {{seconds}}s',
      'forgot.resent': 'A new code was sent.',
      'forgot.backToLogin': 'Back to sign in',
      'forgot.changeEmail': 'Change email',
      'forgot.help.noMail':
        "If the code didn't arrive, check your spam folder or confirm your email address.",
      // Server result codes → user text
      'reset.RESET_CODE_SENT': 'Code sent. Please check your email.',
      'reset.RATE_LIMITED':
        'Too many requests. Please wait a while and try again.',
      'reset.MAIL_SEND_FAILED': 'Something went wrong. Please try again later.',
      'reset.RESET_CODE_VALID': 'Code verified.',
      'reset.INVALID_RESET_CODE': 'Invalid code. Please try again.',
      'reset.EXPIRED_RESET_CODE':
        'The code has expired. Please request a new code.',
      'reset.WEAK_PASSWORD': 'Password must be at least 6 characters long.',
      'reset.PASSWORD_RESET_SUCCESS':
        'Your password has been updated. Please sign in with your new password.',
      'reset.generic': 'Something went wrong. Please try again.',
      'login.resetSuccess':
        'Your password has been updated. Please sign in with your new password.',

      // Store navigation
      'store.nav.shop': 'Store',

      // Home (store)
      'home.hero.title1': 'Connect in minutes,',
      'home.hero.title2': 'stay online across borders.',
      'home.hero.subtitle': 'Reliable eSIM plans valid in 190+ countries. No physical SIM, no roaming bills.',
      'home.search.placeholder': 'Where are you traveling?',
      'home.tabs.local': 'Local eSIMs',
      'home.tabs.regional': 'Regional eSIMs',
      'home.tabs.lifetime': 'Lifetime eSIMs',
      'home.empty': 'No results match your search.',
      'home.error.title': 'Could not load content',
      'home.error.retry': 'Try again',
      'home.from': 'from',
      'home.popular': 'Popular destinations',
      'home.coverage': '190+ countries · instant activation',
      'home.detail.soon': 'Plans for this selection will be listed here very soon.',
      'home.detail.back': 'Back to store',

      // eSIM detail / plans
      'detail.plans': 'Plans',
      'detail.count': '{{count}} plans',
      'detail.validity': '{{days}} days',
      'detail.validityLifetime': 'No expiry',
      'detail.buy': 'Buy',
      'detail.empty': 'No plans available for this selection right now.',
      'detail.checkoutSoon': 'Checkout is coming very soon.',
      'detail.loginToBuy': 'Please sign in to buy.',
      'detail.basicFeatures': 'Basic features',
      'detail.dataAmount': 'Data amount',
      'detail.validityLabel': 'Validity',
      'detail.coverageArea': 'Coverage',
      'detail.activationNetworks': 'Activation & networks',
      'detail.activationMethod': 'Activation method',
      'detail.esimActivation': 'eSIM — instant via QR code',
      'detail.supportedNetworks': 'Supported networks',
      'detail.description': 'Description',
      'detail.price': 'Price',

      // Auth prompt modal
      'authprompt.title': 'Sign in to continue',
      'authprompt.message': 'Sign in to your account to buy an eSIM, or create one in seconds.',
      'authprompt.close': 'Close',

      // Footer
      'footer.tagline': 'Fast, secure and affordable eSIM worldwide. Get online the moment you land.',
      'footer.explore': 'Explore',
      'footer.support': 'Support',
      'footer.legal': 'Legal',
      'footer.shop': 'Store',
      'footer.help': 'Frequently Asked Questions',
      'footer.terms': 'Terms of Use',
      'footer.rights': '© {{year}} Utkan eSIM. All rights reserved.',
      'footer.apps': 'Get the app',

      // WhatsApp support button
      'whatsapp.label': 'Chat on WhatsApp',
      'whatsapp.message': 'Hello, I have an eSIM support request.',

      // 404
      'notfound.eyebrow': 'NO SIGNAL',
      'notfound.title': 'This page is out of reach',
      'notfound.message': 'The page you’re looking for moved or never existed. Let’s get you back into coverage.',

      // Order success
      'order.congrats': 'Congratulations!',
      'order.message': 'Your eSIM is ready. Set it up in a few steps with the QR code below.',
      'order.details': 'Order summary',
      'order.activation': 'Activation',
      'order.activationDesc': 'To set up your eSIM, scan the QR code with your device camera or enter the activation code manually.',
      'order.qrTitle': 'eSIM QR code',
      'order.manualLabel': 'Activation code',
      'order.copy': 'Copy',
      'order.copied': 'Copied',
      'order.howTo': 'How to activate',
      'order.step1': 'On your device, go to Settings > Cellular / Mobile Data > Add eSIM.',
      'order.step2': 'Choose “Use QR code” and scan the QR above (or enter the activation code manually).',
      'order.step3': 'Once setup finishes, enable the eSIM plan.',
      'order.step4': 'Make sure data roaming is on — you’re connected!',
      'order.cta': 'Back to home',

      // Checkout
      'checkout.title': 'Checkout',
      'checkout.summary': 'Order summary',
      'checkout.total': 'Total',
      'checkout.eurNote': 'You’ll be charged in euro (€) via PayPal.',
      'checkout.processing': 'Verifying your payment…',
      'checkout.error': 'Payment could not be completed. Please try again.',
      'checkout.cancelled': 'Payment cancelled.',

      // Account
      'account.title': 'My account',
      'account.tab.profile': 'Profile',
      'account.tab.esims': 'My eSIMs',
      'account.tab.security': 'Security',
      'account.profile.title': 'Profile information',
      'account.field.phone': 'Phone',
      'account.field.phone.ph': '+1…',
      'account.memberSince': 'Member since',
      'account.save': 'Save',
      'account.saving': 'Saving…',
      'account.saved': 'Your details were updated.',
      'account.esims.title': 'My eSIMs',
      'account.esims.empty': 'You don’t have any eSIMs yet.',
      'account.esims.emptyCta': 'Browse the store',
      'account.esims.data': 'Data',
      'account.esims.expires': 'Expires',
      'account.esims.viewQr': 'Show QR code',
      'account.esims.hideQr': 'Hide QR code',
      'account.esims.active': 'Active',
      'account.esims.passive': 'Inactive',
      'account.esims.noActive': 'You have no active eSIMs.',
      'account.esims.noPassive': 'You have no inactive eSIMs.',
      'account.esims.readyHint': 'Ready to use — validity starts on first use.',
      'account.esims.unavailableHint': 'Status unavailable right now. Please try again later.',
      'esimStatus.active': 'Active',
      'esimStatus.readyToUse': 'Ready to use',
      'esimStatus.inactive': 'Inactive',
      'esimStatus.unavailable': 'Status unavailable',
      'account.security.title': 'Change password',
      'account.field.oldPassword': 'Current password',
      'account.field.newPassword': 'New password',
      'account.field.confirmPassword': 'New password (again)',
      'account.changePassword': 'Update password',
      'account.passwordChanged': 'Your password was updated.',
      'account.error.passwordMismatch': 'New passwords don’t match.',
      'account.danger.title': 'Account actions',
      'account.delete': 'Delete account',
      'account.delete.confirm': 'You’re about to permanently delete your account. This cannot be undone.',
      'account.delete.confirmBtn': 'Yes, delete',
      'account.cancel': 'Cancel',

      // Purchased eSIM detail
      'esimDetail.back': 'Back',
      'esimDetail.dataUsage': 'Data usage',
      'esimDetail.left': 'left',
      'esimDetail.leftData': 'Remaining data',
      'esimDetail.usedData': 'Used',
      'esimDetail.totalData': 'Total data',
      'esimDetail.qrDesc': 'Scan this QR code with your device camera to set up your eSIM.',
      'esimDetail.validity': 'Validity',
      'esimDetail.daysLeft': '{{days}} days left',
      'esimDetail.expired': 'Expired',
      'esimDetail.notYetActive': 'Not active yet',
      'esimDetail.leftDate': 'Time left',
      'esimDetail.activationDate': 'Activation date',
      'esimDetail.endDate': 'End date',
      'esimDetail.technical': 'Technical details',
      'esimDetail.activationCode': 'Activation code (Android)',
      'esimDetail.smdp': 'SM-DP+ address (iOS)',
      'esimDetail.matchingId': 'Matching ID (iOS)',
      'esimDetail.support': 'Technical support',
      'esimDetail.supportDesc': 'Something wrong? We’re here to help.',
      'esimDetail.email': 'Send email',

      // eSIM guide
      'guide.eyebrow': 'eSIM GUIDE',
      'guide.title': 'What is an eSIM and how to set it up?',
      'guide.intro.title': 'What is an eSIM?',
      'guide.intro.body': 'An eSIM is a digital SIM embedded in your device — no physical card needed. Scan a QR code and your line is set up in seconds, so you can get online in 190+ countries with no card swaps and no roaming bills.',
      'guide.steps.title': 'How to activate',
      'guide.devices.title': 'Supported devices',
      'guide.devices.desc': 'Your device must support eSIM for it to work. Find your brand below.',
      'guide.faq.title': 'Frequently asked questions',
      'nav.guide': 'eSIM Guide',
      'currency.label': 'Currency',

      // Static pages (About/Contact/Privacy) — loading & error states
      'staticPage.loading': 'Loading page...',
      'staticPage.errorTitle': 'An Error Occurred',
      'staticPage.retry': 'Try Again',
      'staticPage.loadFailed': 'Page content could not be loaded. Please try again later.',

      // General
      'last.updated': 'Last updated: July 8, 2024',

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      'home.tabs.unlimited': 'Unlimited eSIMs',
      'detail.unlimited': 'Unlimited',
      'detail.unlimitedNote': 'This bundle has no data cap — enjoy unlimited internet for the whole validity period.',
      'detail.notPriced': 'This bundle is not available for purchase on the web right now.',
      'checkout.priceUpdated': 'The price of this bundle has changed. Please go back to the store and select it again.',
      'order.pending.title': 'Your eSIM is being prepared',
      'order.pending.message': 'Your payment went through. Unlimited bundles can take a few minutes to activate.',
      'order.pending.waiting': 'Checking your order status…',
      'order.pending.ready': 'Your eSIM is ready!',
      'order.pending.timeout': 'This is taking longer than expected. Your payment is safe — your eSIM will appear under “My eSIMs” as soon as it is ready.',
      'order.pending.cta': 'Go to My eSIMs',
      'account.esims.unlimited': 'Unlimited',
      'account.esims.unlimitedHint': 'Unlimited data — this bundle has no data cap.',
      'esimDetail.unlimitedData': 'This bundle has no data cap; see the remaining time below.',


      // Account deletion page (/hesap-sil · /account-deletion) — Google Play “Data deletion” requirement
      'del.eyebrow': 'Account deletion',
      'del.title': 'Delete my account',
      'del.intro': 'You can permanently delete your Utkan eSIM account and personal data here. You don’t need the app installed — just sign in with the account you want to delete.',
      'del.deleted.title': 'Data that is deleted',
      'del.deleted.identity': 'Your first name, last name, email address and phone number',
      'del.deleted.credentials': 'Your password and session data',
      'del.deleted.codes': 'Your email verification and password reset codes',
      'del.deleted.esim': 'Your eSIM number (MSISDN), QR/activation code and usage data',
      'del.kept.title': 'Data we keep, and why',
      'del.kept.orders': 'Purchase records (order number, date, amount, payment status) are kept to meet tax and accounting obligations. They contain no name, email address or payment details — only an identifier that cannot be linked back to you.',
      'del.kept.period': 'Retention period: 5 years (Turkish Tax Procedure Law, art. 253).',
      'del.warn.title': 'Before you delete',
      'del.warn.irreversible': 'This action cannot be undone.',
      'del.warn.esim': 'Active eSIMs keep working on your device, but you will no longer be able to access your QR code or your remaining data. Save your QR code before deleting.',
      'del.warn.rejoin': 'You can sign up again with the same email address, but your previous eSIMs will not appear in the new account.',
      'del.support': 'If you cannot sign in, you can also request deletion by email:',
      'del.login.title': 'Sign in first',
      'del.login.subtitle': 'Enter your email and password so we can confirm the account is yours.',
      'del.login.action': 'Sign in',
      'del.login.loading': 'Signing in...',
      'del.forgot': 'Forgot your password?',
      'del.confirm.title': 'Are you sure?',
      'del.confirm.subtitle': 'The account {{email}} and your personal data will be permanently deleted.',
      'del.confirm.field': 'Type your email address again to confirm',
      'del.confirm.action': 'Permanently delete my account',
      'del.confirm.deleting': 'Deleting...',
      'del.confirm.cancel': 'Cancel',
      'del.done.title': 'Your account has been deleted',
      'del.done.body': 'Your personal data has been permanently deleted.',
      'del.done.retained': 'Your personal data has been permanently deleted. {{n}} purchase record(s) were kept to meet legal obligations; they cannot be linked to you.',
      'del.done.home': 'Back to the store',
      'del.error.required': 'Please enter your email and password.',
      'del.error.credentials': 'Incorrect email or password.',
      'del.error.suspended': 'Your account has been suspended. Please contact support.',
      'del.error.session': 'Your session has expired. Please sign in again.',
      'del.error.network': 'Could not connect. Check your internet connection and try again.',
      'del.error.generic': 'Something went wrong. Please try again.',
      'footer.deleteAccount': 'Delete account',


      // Voice bundles (data + unlimited calls & SMS) — docs/ses-paketleri.md
      'home.tabs.voice': 'Voice eSIMs',
      'detail.voice': 'Calls + SMS',
      'detail.voiceNote': 'This plan includes unlimited calls and SMS on top of its data — one eSIM for both internet and calls.',
      'detail.calls': 'Calls',
      'detail.sms': 'SMS',
      'plan.unlimitedCalls': 'Unlimited calls',
      'plan.unlimitedSms': 'Unlimited SMS',
      'plan.minutes': '{{n}} min of calls',
      'plan.sms': '{{n}} SMS',
      'loading': 'Loading...',
    }
  },
  de: {
    translation: {
      // Hauptseite
      'hero.title': 'Utkan eSIM',
      'hero.subtitle': 'Die Zukunft der digitalen Konnektivität',
      'hero.description': 'Wir entfernen Grenzen mit der neuen Generation digitaler Konnektivitätserfahrung.',
      'hero.description2': 'Schnelle, sichere und erschwingliche eSIM-Lösungen weltweit.',

      // Funktionen
      'features.countries': '150+ Länder',
      'features.activation': 'Sofortige Aktivierung',
      'features.support': '24/7 Support',

      // Countdown
      'countdown.title': 'Unsere Website kommt bald!',
      'countdown.days': 'Tage',
      'countdown.hours': 'Stunden',
      'countdown.minutes': 'Minuten',
      'countdown.seconds': 'Sekunden',
      'countdown.launch': 'Unsere Website ist live!',
      'countdown.loading': 'Lädt...',

      // Apps
      'apps.title': 'Unsere mobilen Anwendungen',
      'apps.ios.label': 'Download im',
      'apps.ios.name': 'App Store',
      'apps.android.label': 'JETZT BEI',
      'apps.android.name': 'Google Play',

      // Kontakt
      'contact.title': 'Kontaktieren Sie uns bis zum Launch',
      'contact.whatsapp': 'WhatsApp: +43 676 555 1 333',
      'contact.email': 'E-Mail: info@utkanesim.com',

      // Über uns Seite
      'about.hero.title': 'Über Utkan eSIM',
      'about.hero.description': 'Ihr vertrauensvoller Partner für die Verbindung, wo immer Sie sind. Wir glauben, dass globales Reisen nahtlos und erschwinglich sein sollte, ohne die Mühe physischer SIM-Karten und teurer Roaming-Gebühren.',
      'about.story.title': 'Unsere Geschichte',
      'about.story.content': 'Gegründet 2024 von einem Team leidenschaftlicher Reisender und Technologie-Enthusiasten, ist unser Ziel, die Art und Weise zu revolutionieren, wie Menschen im Ausland eine Internetverbindung herstellen. Wir bieten hochwertige, zuverlässige eSIM-Datenpläne für über 190 Länder und Regionen und stellen sicher, dass Sie vom Moment der Landung an schnellen Internetzugang haben.',
      'about.mission.title': 'Unsere Mission',
      'about.mission.content': 'Reisenden weltweit einfache, erschwingliche und sofortige Konnektivität zu bieten und sie zu befähigen, grenzenlos zu erkunden, zu arbeiten und in Kontakt zu bleiben.',
      'about.vision.title': 'Unsere Vision',
      'about.vision.content': 'Die führende globale Plattform für digitale Konnektivitätslösungen zu sein und die Welt für alle zu einem kleineren, vernetzteren Ort zu machen.',
      'about.features.title': 'Warum uns wählen?',
      'about.features.instant.title': 'Sofortige Lieferung',
      'about.features.instant.content': 'Erhalten Sie Ihre eSIM sofort nach dem Kauf über QR-Code.',
      'about.features.global.title': 'Globale Abdeckung',
      'about.features.global.content': 'Datenpläne für über 190 Länder und Regionen.',
      'about.features.affordable.title': 'Erschwingliche Preise',
      'about.features.affordable.content': 'Sparen Sie bis zu 90% bei Roaming-Gebühren.',
      'about.features.support.title': '24/7 Support',
      'about.features.support.content': 'Unser engagiertes Support-Team ist immer für Sie da.',
      'about.features.secure.title': 'Sichere Verbindung',
      'about.features.secure.content': 'Verbindung geschützt mit den neuesten Sicherheitsprotokollen.',
      'about.features.fast.title': 'Schnelles Internet',
      'about.features.fast.content': 'Nahtlose Internet-Erfahrung mit 4G/5G-Geschwindigkeiten.',
      'about.cta.title': 'Werden Sie Teil der Zukunft der digitalen Konnektivität',
      'about.cta.content': 'Vielen Dank, dass Sie Utkan eSIM gewählt haben. Gute Reise!',
      'about.cta.whatsapp': 'Kontakt über WhatsApp',
      'about.cta.email': 'E-Mail senden',

      // Kontakt Seite
      'contact.hero.title': 'Kontaktieren Sie uns',
      'contact.hero.description': 'Wir sind hier, um zu helfen! Ob Sie eine Frage zu unseren eSIMs haben, technischen Support benötigen oder uns einfach Feedback geben möchten - wir freuen uns, von Ihnen zu hören.',
      'contact.info.title': 'Kontaktinformationen',
      'contact.whatsapp.title': 'WhatsApp',
      'contact.whatsapp.subtitle': '24/7 Schneller Support',
      'contact.email.title': 'E-Mail',
      'contact.email.subtitle': 'Allgemeiner Kontakt',
      'contact.support.title': 'Technischer Support',
      'contact.support.subtitle': 'eSIM-Probleme',
      'contact.business.title': 'Partnerschaft',
      'contact.business.subtitle': 'Unternehmenskontakt',
      'contact.hours.title': 'Support-Zeiten',
      'contact.hours.subtitle': '24/7 Technischer Support',
      'contact.hours.detail': 'Montag - Sonntag: 00:00 - 23:59',
      'contact.form.title': 'Senden Sie uns eine Nachricht',
      'contact.form.name': 'Ihr Name',
      'contact.form.name.placeholder': 'Geben Sie Ihren Vor- und Nachnamen ein',
      'contact.form.email': 'Ihre E-Mail',
      'contact.form.email.placeholder': 'beispiel@email.com',
      'contact.form.subject': 'Betreff',
      'contact.form.subject.placeholder': 'Betreff auswählen',
      'contact.form.subject.general': 'Allgemeine Informationen',
      'contact.form.subject.technical': 'Technischer Support',
      'contact.form.subject.billing': 'Abrechnungsfragen',
      'contact.form.subject.partnership': 'Partnerschaft',
      'contact.form.subject.feedback': 'Feedback',
      'contact.form.message': 'Ihre Nachricht',
      'contact.form.message.placeholder': 'Schreiben Sie Ihre Nachricht hier...',
      'contact.form.submit': 'Nachricht senden',
      'contact.faq.title': 'Häufig gestellte Fragen',
      'contact.faq.esim.title': 'Wie funktioniert eSIM?',
      'contact.faq.esim.content': 'eSIM ist eine digitale SIM-Karte, die in Ihrem Telefon funktioniert, ohne eine physische SIM-Karte zu benötigen. Sie wird sofort über QR-Code aktiviert.',
      'contact.faq.phones.title': 'Welche Telefone unterstützen eSIM?',
      'contact.faq.phones.content': 'iPhone XS und höher, Samsung Galaxy S20 und höher, Google Pixel 3 und höhere Modelle unterstützen eSIM.',
      'contact.faq.validity.title': 'Wie lange ist mein Datenpaket gültig?',
      'contact.faq.validity.content': 'Die Gültigkeitsdauer des Pakets variiert je nach gewähltem Plan zwischen 1-30 Tagen.',
      'contact.faq.payment.title': 'Wie kann ich bezahlen?',
      'contact.faq.payment.content': 'Sie können sicher mit Kreditkarte, PayPal und Banküberweisung bezahlen.',

      // Datenschutz Seite
      'privacy.hero.title': 'Datenschutzerklärung',
      'privacy.hero.description': 'Die Sicherheit Ihrer persönlichen Daten ist uns sehr wichtig. Diese Richtlinie erklärt, wie Ihre Daten gesammelt, verwendet und geschützt werden.',
      'privacy.overview.title': 'Übersicht',
      'privacy.overview.content': 'Diese Datenschutzerklärung beschreibt unsere Richtlinien und Verfahren zur Sammlung, Verwendung und Offenlegung Ihrer Informationen, wenn Sie den Service nutzen, und informiert Sie über Ihre Datenschutzrechte und wie das Gesetz Sie schützt.',
      'privacy.data.title': 'Daten, die wir sammeln',
      'privacy.data.personal.title': 'Persönliche Informationen',
      'privacy.data.personal.name': 'Vor- und Nachname',
      'privacy.data.personal.email': 'E-Mail-Adresse',
      'privacy.data.personal.phone': 'Telefonnummer',
      'privacy.data.personal.payment': 'Zahlungsinformationen',
      'privacy.data.usage.title': 'Nutzungsdaten',
      'privacy.data.usage.ip': 'IP-Adresse',
      'privacy.data.usage.browser': 'Browsertyp',
      'privacy.data.usage.device': 'Geräteinformationen',
      'privacy.data.usage.stats': 'Nutzungsstatistiken',
      'privacy.security.title': 'Datensicherheit',
      'privacy.security.ssl.title': 'SSL-Verschlüsselung',
      'privacy.security.ssl.content': 'Alle Datenübertragungen sind mit 256-Bit-SSL-Verschlüsselung geschützt.',
      'privacy.security.servers.title': 'Sichere Server',
      'privacy.security.servers.content': 'Ihre Daten werden auf ISO 27001-zertifizierten sicheren Servern gespeichert.',
      'privacy.security.access.title': 'Zugriffskontrolle',
      'privacy.security.access.content': 'Nur autorisiertes Personal kann auf Ihre Daten zugreifen.',
      'privacy.usage.title': 'Datenverwendung',
      'privacy.usage.intro': 'Wir verwenden die gesammelten Daten für folgende Zwecke:',
      'privacy.usage.service.title': 'Dienstleistungserbringung',
      'privacy.usage.service.content': 'Um Ihnen unsere eSIM-Dienste bereitzustellen und zu verwalten',
      'privacy.usage.support.title': 'Kundensupport',
      'privacy.usage.support.content': 'Um technischen Support und Kundenservice zu bieten',
      'privacy.usage.security.title': 'Sicherheit',
      'privacy.usage.security.content': 'Um Ihr Konto und unsere Dienste zu schützen',
      'privacy.usage.improvement.title': 'Verbesserung',
      'privacy.usage.improvement.content': 'Um unsere Dienste zu verbessern und neue Funktionen hinzuzufügen',
      'privacy.sharing.title': 'Datenweitergabe',
      'privacy.sharing.intro': 'Wir geben Ihre persönlichen Daten nicht an Dritte weiter, aber eine Weitergabe kann in folgenden Fällen erforderlich sein:',
      'privacy.sharing.legal': 'Bei gesetzlicher Verpflichtung',
      'privacy.sharing.providers': 'Mit unseren Dienstleistern (wie Zahlungsabwicklern)',
      'privacy.sharing.threats': 'Um Sicherheitsbedrohungen zu verhindern',
      'privacy.sharing.consent': 'Wenn Sie ausdrückliche Zustimmung geben',
      'privacy.rights.title': 'Ihre Rechte',
      'privacy.rights.access.title': 'Recht auf Zugang',
      'privacy.rights.access.content': 'Sie können Zugang zu den über Sie gespeicherten Daten beantragen.',
      'privacy.rights.correction.title': 'Recht auf Berichtigung',
      'privacy.rights.correction.content': 'Wir können Ihre falschen oder unvollständigen Daten berichtigen.',
      'privacy.rights.deletion.title': 'Recht auf Löschung',
      'privacy.rights.deletion.content': 'Wir können Ihre Daten unter bestimmten Bedingungen löschen.',
      'privacy.rights.objection.title': 'Widerspruchsrecht',
      'privacy.rights.objection.content': 'Sie können unseren Datenverarbeitungsaktivitäten widersprechen.',
      'privacy.contact.title': 'Kontakt',
      'privacy.contact.intro': 'Wenn Sie Fragen zu dieser Datenschutzerklärung haben, können Sie uns über folgende Kanäle kontaktieren:',

      // Navigation
      'nav.about': 'Über uns',
      'nav.contact': 'Kontakt',
      'nav.privacy': 'Datenschutz',
      'nav.login': 'Anmelden',
      'nav.account': 'Konto',
      'nav.logout': 'Abmelden',

      // Auth - Markenpanel
      'auth.brand.eyebrow': 'WELTWEITE ABDECKUNG',
      'auth.brand.title': 'In über 150 Ländern online, sobald du landest.',
      'auth.brand.subtitle': 'Keine physische SIM, keine Roaming-Rechnungen. Aktiviere deine eSIM in Sekunden.',

      // Auth - Anmeldung
      'auth.login.eyebrow': 'ANMELDEN',
      'auth.login.title': 'Willkommen zurück',
      'auth.login.subtitle': 'Verwalte deine eSIMs und entdecke neue.',

      // Auth - Registrierung
      'auth.signup.eyebrow': 'NEUES KONTO',
      'auth.signup.title': 'Konto erstellen',
      'auth.signup.subtitle': 'Wenige Schritte bis zu deiner ersten eSIM.',

      // Auth - Felder
      'auth.field.identifier': 'E-Mail oder Telefon',
      'auth.field.identifier.ph': 'du@email.com oder +49…',
      'auth.field.email': 'E-Mail',
      'auth.field.email.ph': 'du@email.com',
      'auth.field.fullName': 'Vollständiger Name',
      'auth.field.fullName.ph': 'Dein vollständiger Name',
      'auth.field.password': 'Passwort',
      'auth.field.password.ph': '••••••••',

      // Auth - Aktionen
      'auth.action.login': 'Anmelden',
      'auth.action.loggingIn': 'Anmeldung läuft…',
      'auth.action.signup': 'Konto erstellen',
      'auth.action.signingUp': 'Konto wird erstellt…',
      'auth.toSignup.q': 'Noch kein Konto?',
      'auth.toSignup.link': 'Registrieren',
      'auth.toLogin.q': 'Bereits ein Konto?',
      'auth.toLogin.link': 'Anmelden',
      'auth.password.show': 'Passwort anzeigen',
      'auth.password.hide': 'Passwort verbergen',

      // Auth - Bedingungen & Fehler
      'auth.terms.prefix': 'Mit dem Fortfahren stimme ich den ',
      'auth.terms.link': 'Nutzungsbedingungen und der Datenschutzerklärung',
      'auth.terms.suffix': ' zu.',
      'auth.error.required': 'Bitte fülle die erforderlichen Felder aus.',
      'auth.error.terms': 'Bitte akzeptiere die Bedingungen, um fortzufahren.',

      // E-Mail-Bestätigung
      'verify.eyebrow': 'E-MAIL-BESTÄTIGUNG',
      'verify.title': 'Bestätige deine E-Mail',
      'verify.subtitle': 'Wir haben einen 6-stelligen Code an {{email}} gesendet. Gib ihn zur Bestätigung ein.',
      'verify.code': 'Bestätigungscode',
      'verify.code.ph': '••••••',
      'verify.action': 'Bestätigen',
      'verify.verifying': 'Wird bestätigt…',
      'verify.resend': 'Code erneut senden',
      'verify.resendIn': 'Erneut senden in {{seconds}}s',
      'verify.resent': 'Ein neuer Code wurde gesendet.',
      'verify.skip': 'Vorerst überspringen',

      // Passwort vergessen
      'auth.forgot.link': 'Passwort vergessen?',
      'forgot.eyebrow': 'PASSWORT ZURÜCKSETZEN',
      'forgot.email.title': 'Passwort zurücksetzen',
      'forgot.email.subtitle':
        'Gib die E-Mail-Adresse deines Kontos ein; wir senden dir einen 6-stelligen Code.',
      'forgot.email.action': 'Code senden',
      'forgot.email.sending': 'Wird gesendet…',
      'forgot.reset.title': 'Neues Passwort festlegen',
      'forgot.reset.subtitle':
        'Gib den 6-stelligen Code, den wir an {{email}} gesendet haben, und dein neues Passwort ein.',
      'forgot.reset.action': 'Passwort aktualisieren',
      'forgot.reset.updating': 'Wird aktualisiert…',
      'forgot.field.code': 'Zurücksetzungscode',
      'forgot.field.code.ph': '••••••',
      'forgot.field.newPassword': 'Neues Passwort',
      'forgot.field.newPassword.ph': 'Mindestens 6 Zeichen',
      'forgot.resend': 'Code erneut senden',
      'forgot.resendIn': 'Erneut senden in {{seconds}}s',
      'forgot.resent': 'Ein neuer Code wurde gesendet.',
      'forgot.backToLogin': 'Zurück zur Anmeldung',
      'forgot.changeEmail': 'E-Mail ändern',
      'forgot.help.noMail':
        'Falls der Code nicht angekommen ist, prüfe deinen Spam-Ordner oder bestätige deine E-Mail-Adresse.',
      // Server-Ergebniscodes → Nutzertext
      'reset.RESET_CODE_SENT': 'Code gesendet. Bitte prüfe deine E-Mails.',
      'reset.RATE_LIMITED':
        'Zu viele Anfragen. Bitte warte eine Weile und versuche es erneut.',
      'reset.MAIL_SEND_FAILED':
        'Etwas ist schiefgelaufen. Bitte versuche es später erneut.',
      'reset.RESET_CODE_VALID': 'Code bestätigt.',
      'reset.INVALID_RESET_CODE':
        'Ungültiger Code. Bitte versuche es erneut.',
      'reset.EXPIRED_RESET_CODE':
        'Der Code ist abgelaufen. Bitte fordere einen neuen Code an.',
      'reset.WEAK_PASSWORD': 'Das Passwort muss mindestens 6 Zeichen lang sein.',
      'reset.PASSWORD_RESET_SUCCESS':
        'Dein Passwort wurde aktualisiert. Bitte melde dich mit deinem neuen Passwort an.',
      'reset.generic': 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
      'login.resetSuccess':
        'Dein Passwort wurde aktualisiert. Bitte melde dich mit deinem neuen Passwort an.',

      // Store-Navigation
      'store.nav.shop': 'Shop',

      // Startseite (Shop)
      'home.hero.title1': 'In Minuten verbunden,',
      'home.hero.title2': 'über Grenzen hinweg online.',
      'home.hero.subtitle': 'Zuverlässige eSIM-Tarife, gültig in über 190 Ländern. Keine physische SIM, keine Roaming-Rechnungen.',
      'home.search.placeholder': 'Wohin reist du?',
      'home.tabs.local': 'Lokale eSIMs',
      'home.tabs.regional': 'Regionale eSIMs',
      'home.tabs.lifetime': 'Lebenslange eSIMs',
      'home.empty': 'Keine Ergebnisse für deine Suche.',
      'home.error.title': 'Inhalt konnte nicht geladen werden',
      'home.error.retry': 'Erneut versuchen',
      'home.from': 'ab',
      'home.popular': 'Beliebte Reiseziele',
      'home.coverage': '190+ Länder · sofortige Aktivierung',
      'home.detail.soon': 'Tarife für diese Auswahl werden hier in Kürze aufgelistet.',
      'home.detail.back': 'Zurück zum Shop',

      // eSIM-Detail / Tarife
      'detail.plans': 'Tarife',
      'detail.count': '{{count}} Tarife',
      'detail.validity': '{{days}} Tage',
      'detail.validityLifetime': 'Unbegrenzt',
      'detail.buy': 'Kaufen',
      'detail.empty': 'Für diese Auswahl sind derzeit keine Tarife verfügbar.',
      'detail.checkoutSoon': 'Die Bezahlung folgt in Kürze.',
      'detail.loginToBuy': 'Zum Kauf bitte anmelden.',
      'detail.basicFeatures': 'Grundfunktionen',
      'detail.dataAmount': 'Datenvolumen',
      'detail.validityLabel': 'Gültigkeit',
      'detail.coverageArea': 'Abdeckung',
      'detail.activationNetworks': 'Aktivierung & Netze',
      'detail.activationMethod': 'Aktivierungsmethode',
      'detail.esimActivation': 'eSIM — sofort per QR-Code',
      'detail.supportedNetworks': 'Unterstützte Netze',
      'detail.description': 'Beschreibung',
      'detail.price': 'Preis',

      // Anmelde-Dialog
      'authprompt.title': 'Zum Fortfahren anmelden',
      'authprompt.message': 'Melde dich an, um eine eSIM zu kaufen, oder erstelle in Sekunden ein Konto.',
      'authprompt.close': 'Schließen',

      // Footer
      'footer.tagline': 'Schnelle, sichere und günstige eSIM weltweit. Online, sobald du landest.',
      'footer.explore': 'Entdecken',
      'footer.support': 'Support',
      'footer.legal': 'Rechtliches',
      'footer.shop': 'Shop',
      'footer.help': 'Häufige Fragen',
      'footer.terms': 'Nutzungsbedingungen',
      'footer.rights': '© {{year}} Utkan eSIM. Alle Rechte vorbehalten.',
      'footer.apps': 'App herunterladen',

      // WhatsApp-Support-Button
      'whatsapp.label': 'Per WhatsApp schreiben',
      'whatsapp.message': 'Hallo, ich habe eine eSIM-Supportanfrage.',

      // 404
      'notfound.eyebrow': 'KEIN SIGNAL',
      'notfound.title': 'Diese Seite ist nicht erreichbar',
      'notfound.message': 'Die gesuchte Seite wurde verschoben oder hat nie existiert. Zurück ins Netz!',

      // Bestellung erfolgreich
      'order.congrats': 'Glückwunsch!',
      'order.message': 'Deine eSIM ist bereit. Richte sie in wenigen Schritten mit dem QR-Code unten ein.',
      'order.details': 'Bestellübersicht',
      'order.activation': 'Aktivierung',
      'order.activationDesc': 'Scanne zum Einrichten den QR-Code mit deiner Gerätekamera oder gib den Aktivierungscode manuell ein.',
      'order.qrTitle': 'eSIM-QR-Code',
      'order.manualLabel': 'Aktivierungscode',
      'order.copy': 'Kopieren',
      'order.copied': 'Kopiert',
      'order.howTo': 'So aktivierst du',
      'order.step1': 'Gehe am Gerät zu Einstellungen > Mobilfunk > eSIM hinzufügen.',
      'order.step2': 'Wähle „QR-Code verwenden“ und scanne den QR oben (oder gib den Code manuell ein).',
      'order.step3': 'Aktiviere nach der Einrichtung den eSIM-Tarif.',
      'order.step4': 'Stelle sicher, dass Daten-Roaming aktiviert ist — du bist verbunden!',
      'order.cta': 'Zur Startseite',

      // Kasse (Checkout)
      'checkout.title': 'Kasse',
      'checkout.summary': 'Bestellübersicht',
      'checkout.total': 'Gesamt',
      'checkout.eurNote': 'Die Abbuchung erfolgt in Euro (€) über PayPal.',
      'checkout.processing': 'Zahlung wird überprüft…',
      'checkout.error': 'Zahlung konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
      'checkout.cancelled': 'Zahlung abgebrochen.',

      // Konto
      'account.title': 'Mein Konto',
      'account.tab.profile': 'Profil',
      'account.tab.esims': 'Meine eSIMs',
      'account.tab.security': 'Sicherheit',
      'account.profile.title': 'Profilinformationen',
      'account.field.phone': 'Telefon',
      'account.field.phone.ph': '+49…',
      'account.memberSince': 'Mitglied seit',
      'account.save': 'Speichern',
      'account.saving': 'Wird gespeichert…',
      'account.saved': 'Deine Daten wurden aktualisiert.',
      'account.esims.title': 'Meine eSIMs',
      'account.esims.empty': 'Du hast noch keine eSIMs.',
      'account.esims.emptyCta': 'Zum Shop',
      'account.esims.data': 'Daten',
      'account.esims.expires': 'Läuft ab',
      'account.esims.viewQr': 'QR-Code anzeigen',
      'account.esims.hideQr': 'QR-Code ausblenden',
      'account.esims.active': 'Aktiv',
      'account.esims.passive': 'Inaktiv',
      'account.esims.noActive': 'Du hast keine aktiven eSIMs.',
      'account.esims.noPassive': 'Du hast keine inaktiven eSIMs.',
      'account.esims.readyHint': 'Einsatzbereit — die Laufzeit beginnt bei der ersten Nutzung.',
      'account.esims.unavailableHint': 'Status derzeit nicht verfügbar. Bitte später erneut versuchen.',
      'esimStatus.active': 'Aktiv',
      'esimStatus.readyToUse': 'Einsatzbereit',
      'esimStatus.inactive': 'Inaktiv',
      'esimStatus.unavailable': 'Status nicht verfügbar',
      'account.security.title': 'Passwort ändern',
      'account.field.oldPassword': 'Aktuelles Passwort',
      'account.field.newPassword': 'Neues Passwort',
      'account.field.confirmPassword': 'Neues Passwort (wiederholen)',
      'account.changePassword': 'Passwort aktualisieren',
      'account.passwordChanged': 'Dein Passwort wurde aktualisiert.',
      'account.error.passwordMismatch': 'Die neuen Passwörter stimmen nicht überein.',
      'account.danger.title': 'Kontoaktionen',
      'account.delete': 'Konto löschen',
      'account.delete.confirm': 'Du bist dabei, dein Konto dauerhaft zu löschen. Das kann nicht rückgängig gemacht werden.',
      'account.delete.confirmBtn': 'Ja, löschen',
      'account.cancel': 'Abbrechen',

      // Detail der gekauften eSIM
      'esimDetail.back': 'Zurück',
      'esimDetail.dataUsage': 'Datennutzung',
      'esimDetail.left': 'übrig',
      'esimDetail.leftData': 'Verbleibende Daten',
      'esimDetail.usedData': 'Verbraucht',
      'esimDetail.totalData': 'Gesamtdaten',
      'esimDetail.qrDesc': 'Scanne diesen QR-Code mit deiner Gerätekamera, um deine eSIM einzurichten.',
      'esimDetail.validity': 'Gültigkeit',
      'esimDetail.daysLeft': 'Noch {{days}} Tage',
      'esimDetail.expired': 'Abgelaufen',
      'esimDetail.notYetActive': 'Noch nicht aktiv',
      'esimDetail.leftDate': 'Verbleibende Zeit',
      'esimDetail.activationDate': 'Aktivierungsdatum',
      'esimDetail.endDate': 'Enddatum',
      'esimDetail.technical': 'Technische Details',
      'esimDetail.activationCode': 'Aktivierungscode (Android)',
      'esimDetail.smdp': 'SM-DP+-Adresse (iOS)',
      'esimDetail.matchingId': 'Matching-ID (iOS)',
      'esimDetail.support': 'Technischer Support',
      'esimDetail.supportDesc': 'Etwas stimmt nicht? Wir helfen dir.',
      'esimDetail.email': 'E-Mail senden',

      // eSIM-Leitfaden
      'guide.eyebrow': 'eSIM-LEITFADEN',
      'guide.title': 'Was ist eine eSIM und wie richte ich sie ein?',
      'guide.intro.title': 'Was ist eine eSIM?',
      'guide.intro.body': 'Eine eSIM ist eine digitale, im Gerät eingebettete SIM — ganz ohne physische Karte. Scanne einen QR-Code und deine Leitung ist in Sekunden eingerichtet: online in über 190 Ländern, ohne Kartenwechsel und ohne Roaming-Rechnungen.',
      'guide.steps.title': 'So aktivierst du',
      'guide.devices.title': 'Unterstützte Geräte',
      'guide.devices.desc': 'Dein Gerät muss eSIM unterstützen. Finde unten deine Marke.',
      'guide.faq.title': 'Häufig gestellte Fragen',
      'nav.guide': 'eSIM-Leitfaden',
      'currency.label': 'Währung',

      // Statische Seiten (About/Contact/Privacy) — Lade- & Fehlerzustände
      'staticPage.loading': 'Seite wird geladen...',
      'staticPage.errorTitle': 'Ein Fehler ist aufgetreten',
      'staticPage.retry': 'Erneut versuchen',
      'staticPage.loadFailed': 'Seiteninhalt konnte nicht geladen werden. Bitte versuche es später erneut.',

      // Allgemein
      'last.updated': 'Zuletzt aktualisiert: 8. Juli 2024',

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      'home.tabs.unlimited': 'Unbegrenzte eSIMs',
      'detail.unlimited': 'Unbegrenzt',
      'detail.unlimitedNote': 'Dieses Paket hat kein Datenlimit — unbegrenztes Internet für die gesamte Laufzeit.',
      'detail.notPriced': 'Dieses Paket ist derzeit im Web nicht kaufbar.',
      'checkout.priceUpdated': 'Der Preis dieses Pakets hat sich geändert. Bitte kehre zum Shop zurück und wähle es erneut aus.',
      'order.pending.title': 'Deine eSIM wird vorbereitet',
      'order.pending.message': 'Deine Zahlung war erfolgreich. Bei unbegrenzten Paketen kann die Aktivierung einige Minuten dauern.',
      'order.pending.waiting': 'Bestellstatus wird geprüft…',
      'order.pending.ready': 'Deine eSIM ist bereit!',
      'order.pending.timeout': 'Das dauert länger als erwartet. Deine Zahlung ist sicher — deine eSIM erscheint unter „Meine eSIMs“, sobald sie bereit ist.',
      'order.pending.cta': 'Zu meinen eSIMs',
      'account.esims.unlimited': 'Unbegrenzt',
      'account.esims.unlimitedHint': 'Unbegrenzte Daten — dieses Paket hat kein Datenlimit.',
      'esimDetail.unlimitedData': 'Dieses Paket hat kein Datenlimit; die Restlaufzeit siehst du unten.',


      // Kontolöschung (/hesap-sil · /account-deletion) — Google-Play-Anforderung „Data deletion“
      'del.eyebrow': 'Kontolöschung',
      'del.title': 'Mein Konto löschen',
      'del.intro': 'Hier kannst du dein Utkan eSIM-Konto und deine personenbezogenen Daten dauerhaft löschen. Du brauchst die App dafür nicht — melde dich einfach mit dem Konto an, das gelöscht werden soll.',
      'del.deleted.title': 'Daten, die gelöscht werden',
      'del.deleted.identity': 'Vorname, Nachname, E-Mail-Adresse und Telefonnummer',
      'del.deleted.credentials': 'Passwort und Sitzungsdaten',
      'del.deleted.codes': 'Codes zur E-Mail-Bestätigung und zum Zurücksetzen des Passworts',
      'del.deleted.esim': 'eSIM-Rufnummer (MSISDN), QR-/Aktivierungscode und Nutzungsdaten',
      'del.kept.title': 'Daten, die wir aufbewahren – und warum',
      'del.kept.orders': 'Kaufbelege (Bestellnummer, Datum, Betrag, Zahlungsstatus) werden aufgrund steuerrechtlicher Pflichten aufbewahrt. Sie enthalten weder deinen Namen noch deine E-Mail-Adresse oder Zahlungsdaten – nur eine Kennung, die sich dir nicht zuordnen lässt.',
      'del.kept.period': 'Aufbewahrungsfrist: 5 Jahre (türkisches Steuerverfahrensgesetz, Art. 253).',
      'del.warn.title': 'Vor dem Löschen',
      'del.warn.irreversible': 'Dieser Vorgang kann nicht rückgängig gemacht werden.',
      'del.warn.esim': 'Aktive eSIMs funktionieren auf deinem Gerät weiter, aber du hast keinen Zugriff mehr auf deinen QR-Code und dein verbleibendes Datenvolumen. Sichere deinen QR-Code vorher.',
      'del.warn.rejoin': 'Du kannst dich mit derselben E-Mail-Adresse erneut registrieren, deine bisherigen eSIMs erscheinen jedoch nicht im neuen Konto.',
      'del.support': 'Wenn du dich nicht anmelden kannst, kannst du die Löschung auch per E-Mail beantragen:',
      'del.login.title': 'Zuerst anmelden',
      'del.login.subtitle': 'Gib E-Mail und Passwort ein, damit wir bestätigen können, dass es dein Konto ist.',
      'del.login.action': 'Anmelden',
      'del.login.loading': 'Anmeldung läuft...',
      'del.forgot': 'Passwort vergessen?',
      'del.confirm.title': 'Bist du sicher?',
      'del.confirm.subtitle': 'Das Konto {{email}} und deine personenbezogenen Daten werden dauerhaft gelöscht.',
      'del.confirm.field': 'Gib deine E-Mail-Adresse zur Bestätigung erneut ein',
      'del.confirm.action': 'Mein Konto dauerhaft löschen',
      'del.confirm.deleting': 'Wird gelöscht...',
      'del.confirm.cancel': 'Abbrechen',
      'del.done.title': 'Dein Konto wurde gelöscht',
      'del.done.body': 'Deine personenbezogenen Daten wurden dauerhaft gelöscht.',
      'del.done.retained': 'Deine personenbezogenen Daten wurden dauerhaft gelöscht. {{n}} Kaufbeleg(e) werden aufgrund gesetzlicher Pflichten aufbewahrt; sie lassen sich dir nicht zuordnen.',
      'del.done.home': 'Zurück zum Shop',
      'del.error.required': 'Bitte gib E-Mail und Passwort ein.',
      'del.error.credentials': 'E-Mail oder Passwort ist falsch.',
      'del.error.suspended': 'Dein Konto wurde gesperrt. Bitte wende dich an den Support.',
      'del.error.session': 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
      'del.error.network': 'Keine Verbindung. Prüfe deine Internetverbindung und versuche es erneut.',
      'del.error.generic': 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
      'footer.deleteAccount': 'Konto löschen',


      // Sprach-Pakete (Daten + unbegrenzte Anrufe & SMS) — docs/ses-paketleri.md
      'home.tabs.voice': 'eSIMs mit Telefonie',
      'detail.voice': 'Anrufe + SMS',
      'detail.voiceNote': 'Dieser Tarif enthält zusätzlich zum Datenvolumen unbegrenzte Anrufe und SMS – eine eSIM für Internet und Telefonie.',
      'detail.calls': 'Anrufe',
      'detail.sms': 'SMS',
      'plan.unlimitedCalls': 'Unbegrenzte Anrufe',
      'plan.unlimitedSms': 'Unbegrenzte SMS',
      'plan.minutes': '{{n}} Gesprächsminuten',
      'plan.sms': '{{n}} SMS',
      'loading': 'Lädt...',
    }
  },
  fr: {
    translation: {
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "L'Avenir de la Connectivité Numérique",
      "hero.description": "Nous repoussons les limites avec une expérience de connectivité numérique de nouvelle génération.",
      "hero.description2": "Des solutions eSIM rapides, sécurisées et abordables dans le monde entier.",
      "features.countries": "150+ Pays",
      "features.activation": "Activation Instantanée",
      "features.support": "Support 24/7",
      "countdown.title": "Notre Site Web Arrive Bientôt !",
      "countdown.days": "Jours",
      "countdown.hours": "Heures",
      "countdown.minutes": "Minutes",
      "countdown.seconds": "Secondes",
      "countdown.launch": "Notre Site Web Est Ouvert !",
      "countdown.loading": "Chargement...",
      "apps.title": "Nos Applications Mobiles",
      "apps.ios.label": "Télécharger dans l'",
      "apps.ios.name": "App Store",
      "apps.android.label": "DISPONIBLE SUR",
      "apps.android.name": "Google Play",
      "contact.title": "Contactez-nous avant le lancement",
      "contact.whatsapp": "WhatsApp : +43 676 555 1 333",
      "contact.email": "E-mail : info@utkanesim.com",
      "about.hero.title": "À propos d'Utkan eSIM",
      "about.hero.description": "La sécurité de vos données personnelles est très importante pour nous. Cette politique explique comment vos données sont collectées, utilisées et protégées.",
      "about.story.title": "Notre Histoire",
      "about.story.content": "Fondée en 2024 par une équipe de voyageurs passionnés et de technophiles, Utkan eSIM vise à révolutionner la façon dont les gens se connectent à Internet à l'étranger. En proposant des forfaits de données eSIM fiables et de haute qualité pour plus de 190 pays et régions, nous garantissons votre accès rapide à Internet dès votre atterrissage.",
      "about.mission.title": "Notre Mission",
      "about.mission.content": "Fournir aux voyageurs une connectivité simple, abordable et instantanée dans le monde entier, leur permettant d'explorer, de travailler et de rester en contact sans frontières.",
      "about.vision.title": "Notre Vision",
      "about.vision.content": "Être la principale plateforme mondiale de solutions de connectivité numérique, rendant le monde plus petit et plus connecté pour tous.",
      "about.features.title": "Pourquoi Nous Choisir ?",
      "about.features.instant.title": "Livraison Instantanée",
      "about.features.instant.content": "Obtenez votre eSIM instantanément avec un code QR après l'achat.",
      "about.features.global.title": "Couverture Mondiale",
      "about.features.global.content": "Des forfaits de données pour plus de 190 pays et régions.",
      "about.features.affordable.title": "Prix Abordables",
      "about.features.affordable.content": "Économisez jusqu'à 90 % sur les frais d'itinérance.",
      "about.features.support.title": "Support 24/7",
      "about.features.support.content": "Notre équipe de support dédiée est toujours à votre disposition.",
      "about.features.secure.title": "Connexion Sécurisée",
      "about.features.secure.content": "Une connexion protégée par les derniers protocoles de sécurité.",
      "about.features.fast.title": "Internet Rapide",
      "about.features.fast.content": "Expérience Internet ininterrompue à des vitesses 4G/5G.",
      "about.cta.title": "Rejoignez l'Avenir de la Connectivité Numérique",
      "about.cta.content": "Merci d'avoir choisi Utkan eSIM. Bon voyage !",
      "about.cta.whatsapp": "Contacter via WhatsApp",
      "about.cta.email": "Envoyer un E-mail",
      "contact.hero.title": "Contactez-nous",
      "contact.hero.description": "Si vous avez des questions sur nos eSIM, besoin d'un support technique ou si vous souhaitez simplement donner votre avis, nous serions ravis de vous entendre.",
      "contact.info.title": "Nos Coordonnées",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Support Rapide 24/7",
      "contact.email.title": "E-mail",
      "contact.email.subtitle": "Contact Général",
      "contact.support.title": "Support Technique",
      "contact.support.subtitle": "Problèmes d'eSIM",
      "contact.business.title": "Partenariat Commercial",
      "contact.business.subtitle": "Contact Entreprise",
      "contact.hours.title": "Heures de Support",
      "contact.hours.subtitle": "Support Technique 24/7",
      "contact.hours.detail": "Lundi - Dimanche : 00:00 - 23:59",
      "contact.form.title": "Envoyer un Message",
      "contact.form.name": "Nom et Prénom",
      "contact.form.name.placeholder": "Entrez votre nom et prénom",
      "contact.form.email": "Votre Adresse E-mail",
      "contact.form.email.placeholder": "exemple@email.com",
      "contact.form.subject": "Sujet",
      "contact.form.subject.placeholder": "Sélectionnez un sujet",
      "contact.form.subject.general": "Informations Générales",
      "contact.form.subject.technical": "Support Technique",
      "contact.form.subject.billing": "Questions de Facturation",
      "contact.form.subject.partnership": "Partenariat Commercial",
      "contact.form.subject.feedback": "Commentaires",
      "contact.form.message": "Votre Message",
      "contact.form.message.placeholder": "Écrivez votre message ici...",
      "contact.form.submit": "Envoyer le Message",
      "contact.faq.title": "Foire Aux Questions",
      "contact.faq.esim.title": "Comment fonctionne une eSIM ?",
      "contact.faq.esim.content": "L'eSIM est une carte SIM numérique qui fonctionne sur votre téléphone sans avoir besoin d'une carte SIM physique. Elle est activée instantanément avec un code QR.",
      "contact.faq.phones.title": "Quels téléphones sont compatibles avec l'eSIM ?",
      "contact.faq.phones.content": "Les modèles iPhone XS et ultérieurs, Samsung Galaxy S20 et ultérieurs, Google Pixel 3 et ultérieurs sont compatibles avec l'eSIM.",
      "contact.faq.validity.title": "Combien de temps mon forfait de données est-il valide ?",
      "contact.faq.validity.content": "La période de validité des forfaits varie de 1 à 30 jours selon le plan que vous choisissez.",
      "contact.faq.payment.title": "Comment s'effectue le paiement ?",
      "contact.faq.payment.content": "Vous pouvez payer en toute sécurité par carte de crédit, PayPal et virement bancaire.",
      "privacy.hero.title": "Politique de Confidentialité",
      "privacy.hero.description": "La sécurité de vos données personnelles est très importante pour nous. Cette politique explique comment vos données sont collectées, utilisées et protégées.",
      "privacy.overview.title": "Aperçu",
      "privacy.overview.content": "Cette Politique de confidentialité décrit nos politiques et procédures concernant la collecte, l'utilisation et la divulgation de vos informations lorsque vous utilisez notre Service. Elle vous informe également sur vos droits en matière de confidentialité et sur la manière dont la loi vous protège.",
      "privacy.data.title": "Données Que Nous Collectons",
      "privacy.data.personal.title": "Informations Personnelles",
      "privacy.data.personal.name": "Nom et prénom",
      "privacy.data.personal.email": "Adresse e-mail",
      "privacy.data.personal.phone": "Numéro de téléphone",
      "privacy.data.personal.payment": "Informations de paiement",
      "privacy.data.usage.title": "Données d'Utilisation",
      "privacy.data.usage.ip": "Adresse IP",
      "privacy.data.usage.browser": "Type de navigateur",
      "privacy.data.usage.device": "Informations sur l'appareil",
      "privacy.data.usage.stats": "Statistiques d'utilisation",
      "privacy.security.title": "Sécurité des Données",
      "privacy.security.ssl.title": "Cryptage SSL",
      "privacy.security.ssl.content": "Tous les transferts de données sont protégés par un cryptage SSL 256 bits.",
      "privacy.security.servers.title": "Serveurs Sécurisés",
      "privacy.security.servers.content": "Vos données sont stockées sur des serveurs sécurisés certifiés ISO 27001.",
      "privacy.security.access.title": "Contrôle d'Accès",
      "privacy.security.access.content": "Seul le personnel autorisé peut accéder à vos données.",
      "privacy.usage.title": "Utilisation des Données",
      "privacy.usage.intro": "Nous utilisons les données que nous collectons aux fins suivantes :",
      "privacy.usage.service.title": "Fourniture de Service",
      "privacy.usage.service.content": "Pour fournir et gérer nos services eSIM",
      "privacy.usage.support.title": "Support Client",
      "privacy.usage.support.content": "Pour fournir un support technique et un service client",
      "privacy.usage.security.title": "Sécurité",
      "privacy.usage.security.content": "Pour protéger votre compte et nos services",
      "privacy.usage.improvement.title": "Amélioration",
      "privacy.usage.improvement.content": "Pour améliorer nos services et ajouter de nouvelles fonctionnalités",
      "privacy.sharing.title": "Partage de Données",
      "privacy.sharing.intro": "Nous ne partageons pas vos données personnelles avec des tiers, mais un partage peut être nécessaire dans les cas suivants :",
      "privacy.sharing.legal": "En cas d'obligation légale",
      "privacy.sharing.providers": "Avec nos prestataires de services (comme les processeurs de paiement)",
      "privacy.sharing.threats": "Pour prévenir les menaces de sécurité",
      "privacy.sharing.consent": "Avec votre consentement explicite",
      "privacy.rights.title": "Vos Droits",
      "privacy.rights.access.title": "Droit d'Accès",
      "privacy.rights.access.content": "Vous pouvez demander l'accès aux données que nous détenons à votre sujet.",
      "privacy.rights.correction.title": "Droit de Rectification",
      "privacy.rights.correction.content": "Nous pouvons corriger vos données inexactes ou incomplètes.",
      "privacy.rights.deletion.title": "Droit de Suppression",
      "privacy.rights.deletion.content": "Nous pouvons supprimer vos données sous certaines conditions.",
      "privacy.rights.objection.title": "Droit d'Opposition",
      "privacy.rights.objection.content": "Vous pouvez vous opposer à nos activités de traitement de données.",
      "privacy.contact.title": "Contact",
      "privacy.contact.intro": "Si vous avez des questions concernant cette Politique de confidentialité, vous pouvez nous contacter via les canaux suivants :",
      "nav.about": "À propos",
      "nav.contact": "Contact",
      "nav.privacy": "Confidentialité",
      "nav.login": "Connexion",
      "nav.account": "Mon Compte",
      "nav.logout": "Se déconnecter",
      "auth.brand.eyebrow": "COUVERTURE MONDIALE",
      "auth.brand.title": "Internet dès votre atterrissage dans plus de 150 pays.",
      "auth.brand.subtitle": "Pas de SIM physique, pas de frais d'itinérance. Activez votre eSIM en quelques secondes.",
      "auth.login.eyebrow": "CONNEXION AU COMPTE",
      "auth.login.title": "Bon retour",
      "auth.login.subtitle": "Gérez vos eSIM et découvrez-en de nouvelles.",
      "auth.signup.eyebrow": "NOUVEAU COMPTE",
      "auth.signup.title": "Rejoignez-nous",
      "auth.signup.subtitle": "Préparez votre première eSIM en quelques étapes.",
      "auth.field.identifier": "E-mail ou téléphone",
      "auth.field.identifier.ph": "exemple@email.com ou +90…",
      "auth.field.email": "E-mail",
      "auth.field.email.ph": "exemple@email.com",
      "auth.field.fullName": "Nom et prénom",
      "auth.field.fullName.ph": "Votre nom et prénom",
      "auth.field.password": "Mot de passe",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Se connecter",
      "auth.action.loggingIn": "Connexion en cours…",
      "auth.action.signup": "Créer un compte",
      "auth.action.signingUp": "Création du compte…",
      "auth.toSignup.q": "Vous n'avez pas de compte ?",
      "auth.toSignup.link": "S'inscrire",
      "auth.toLogin.q": "Vous avez déjà un compte ?",
      "auth.toLogin.link": "Se connecter",
      "auth.password.show": "Afficher le mot de passe",
      "auth.password.hide": "Masquer le mot de passe",
      "auth.terms.prefix": "En continuant, j'accepte les ",
      "auth.terms.link": "Conditions d'Utilisation et la Politique de Confidentialité",
      "auth.terms.suffix": ".",
      "auth.error.required": "Veuillez remplir les champs obligatoires.",
      "auth.error.terms": "Vous devez accepter les conditions pour continuer.",
      "verify.eyebrow": "VÉRIFICATION DE L'E-MAIL",
      "verify.title": "Vérifiez votre e-mail",
      "verify.subtitle": "Nous avons envoyé un code à 6 chiffres à l'adresse {{email}}. Saisissez le code pour vérifier.",
      "verify.code": "Code de vérification",
      "verify.code.ph": "••••••",
      "verify.action": "Vérifier",
      "verify.verifying": "Vérification en cours…",
      "verify.resend": "Renvoyer le code",
      "verify.resendIn": "Renvoyer dans {{seconds}} s",
      "verify.resent": "Nouveau code envoyé.",
      "verify.skip": "Ignorer pour le moment",
      "auth.forgot.link": "Mot de passe oublié ?",
      "forgot.eyebrow": "RÉINITIALISATION DU MOT DE PASSE",
      "forgot.email.title": "Réinitialiser votre mot de passe",
      "forgot.email.subtitle": "Saisissez l'adresse e-mail de votre compte ; nous vous enverrons un code de réinitialisation à 6 chiffres.",
      "forgot.email.action": "Envoyer le code",
      "forgot.email.sending": "Envoi en cours…",
      "forgot.reset.title": "Définissez votre nouveau mot de passe",
      "forgot.reset.subtitle": "Saisissez le code à 6 chiffres que nous avons envoyé à {{email}} et votre nouveau mot de passe.",
      "forgot.reset.action": "Mettre à jour le mot de passe",
      "forgot.reset.updating": "Mise à jour en cours…",
      "forgot.field.code": "Code de réinitialisation",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Nouveau mot de passe",
      "forgot.field.newPassword.ph": "Au moins 6 caractères",
      "forgot.resend": "Renvoyer le code",
      "forgot.resendIn": "Renvoyer dans {{seconds}} s",
      "forgot.resent": "Nouveau code envoyé.",
      "forgot.backToLogin": "Retour à la connexion",
      "forgot.changeEmail": "Changer d'e-mail",
      "forgot.help.noMail": "Si le code n'est pas arrivé, vérifiez vos spams ou vérifiez votre adresse e-mail.",
      "reset.RESET_CODE_SENT": "Code envoyé. Veuillez vérifier votre e-mail.",
      "reset.RATE_LIMITED": "Vous avez fait trop de tentatives. Veuillez patienter un moment et réessayer.",
      "reset.MAIL_SEND_FAILED": "Un problème est survenu. Veuillez réessayer plus tard.",
      "reset.RESET_CODE_VALID": "Code vérifié.",
      "reset.INVALID_RESET_CODE": "Code incorrect. Veuillez réessayer.",
      "reset.EXPIRED_RESET_CODE": "Le code a expiré. Veuillez demander un nouveau code.",
      "reset.WEAK_PASSWORD": "Le mot de passe doit comporter au moins 6 caractères.",
      "reset.PASSWORD_RESET_SUCCESS": "Votre mot de passe a été mis à jour. Vous pouvez vous connecter avec votre nouveau mot de passe.",
      "reset.generic": "Un problème est survenu. Veuillez réessayer.",
      "login.resetSuccess": "Votre mot de passe a été mis à jour. Vous pouvez vous connecter avec votre nouveau mot de passe.",
      "store.nav.shop": "Boutique",
      "home.hero.title1": "Connectez-vous en quelques minutes,",
      "home.hero.title2": "restez au-delà des frontières.",
      "home.hero.subtitle": "Des forfaits eSIM fiables valables dans plus de 190 pays. Pas de SIM physique, pas de frais d'itinérance.",
      "home.search.placeholder": "Où voyagez-vous ?",
      "home.tabs.local": "eSIM locales",
      "home.tabs.regional": "eSIM régionales",
      "home.tabs.lifetime": "eSIM à vie",
      "home.empty": "Aucun résultat ne correspond à votre recherche.",
      "home.error.title": "Impossible de charger le contenu",
      "home.error.retry": "Réessayer",
      "home.from": "à partir de",
      "home.popular": "Destinations populaires",
      "home.coverage": "190+ pays · activation instantanée",
      "home.detail.soon": "Les forfaits de cette sélection seront bientôt listés ici.",
      "home.detail.back": "Retour à la boutique",
      "detail.plans": "Forfaits",
      "detail.count": "{{count}} forfait(s)",
      "detail.validity": "{{days}} jours",
      "detail.validityLifetime": "Sans expiration",
      "detail.buy": "Acheter",
      "detail.empty": "Il n'y a actuellement aucun forfait pour cette sélection.",
      "detail.checkoutSoon": "Le flux de paiement sera ajouté très prochainement.",
      "detail.loginToBuy": "Vous devez vous connecter pour acheter.",
      "detail.basicFeatures": "Caractéristiques de base",
      "detail.dataAmount": "Quantité de données",
      "detail.validityLabel": "Période de validité",
      "detail.coverageArea": "Zone de couverture",
      "detail.activationNetworks": "Activation et Réseaux",
      "detail.activationMethod": "Méthode d'activation",
      "detail.esimActivation": "eSIM — instantané avec code QR",
      "detail.supportedNetworks": "Réseaux pris en charge",
      "detail.description": "Description",
      "detail.price": "Prix",
      "authprompt.title": "Connectez-vous pour continuer",
      "authprompt.message": "Connectez-vous à votre compte pour acheter une eSIM ou créez un nouveau compte en quelques secondes.",
      "authprompt.close": "Fermer",
      "footer.tagline": "Une eSIM mondiale rapide, sécurisée et abordable. Connectez-vous à Internet dès votre atterrissage.",
      "footer.explore": "Explorer",
      "footer.support": "Support",
      "footer.legal": "Légal",
      "footer.shop": "Boutique",
      "footer.help": "Foire Aux Questions",
      "footer.terms": "Conditions d'Utilisation",
      "footer.rights": "© {{year}} Utkan eSIM. Tous droits réservés.",
      "footer.apps": "Télécharger l'application",
      "whatsapp.label": "Écrire sur WhatsApp",
      "whatsapp.message": "Bonjour, j'ai une demande de support eSIM.",
      "notfound.eyebrow": "AUCUN SIGNAL",
      "notfound.title": "Cette page est inaccessible",
      "notfound.message": "La page que vous recherchez a peut-être été déplacée ou n'a jamais existé. Laissez-nous vous ramener dans la zone de couverture.",
      "order.congrats": "Félicitations !",
      "order.message": "Votre eSIM est prête. Vous pouvez la configurer en quelques étapes avec le code QR ci-dessous.",
      "order.details": "Résumé de la commande",
      "order.activation": "Activation",
      "order.activationDesc": "Pour configurer votre eSIM, scannez le code QR avec l'appareil photo de votre appareil ou saisissez manuellement le code de configuration.",
      "order.qrTitle": "Code QR eSIM",
      "order.manualLabel": "Code de configuration",
      "order.copy": "Copier",
      "order.copied": "Copié",
      "order.howTo": "Comment l'activer ?",
      "order.step1": "Allez dans Réglages > Données cellulaires / mobiles > Ajouter une eSIM sur votre appareil.",
      "order.step2": "Sélectionnez « Utiliser un code QR » et scannez le code QR ci-dessus (ou saisissez manuellement le code de configuration).",
      "order.step3": "Une fois l'installation terminée, activez votre forfait eSIM.",
      "order.step4": "Assurez-vous que l'itinérance des données est activée — vous êtes maintenant connecté !",
      "order.cta": "Retour à la page d'accueil",
      "checkout.title": "Paiement",
      "checkout.summary": "Résumé de la commande",
      "checkout.total": "Total",
      "checkout.eurNote": "Le montant est facturé en euros (€) sur PayPal.",
      "checkout.processing": "Vérification de votre paiement…",
      "checkout.error": "Le paiement n'a pas pu être effectué. Veuillez réessayer.",
      "checkout.cancelled": "Paiement annulé.",
      "account.title": "Mon Compte",
      "account.tab.profile": "Profil",
      "account.tab.esims": "Mes eSIM",
      "account.tab.security": "Sécurité",
      "account.profile.title": "Informations du profil",
      "account.field.phone": "Téléphone",
      "account.field.phone.ph": "+90…",
      "account.memberSince": "Membre depuis",
      "account.save": "Enregistrer",
      "account.saving": "Enregistrement en cours…",
      "account.saved": "Vos informations ont été mises à jour.",
      "account.esims.title": "Mes eSIM",
      "account.esims.empty": "Vous n'avez pas encore d'eSIM.",
      "account.esims.emptyCta": "Parcourir la boutique",
      "account.esims.data": "Données",
      "account.esims.expires": "Date de fin",
      "account.esims.viewQr": "Afficher le code QR",
      "account.esims.hideQr": "Masquer le code QR",
      "account.esims.active": "Actif",
      "account.esims.passive": "Inactif",
      "account.esims.noActive": "Vous n'avez pas d'eSIM active.",
      "account.esims.noPassive": "Vous n'avez pas d'eSIM inactive.",
      "account.esims.readyHint": "Prêt à l'emploi — la durée commence à la première utilisation.",
      "account.esims.unavailableHint": "Le statut n'a pas pu être chargé pour le moment. Veuillez réessayer plus tard.",
      "esimStatus.active": "Actif",
      "esimStatus.readyToUse": "Prêt à l'emploi",
      "esimStatus.inactive": "Inactif",
      "esimStatus.unavailable": "Impossible de charger le statut",
      "account.security.title": "Changer le mot de passe",
      "account.field.oldPassword": "Mot de passe actuel",
      "account.field.newPassword": "Nouveau mot de passe",
      "account.field.confirmPassword": "Nouveau mot de passe (répéter)",
      "account.changePassword": "Mettre à jour le mot de passe",
      "account.passwordChanged": "Votre mot de passe a été mis à jour.",
      "account.error.passwordMismatch": "Les nouveaux mots de passe ne correspondent pas.",
      "account.danger.title": "Actions du compte",
      "account.delete": "Supprimer le compte",
      "account.delete.confirm": "Vous êtes sur le point de supprimer définitivement votre compte. Cette action est irréversible.",
      "account.delete.confirmBtn": "Oui, supprimer",
      "account.cancel": "Annuler",
      "esimDetail.back": "Retour",
      "esimDetail.dataUsage": "Utilisation des données",
      "esimDetail.left": "restant",
      "esimDetail.leftData": "Données restantes",
      "esimDetail.usedData": "Utilisé",
      "esimDetail.totalData": "Données totales",
      "esimDetail.qrDesc": "Configurez votre eSIM en scannant ce code QR avec l'appareil photo de votre appareil.",
      "esimDetail.validity": "Validité",
      "esimDetail.daysLeft": "{{days}} jour(s) restant(s)",
      "esimDetail.expired": "Expiré",
      "esimDetail.notYetActive": "Pas encore actif",
      "esimDetail.leftDate": "Temps restant",
      "esimDetail.activationDate": "Date d'activation",
      "esimDetail.endDate": "Date de fin",
      "esimDetail.technical": "Informations techniques",
      "esimDetail.activationCode": "Code d'activation (Android)",
      "esimDetail.smdp": "Adresse SM-DP+ (iOS)",
      "esimDetail.matchingId": "ID de correspondance (iOS)",
      "esimDetail.support": "Support technique",
      "esimDetail.supportDesc": "Un problème ? Laissez-nous vous aider.",
      "esimDetail.email": "Envoyer un e-mail",
      "guide.eyebrow": "GUIDE eSIM",
      "guide.title": "Qu'est-ce qu'une eSIM et comment l'installer ?",
      "guide.intro.title": "Qu'est-ce qu'une eSIM ?",
      "guide.intro.body": "L'eSIM est une SIM numérique intégrée à votre appareil qui fonctionne sans avoir besoin d'une carte SIM physique. Elle configure votre ligne en quelques secondes en scannant un code QR ; vous vous connectez à Internet dans plus de 190 pays sans changer de carte et sans frais d'itinérance.",
      "guide.steps.title": "Comment l'activer ?",
      "guide.devices.title": "Appareils pris en charge",
      "guide.devices.desc": "Votre appareil doit être compatible avec l'eSIM pour que l'eSIM fonctionne. Vérifiez votre marque.",
      "guide.faq.title": "Foire aux questions",
      "nav.guide": "Guide eSIM",
      "currency.label": "Devise",
      "staticPage.loading": "Chargement de la page...",
      "staticPage.errorTitle": "Une Erreur est Survenue",
      "staticPage.retry": "Réessayer",
      "staticPage.loadFailed": "Le contenu de la page n'a pas pu être chargé. Veuillez réessayer plus tard.",
      "last.updated": "Dernière mise à jour : 8 juillet 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "eSIM illimitées",
      "detail.unlimited": "Illimité",
      "detail.unlimitedNote": "Ce forfait n'a aucune limite de données — internet illimité pendant toute la durée de validité.",
      "detail.notPriced": "Ce forfait n'est pas disponible à l'achat sur le web pour le moment.",
      "checkout.priceUpdated": "Le prix de ce forfait a changé. Veuillez retourner à la boutique et le sélectionner à nouveau.",
      "order.pending.title": "Votre eSIM est en préparation",
      "order.pending.message": "Votre paiement a été accepté. Les forfaits illimités peuvent prendre quelques minutes à s'activer.",
      "order.pending.waiting": "Vérification du statut de votre commande…",
      "order.pending.ready": "Votre eSIM est prête !",
      "order.pending.timeout": "Cela prend plus de temps que prévu. Votre paiement est sécurisé — votre eSIM apparaîtra dans « Mes eSIM » dès qu'elle sera prête.",
      "order.pending.cta": "Aller à Mes eSIM",
      "account.esims.unlimited": "Illimité",
      "account.esims.unlimitedHint": "Données illimitées — ce forfait n'a aucune limite de données.",
      "esimDetail.unlimitedData": "Ce forfait n'a aucune limite de données ; voir le temps restant ci-dessous.",


      // Suppression de compte (/hesap-sil · /account-deletion) — exigence Google Play « Data deletion »
      "del.eyebrow": "Suppression de compte",
      "del.title": "Supprimer mon compte",
      "del.intro": "Vous pouvez supprimer définitivement votre compte Utkan eSIM et vos données personnelles ici. L'application n'est pas nécessaire — il suffit de vous connecter avec le compte à supprimer.",
      "del.deleted.title": "Données supprimées",
      "del.deleted.identity": "Vos nom, prénom, adresse e-mail et numéro de téléphone",
      "del.deleted.credentials": "Votre mot de passe et vos données de session",
      "del.deleted.codes": "Vos codes de vérification e-mail et de réinitialisation du mot de passe",
      "del.deleted.esim": "Votre numéro eSIM (MSISDN), votre code QR/d'activation et vos données d'utilisation",
      "del.kept.title": "Données conservées et pourquoi",
      "del.kept.orders": "Les justificatifs d'achat (numéro de commande, date, montant, statut du paiement) sont conservés pour répondre aux obligations fiscales et comptables. Ils ne contiennent ni votre nom, ni votre e-mail, ni vos informations de paiement — uniquement un identifiant qui ne peut pas vous être rattaché.",
      "del.kept.period": "Durée de conservation : 5 ans (loi turque sur la procédure fiscale, art. 253).",
      "del.warn.title": "Avant de supprimer",
      "del.warn.irreversible": "Cette action est irréversible.",
      "del.warn.esim": "Les eSIM actives continuent de fonctionner sur votre appareil, mais vous n'aurez plus accès à votre code QR ni à votre volume de données restant. Enregistrez votre code QR avant la suppression.",
      "del.warn.rejoin": "Vous pouvez vous réinscrire avec la même adresse e-mail, mais vos anciennes eSIM n'apparaîtront pas dans le nouveau compte.",
      "del.support": "Si vous ne parvenez pas à vous connecter, vous pouvez aussi demander la suppression par e-mail :",
      "del.login.title": "Connectez-vous d'abord",
      "del.login.subtitle": "Saisissez votre e-mail et votre mot de passe afin de confirmer que ce compte est bien le vôtre.",
      "del.login.action": "Se connecter",
      "del.login.loading": "Connexion...",
      "del.forgot": "Mot de passe oublié ?",
      "del.confirm.title": "Êtes-vous sûr ?",
      "del.confirm.subtitle": "Le compte {{email}} et vos données personnelles seront définitivement supprimés.",
      "del.confirm.field": "Saisissez à nouveau votre adresse e-mail pour confirmer",
      "del.confirm.action": "Supprimer définitivement mon compte",
      "del.confirm.deleting": "Suppression...",
      "del.confirm.cancel": "Annuler",
      "del.done.title": "Votre compte a été supprimé",
      "del.done.body": "Vos données personnelles ont été définitivement supprimées.",
      "del.done.retained": "Vos données personnelles ont été définitivement supprimées. {{n}} justificatif(s) d'achat ont été conservés pour des raisons légales ; ils ne peuvent pas vous être rattachés.",
      "del.done.home": "Retour à la boutique",
      "del.error.required": "Veuillez saisir votre e-mail et votre mot de passe.",
      "del.error.credentials": "E-mail ou mot de passe incorrect.",
      "del.error.suspended": "Votre compte a été suspendu. Veuillez contacter le support.",
      "del.error.session": "Votre session a expiré. Veuillez vous reconnecter.",
      "del.error.network": "Connexion impossible. Vérifiez votre connexion Internet et réessayez.",
      "del.error.generic": "Une erreur s'est produite. Veuillez réessayer.",
      "footer.deleteAccount": "Supprimer mon compte",


      // Forfaits voix (données + appels et SMS illimités) — docs/ses-paketleri.md
      "home.tabs.voice": "eSIM avec appels",
      "detail.voice": "Appels + SMS",
      "detail.voiceNote": "Ce forfait inclut les appels et SMS illimités en plus des données : une seule eSIM pour Internet et les appels.",
      "detail.calls": "Appels",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Appels illimités",
      "plan.unlimitedSms": "SMS illimités",
      "plan.minutes": "{{n}} min d'appels",
      "plan.sms": "{{n}} SMS",
      "loading": "Chargement..."
    }
  },
  es: {
    translation: {

      "hero.title": "Utkan eSIM",
      "hero.subtitle": "El Futuro de la Conectividad Digital",
      "hero.description": "Eliminamos las fronteras con una experiencia de conectividad digital de nueva generación.",
      "hero.description2": "Soluciones eSIM rápidas, seguras y asequibles en todo el mundo.",
      "features.countries": "150+ Países",
      "features.activation": "Activación Instantánea",
      "features.support": "Soporte 24/7",
      "countdown.title": "¡Nuestro Sitio Web Próximamente!",
      "countdown.days": "Días",
      "countdown.hours": "Horas",
      "countdown.minutes": "Minutos",
      "countdown.seconds": "Segundos",
      "countdown.launch": "¡Nuestro Sitio Web Está Abierto!",
      "countdown.loading": "Cargando...",
      "apps.title": "Nuestras Aplicaciones Móviles",
      "apps.ios.label": "Descárgalo en la",
      "apps.ios.name": "App Store",
      "apps.android.label": "DISPONIBLE EN",
      "apps.android.name": "Google Play",
      "contact.title": "Contáctenos antes del lanzamiento",
      "contact.whatsapp": "WhatsApp: +43 676 555 1 333",
      "contact.email": "Correo electrónico: info@utkanesim.com",
      "about.hero.title": "Acerca de Utkan eSIM",
      "about.hero.description": "La seguridad de sus datos personales es muy importante para nosotros. Esta política explica cómo se recopilan, utilizan y protegen sus datos.",
      "about.story.title": "Nuestra Historia",
      "about.story.content": "Fundada en 2024 por un equipo de viajeros apasionados y entusiastas de la tecnología, Utkan eSIM tiene como objetivo revolucionar la forma en que las personas se conectan a Internet en el extranjero. Al ofrecer planes de datos eSIM confiables y de alta calidad para más de 190 países y regiones, garantizamos su acceso rápido a Internet desde el momento en que aterriza.",
      "about.mission.title": "Nuestra Misión",
      "about.mission.content": "Proporcionar a los viajeros una conectividad global simple, asequible e instantánea, permitiéndoles explorar, trabajar y mantenerse conectados sin fronteras.",
      "about.vision.title": "Nuestra Visión",
      "about.vision.content": "Ser la principal plataforma global de soluciones de conectividad digital, haciendo del mundo un lugar más pequeño y más conectado para todos.",
      "about.features.title": "¿Por Qué Elegirnos?",
      "about.features.instant.title": "Entrega Instantánea",
      "about.features.instant.content": "Obtenga su eSIM al instante con un código QR después de la compra.",
      "about.features.global.title": "Cobertura Global",
      "about.features.global.content": "Planes de datos para más de 190 países y regiones.",
      "about.features.affordable.title": "Precios Asequibles",
      "about.features.affordable.content": "Ahorre hasta un 90% en tarifas de roaming.",
      "about.features.support.title": "Soporte 24/7",
      "about.features.support.content": "Nuestro equipo de soporte dedicado siempre está a su disposición.",
      "about.features.secure.title": "Conexión Segura",
      "about.features.secure.content": "Conexión protegida por los últimos protocolos de seguridad.",
      "about.features.fast.title": "Internet Rápido",
      "about.features.fast.content": "Experiencia de Internet ininterrumpida a velocidades 4G/5G.",
      "about.cta.title": "Únase al Futuro de la Conectividad Digital",
      "about.cta.content": "Gracias por elegir Utkan eSIM. ¡Buen viaje!",
      "about.cta.whatsapp": "Contactar vía WhatsApp",
      "about.cta.email": "Enviar un Correo Electrónico",
      "contact.hero.title": "Contáctenos",
      "contact.hero.description": "Si tiene preguntas sobre nuestras eSIM, necesita soporte técnico o simplemente desea dejar un comentario, estaremos encantados de escucharle.",
      "contact.info.title": "Nuestra Información de Contacto",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Soporte Rápido 24/7",
      "contact.email.title": "Correo Electrónico",
      "contact.email.subtitle": "Contacto General",
      "contact.support.title": "Soporte Técnico",
      "contact.support.subtitle": "Problemas con eSIM",
      "contact.business.title": "Asociación Comercial",
      "contact.business.subtitle": "Contacto Corporativo",
      "contact.hours.title": "Horario de Soporte",
      "contact.hours.subtitle": "Soporte Técnico 24/7",
      "contact.hours.detail": "Lunes - Domingo: 00:00 - 23:59",
      "contact.form.title": "Enviar un Mensaje",
      "contact.form.name": "Nombre y Apellido",
      "contact.form.name.placeholder": "Ingrese su nombre y apellido",
      "contact.form.email": "Su Dirección de Correo Electrónico",
      "contact.form.email.placeholder": "ejemplo@email.com",
      "contact.form.subject": "Asunto",
      "contact.form.subject.placeholder": "Seleccione un asunto",
      "contact.form.subject.general": "Información General",
      "contact.form.subject.technical": "Soporte Técnico",
      "contact.form.subject.billing": "Preguntas de Facturación",
      "contact.form.subject.partnership": "Asociación Comercial",
      "contact.form.subject.feedback": "Comentarios",
      "contact.form.message": "Su Mensaje",
      "contact.form.message.placeholder": "Escriba su mensaje aquí...",
      "contact.form.submit": "Enviar Mensaje",
      "contact.faq.title": "Preguntas Frecuentes",
      "contact.faq.esim.title": "¿Cómo funciona la eSIM?",
      "contact.faq.esim.content": "La eSIM es una tarjeta SIM digital que funciona en su teléfono sin necesidad de una tarjeta SIM física. Se activa al instante con un código QR.",
      "contact.faq.phones.title": "¿Qué teléfonos son compatibles con eSIM?",
      "contact.faq.phones.content": "Los modelos iPhone XS y superiores, Samsung Galaxy S20 y superiores, y Google Pixel 3 y superiores son compatibles con eSIM.",
      "contact.faq.validity.title": "¿Por cuánto tiempo es válido mi plan de datos?",
      "contact.faq.validity.content": "El período de validez de los planes varía de 1 a 30 días según el plan que elija.",
      "contact.faq.payment.title": "¿Cómo se realiza el pago?",
      "contact.faq.payment.content": "Puede pagar de forma segura con tarjeta de crédito, PayPal y transferencia bancaria.",
      "privacy.hero.title": "Política de Privacidad",
      "privacy.hero.description": "La seguridad de sus datos personales es muy importante para nosotros. Esta política explica cómo se recopilan, utilizan y protegen sus datos.",
      "privacy.overview.title": "Descripción General",
      "privacy.overview.content": "Esta Política de Privacidad describe nuestras políticas y procedimientos sobre la recopilación, el uso y la divulgación de su información cuando utiliza nuestro Servicio. También le informa sobre sus derechos de privacidad y cómo la ley lo protege.",
      "privacy.data.title": "Datos que Recopilamos",
      "privacy.data.personal.title": "Información Personal",
      "privacy.data.personal.name": "Nombre y apellido",
      "privacy.data.personal.email": "Dirección de correo electrónico",
      "privacy.data.personal.phone": "Número de teléfono",
      "privacy.data.personal.payment": "Información de pago",
      "privacy.data.usage.title": "Datos de Uso",
      "privacy.data.usage.ip": "Dirección IP",
      "privacy.data.usage.browser": "Tipo de navegador",
      "privacy.data.usage.device": "Información del dispositivo",
      "privacy.data.usage.stats": "Estadísticas de uso",
      "privacy.security.title": "Seguridad de los Datos",
      "privacy.security.ssl.title": "Cifrado SSL",
      "privacy.security.ssl.content": "Todas las transferencias de datos están protegidas con cifrado SSL de 256 bits.",
      "privacy.security.servers.title": "Servidores Seguros",
      "privacy.security.servers.content": "Sus datos se almacenan en servidores seguros con certificación ISO 27001.",
      "privacy.security.access.title": "Control de Acceso",
      "privacy.security.access.content": "Solo el personal autorizado puede acceder a sus datos.",
      "privacy.usage.title": "Uso de los Datos",
      "privacy.usage.intro": "Utilizamos los datos que recopilamos para los siguientes propósitos:",
      "privacy.usage.service.title": "Prestación de Servicios",
      "privacy.usage.service.content": "Para proporcionar y gestionar nuestros servicios eSIM",
      "privacy.usage.support.title": "Soporte al Cliente",
      "privacy.usage.support.content": "Para proporcionar soporte técnico y servicio al cliente",
      "privacy.usage.security.title": "Seguridad",
      "privacy.usage.security.content": "Para proteger su cuenta y nuestros servicios",
      "privacy.usage.improvement.title": "Mejora",
      "privacy.usage.improvement.content": "Para mejorar nuestros servicios y añadir nuevas funciones",
      "privacy.sharing.title": "Intercambio de Datos",
      "privacy.sharing.intro": "No compartimos sus datos personales con terceros, pero puede ser necesario compartirlos en los siguientes casos:",
      "privacy.sharing.legal": "En caso de obligación legal",
      "privacy.sharing.providers": "Con nuestros proveedores de servicios (como procesadores de pagos)",
      "privacy.sharing.threats": "Para prevenir amenazas a la seguridad",
      "privacy.sharing.consent": "Con su consentimiento explícito",
      "privacy.rights.title": "Sus Derechos",
      "privacy.rights.access.title": "Derecho de Acceso",
      "privacy.rights.access.content": "Puede solicitar acceso a los datos que tenemos sobre usted.",
      "privacy.rights.correction.title": "Derecho de Rectificación",
      "privacy.rights.correction.content": "Podemos corregir sus datos inexactos o incompletos.",
      "privacy.rights.deletion.title": "Derecho de Supresión",
      "privacy.rights.deletion.content": "Podemos eliminar sus datos bajo ciertas condiciones.",
      "privacy.rights.objection.title": "Derecho de Oposición",
      "privacy.rights.objection.content": "Puede oponerse a nuestras actividades de procesamiento de datos.",
      "privacy.contact.title": "Contacto",
      "privacy.contact.intro": "Si tiene alguna pregunta sobre esta Política de Privacidad, puede contactarnos a través de los siguientes canales:",
      "nav.about": "Acerca de",
      "nav.contact": "Contacto",
      "nav.privacy": "Privacidad",
      "nav.login": "Iniciar Sesión",
      "nav.account": "Mi Cuenta",
      "nav.logout": "Cerrar Sesión",
      "auth.brand.eyebrow": "COBERTURA GLOBAL",
      "auth.brand.title": "Internet en el momento en que aterrizas en más de 150 países.",
      "auth.brand.subtitle": "Sin SIM física, sin facturas de roaming. Activa tu eSIM en segundos.",
      "auth.login.eyebrow": "INICIAR SESIÓN EN LA CUENTA",
      "auth.login.title": "Bienvenido de nuevo",
      "auth.login.subtitle": "Gestiona tus eSIM y descubre nuevas.",
      "auth.signup.eyebrow": "NUEVA CUENTA",
      "auth.signup.title": "Únete a nosotros",
      "auth.signup.subtitle": "Prepara tu primera eSIM en unos pocos pasos.",
      "auth.field.identifier": "Correo electrónico o teléfono",
      "auth.field.identifier.ph": "ejemplo@email.com o +34…",
      "auth.field.email": "Correo electrónico",
      "auth.field.email.ph": "ejemplo@email.com",
      "auth.field.fullName": "Nombre y apellido",
      "auth.field.fullName.ph": "Tu nombre y apellido",
      "auth.field.password": "Contraseña",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Iniciar sesión",
      "auth.action.loggingIn": "Iniciando sesión…",
      "auth.action.signup": "Crear cuenta",
      "auth.action.signingUp": "Creando cuenta…",
      "auth.toSignup.q": "¿No tienes cuenta?",
      "auth.toSignup.link": "Regístrate",
      "auth.toLogin.q": "¿Ya tienes una cuenta?",
      "auth.toLogin.link": "Inicia sesión",
      "auth.password.show": "Mostrar contraseña",
      "auth.password.hide": "Ocultar contraseña",
      "auth.terms.prefix": "Al continuar, acepto los ",
      "auth.terms.link": "Términos de Uso y la Política de Privacidad",
      "auth.terms.suffix": ".",
      "auth.error.required": "Por favor, completa los campos requeridos.",
      "auth.error.terms": "Debes aceptar los términos para continuar.",
      "verify.eyebrow": "VERIFICACIÓN DE CORREO ELECTRÓNICO",
      "verify.title": "Verifica tu correo electrónico",
      "verify.subtitle": "Hemos enviado un código de 6 dígitos a {{email}}. Ingresa el código para verificar.",
      "verify.code": "Código de verificación",
      "verify.code.ph": "••••••",
      "verify.action": "Verificar",
      "verify.verifying": "Verificando…",
      "verify.resend": "Reenviar código",
      "verify.resendIn": "Reenviar en {{seconds}} s",
      "verify.resent": "Nuevo código enviado.",
      "verify.skip": "Omitir por ahora",
      "auth.forgot.link": "¿Olvidaste tu contraseña?",
      "forgot.eyebrow": "RESTABLECIMIENTO DE CONTRASEÑA",
      "forgot.email.title": "Restablece tu contraseña",
      "forgot.email.subtitle": "Ingresa la dirección de correo electrónico de tu cuenta; te enviaremos un código de restablecimiento de 6 dígitos.",
      "forgot.email.action": "Enviar código",
      "forgot.email.sending": "Enviando…",
      "forgot.reset.title": "Establece tu nueva contraseña",
      "forgot.reset.subtitle": "Ingresa el código de 6 dígitos que enviamos a {{email}} y tu nueva contraseña.",
      "forgot.reset.action": "Actualizar contraseña",
      "forgot.reset.updating": "Actualizando…",
      "forgot.field.code": "Código de restablecimiento",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Nueva contraseña",
      "forgot.field.newPassword.ph": "Al menos 6 caracteres",
      "forgot.resend": "Reenviar código",
      "forgot.resendIn": "Reenviar en {{seconds}} s",
      "forgot.resent": "Nuevo código enviado.",
      "forgot.backToLogin": "Volver al inicio de sesión",
      "forgot.changeEmail": "Cambiar correo electrónico",
      "forgot.help.noMail": "Si no llegó el código, revisa tu carpeta de spam o verifica tu dirección de correo electrónico.",
      "reset.RESET_CODE_SENT": "Código enviado. Por favor, revisa tu correo electrónico.",
      "reset.RATE_LIMITED": "Has realizado demasiados intentos. Por favor, espera un momento y vuelve a intentarlo.",
      "reset.MAIL_SEND_FAILED": "Algo salió mal. Por favor, inténtalo de nuevo más tarde.",
      "reset.RESET_CODE_VALID": "Código verificado.",
      "reset.INVALID_RESET_CODE": "Código incorrecto. Por favor, inténtalo de nuevo.",
      "reset.EXPIRED_RESET_CODE": "El código ha expirado. Por favor, solicita un nuevo código.",
      "reset.WEAK_PASSWORD": "La contraseña debe tener al menos 6 caracteres.",
      "reset.PASSWORD_RESET_SUCCESS": "Tu contraseña ha sido actualizada. Puedes iniciar sesión con tu nueva contraseña.",
      "reset.generic": "Algo salió mal. Por favor, inténtalo de nuevo.",
      "login.resetSuccess": "Tu contraseña ha sido actualizada. Puedes iniciar sesión con tu nueva contraseña.",
      "store.nav.shop": "Tienda",
      "home.hero.title1": "Conéctate en unos minutos,",
      "home.hero.title2": "mantente más allá de las fronteras.",
      "home.hero.subtitle": "Planes eSIM confiables válidos en más de 190 países. Sin SIM física, sin facturas de roaming.",
      "home.search.placeholder": "¿A dónde viajas?",
      "home.tabs.local": "eSIMs locales",
      "home.tabs.regional": "eSIMs regionales",
      "home.tabs.lifetime": "eSIMs de por vida",
      "home.empty": "No se encontraron resultados que coincidan con su búsqueda.",
      "home.error.title": "No se pudo cargar el contenido",
      "home.error.retry": "Reintentar",
      "home.from": "desde",
      "home.popular": "Destinos populares",
      "home.coverage": "190+ países · activación instantánea",
      "home.detail.soon": "Los planes para esta selección se listarán aquí muy pronto.",
      "home.detail.back": "Volver a la tienda",
      "detail.plans": "Planes",
      "detail.count": "{{count}} plan(es)",
      "detail.validity": "{{days}} días",
      "detail.validityLifetime": "Sin caducidad",
      "detail.buy": "Comprar",
      "detail.empty": "Actualmente no hay planes para esta selección.",
      "detail.checkoutSoon": "El flujo de pago se añadirá muy pronto.",
      "detail.loginToBuy": "Debes iniciar sesión para comprar.",
      "detail.basicFeatures": "Características básicas",
      "detail.dataAmount": "Cantidad de datos",
      "detail.validityLabel": "Período de validez",
      "detail.coverageArea": "Área de cobertura",
      "detail.activationNetworks": "Activación y Redes",
      "detail.activationMethod": "Método de activación",
      "detail.esimActivation": "eSIM — instantáneo con código QR",
      "detail.supportedNetworks": "Redes compatibles",
      "detail.description": "Descripción",
      "detail.price": "Precio",
      "authprompt.title": "Inicia sesión para continuar",
      "authprompt.message": "Inicia sesión en tu cuenta para comprar una eSIM o crea una cuenta nueva en segundos.",
      "authprompt.close": "Cerrar",
      "footer.tagline": "eSIM rápida, segura y asequible en todo el mundo. Conéctate a Internet en cuanto aterrices.",
      "footer.explore": "Explorar",
      "footer.support": "Soporte",
      "footer.legal": "Legal",
      "footer.shop": "Tienda",
      "footer.help": "Preguntas Frecuentes",
      "footer.terms": "Términos de Uso",
      "footer.rights": "© {{year}} Utkan eSIM. Todos los derechos reservados.",
      "footer.apps": "Descargar la aplicación",
      "whatsapp.label": "Escribir por WhatsApp",
      "whatsapp.message": "Hola, tengo una solicitud de soporte para eSIM.",
      "notfound.eyebrow": "SIN SEÑAL",
      "notfound.title": "Esta página no está disponible",
      "notfound.message": "La página que buscas puede haber sido movida o nunca existió. Te llevaremos de vuelta al área de cobertura.",
      "order.congrats": "¡Felicidades!",
      "order.message": "Tu eSIM está lista. Puedes configurarla en unos pocos pasos con el código QR a continuación.",
      "order.details": "Resumen del pedido",
      "order.activation": "Activación",
      "order.activationDesc": "Para configurar tu eSIM, escanea el código QR con la cámara de tu dispositivo o ingresa manualmente el código de configuración.",
      "order.qrTitle": "Código QR de eSIM",
      "order.manualLabel": "Código de configuración",
      "order.copy": "Copiar",
      "order.copied": "Copiado",
      "order.howTo": "¿Cómo activarlo?",
      "order.step1": "Ve a Configuración > Datos celulares / móviles > Agregar eSIM en tu dispositivo.",
      "order.step2": "Selecciona \"Usar código QR\" y escanea el código QR de arriba (o ingresa manualmente el código de configuración).",
      "order.step3": "Una vez completada la instalación, activa tu plan eSIM.",
      "order.step4": "Asegúrate de que la itinerancia de datos esté activada — ¡ya estás conectado!",
      "order.cta": "Volver a la página principal",
      "checkout.title": "Pago",
      "checkout.summary": "Resumen del pedido",
      "checkout.total": "Total",
      "checkout.eurNote": "El monto se cobra en euros (€) en PayPal.",
      "checkout.processing": "Verificando tu pago…",
      "checkout.error": "No se pudo completar el pago. Por favor, inténtalo de nuevo.",
      "checkout.cancelled": "Pago cancelado.",
      "account.title": "Mi Cuenta",
      "account.tab.profile": "Perfil",
      "account.tab.esims": "Mis eSIMs",
      "account.tab.security": "Seguridad",
      "account.profile.title": "Información del perfil",
      "account.field.phone": "Teléfono",
      "account.field.phone.ph": "+34…",
      "account.memberSince": "Miembro desde",
      "account.save": "Guardar",
      "account.saving": "Guardando…",
      "account.saved": "Tu información ha sido actualizada.",
      "account.esims.title": "Mis eSIMs",
      "account.esims.empty": "Aún no tienes una eSIM.",
      "account.esims.emptyCta": "Explorar la tienda",
      "account.esims.data": "Datos",
      "account.esims.expires": "Fecha de finalización",
      "account.esims.viewQr": "Mostrar código QR",
      "account.esims.hideQr": "Ocultar código QR",
      "account.esims.active": "Activo",
      "account.esims.passive": "Inactivo",
      "account.esims.noActive": "No tienes eSIMs activas.",
      "account.esims.noPassive": "No tienes eSIMs inactivas.",
      "account.esims.readyHint": "Listo para usar — la duración comienza en el primer uso.",
      "account.esims.unavailableHint": "No se pudo cargar el estado en este momento. Inténtalo de nuevo más tarde.",
      "esimStatus.active": "Activo",
      "esimStatus.readyToUse": "Listo para usar",
      "esimStatus.inactive": "Inactivo",
      "esimStatus.unavailable": "No se pudo cargar el estado",
      "account.security.title": "Cambiar contraseña",
      "account.field.oldPassword": "Contraseña actual",
      "account.field.newPassword": "Nueva contraseña",
      "account.field.confirmPassword": "Nueva contraseña (repetir)",
      "account.changePassword": "Actualizar contraseña",
      "account.passwordChanged": "Tu contraseña ha sido actualizada.",
      "account.error.passwordMismatch": "Las nuevas contraseñas no coinciden.",
      "account.danger.title": "Acciones de la cuenta",
      "account.delete": "Eliminar cuenta",
      "account.delete.confirm": "Estás a punto de eliminar tu cuenta de forma permanente. Esta acción no se puede deshacer.",
      "account.delete.confirmBtn": "Sí, eliminar",
      "account.cancel": "Cancelar",
      "esimDetail.back": "Volver",
      "esimDetail.dataUsage": "Uso de datos",
      "esimDetail.left": "restante",
      "esimDetail.leftData": "Datos restantes",
      "esimDetail.usedData": "Usado",
      "esimDetail.totalData": "Datos totales",
      "esimDetail.qrDesc": "Configura tu eSIM escaneando este código QR con la cámara de tu dispositivo.",
      "esimDetail.validity": "Validez",
      "esimDetail.daysLeft": "{{days}} día(s) restante(s)",
      "esimDetail.expired": "Expirado",
      "esimDetail.notYetActive": "Aún no activo",
      "esimDetail.leftDate": "Tiempo restante",
      "esimDetail.activationDate": "Fecha de activación",
      "esimDetail.endDate": "Fecha de finalización",
      "esimDetail.technical": "Información técnica",
      "esimDetail.activationCode": "Código de activación (Android)",
      "esimDetail.smdp": "Dirección SM-DP+ (iOS)",
      "esimDetail.matchingId": "ID de coincidencia (iOS)",
      "esimDetail.support": "Soporte técnico",
      "esimDetail.supportDesc": "¿Tienes algún problema? Déjanos ayudarte.",
      "esimDetail.email": "Enviar un correo electrónico",
      "guide.eyebrow": "GUÍA DE eSIM",
      "guide.title": "¿Qué es una eSIM y cómo instalarla?",
      "guide.intro.title": "¿Qué es una eSIM?",
      "guide.intro.body": "Una eSIM es una SIM digital integrada en tu dispositivo que funciona sin necesidad de una tarjeta SIM física. Configura tu línea en segundos escaneando un código QR; te conectas a Internet en más de 190 países sin cambiar de tarjeta y sin facturas de roaming.",
      "guide.steps.title": "¿Cómo activarla?",
      "guide.devices.title": "Dispositivos compatibles",
      "guide.devices.desc": "Tu dispositivo debe ser compatible con eSIM para que funcione. Revisa tu marca.",
      "guide.faq.title": "Preguntas frecuentes",
      "nav.guide": "Guía de eSIM",
      "currency.label": "Moneda",
      "staticPage.loading": "Cargando página...",
      "staticPage.errorTitle": "Se Produjo un Error",
      "staticPage.retry": "Reintentar",
      "staticPage.loadFailed": "No se pudo cargar el contenido de la página. Por favor, inténtelo de nuevo más tarde.",
      "last.updated": "Última actualización: 8 de julio de 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "eSIM ilimitadas",
      "detail.unlimited": "Ilimitado",
      "detail.unlimitedNote": "Este paquete no tiene límite de datos: internet ilimitado durante toda la validez.",
      "detail.notPriced": "Este paquete no está disponible para compra web en este momento.",
      "checkout.priceUpdated": "El precio de este paquete ha cambiado. Vuelve a la tienda y selecciónalo de nuevo.",
      "order.pending.title": "Tu eSIM se está preparando",
      "order.pending.message": "Tu pago se ha completado. Los paquetes ilimitados pueden tardar unos minutos en activarse.",
      "order.pending.waiting": "Comprobando el estado de tu pedido…",
      "order.pending.ready": "¡Tu eSIM está lista!",
      "order.pending.timeout": "Está tardando más de lo previsto. Tu pago está seguro: tu eSIM aparecerá en «Mis eSIM» en cuanto esté lista.",
      "order.pending.cta": "Ir a Mis eSIM",
      "account.esims.unlimited": "Ilimitado",
      "account.esims.unlimitedHint": "Datos ilimitados: este paquete no tiene límite de datos.",
      "esimDetail.unlimitedData": "Este paquete no tiene límite de datos; consulta el tiempo restante abajo.",


      // Eliminación de cuenta (/hesap-sil · /account-deletion) — requisito de Google Play «Data deletion»
      "del.eyebrow": "Eliminación de cuenta",
      "del.title": "Eliminar mi cuenta",
      "del.intro": "Aquí puedes eliminar de forma permanente tu cuenta de Utkan eSIM y tus datos personales. No necesitas tener la aplicación instalada: basta con iniciar sesión con la cuenta que quieres eliminar.",
      "del.deleted.title": "Datos que se eliminan",
      "del.deleted.identity": "Tu nombre, apellidos, dirección de correo electrónico y número de teléfono",
      "del.deleted.credentials": "Tu contraseña y los datos de sesión",
      "del.deleted.codes": "Tus códigos de verificación de correo y de restablecimiento de contraseña",
      "del.deleted.esim": "Tu número de eSIM (MSISDN), tu código QR/de activación y tus datos de uso",
      "del.kept.title": "Datos que conservamos y por qué",
      "del.kept.orders": "Los registros de compra (número de pedido, fecha, importe, estado del pago) se conservan por obligaciones fiscales y contables. No contienen tu nombre, tu correo ni tus datos de pago: solo un identificador que no puede vincularse contigo.",
      "del.kept.period": "Plazo de conservación: 5 años (Ley de Procedimiento Tributario de Turquía, art. 253).",
      "del.warn.title": "Antes de eliminar",
      "del.warn.irreversible": "Esta acción no se puede deshacer.",
      "del.warn.esim": "Las eSIM activas seguirán funcionando en tu dispositivo, pero ya no podrás acceder a tu código QR ni a los datos restantes. Guarda tu código QR antes de eliminar la cuenta.",
      "del.warn.rejoin": "Puedes registrarte de nuevo con el mismo correo, pero tus eSIM anteriores no aparecerán en la nueva cuenta.",
      "del.support": "Si no puedes iniciar sesión, también puedes solicitar la eliminación por correo electrónico:",
      "del.login.title": "Primero inicia sesión",
      "del.login.subtitle": "Introduce tu correo y contraseña para confirmar que la cuenta es tuya.",
      "del.login.action": "Iniciar sesión",
      "del.login.loading": "Iniciando sesión...",
      "del.forgot": "¿Olvidaste tu contraseña?",
      "del.confirm.title": "¿Estás seguro?",
      "del.confirm.subtitle": "La cuenta {{email}} y tus datos personales se eliminarán de forma permanente.",
      "del.confirm.field": "Escribe de nuevo tu correo electrónico para confirmar",
      "del.confirm.action": "Eliminar mi cuenta permanentemente",
      "del.confirm.deleting": "Eliminando...",
      "del.confirm.cancel": "Cancelar",
      "del.done.title": "Tu cuenta ha sido eliminada",
      "del.done.body": "Tus datos personales se han eliminado de forma permanente.",
      "del.done.retained": "Tus datos personales se han eliminado de forma permanente. Se conservaron {{n}} registro(s) de compra por obligaciones legales; no pueden vincularse contigo.",
      "del.done.home": "Volver a la tienda",
      "del.error.required": "Introduce tu correo y tu contraseña.",
      "del.error.credentials": "Correo o contraseña incorrectos.",
      "del.error.suspended": "Tu cuenta ha sido suspendida. Ponte en contacto con el soporte.",
      "del.error.session": "Tu sesión ha caducado. Inicia sesión de nuevo.",
      "del.error.network": "No se pudo conectar. Comprueba tu conexión a Internet e inténtalo de nuevo.",
      "del.error.generic": "Se ha producido un error. Inténtalo de nuevo.",
      "footer.deleteAccount": "Eliminar cuenta",


      // Planes de voz (datos + llamadas y SMS ilimitados) — docs/ses-paketleri.md
      "home.tabs.voice": "eSIM con llamadas",
      "detail.voice": "Llamadas + SMS",
      "detail.voiceNote": "Este plan incluye llamadas y SMS ilimitados además de los datos: una sola eSIM para internet y llamadas.",
      "detail.calls": "Llamadas",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Llamadas ilimitadas",
      "plan.unlimitedSms": "SMS ilimitados",
      "plan.minutes": "{{n}} min de llamadas",
      "plan.sms": "{{n}} SMS",
      "loading": "Cargando..."
    }
  },
  pt: {
    translation: {
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "O Futuro da Conectividade Digital",
      "hero.description": "Eliminamos as fronteiras com uma experiência de conectividade digital de nova geração.",
      "hero.description2": "Soluções eSIM rápidas, seguras e acessíveis em todo o mundo.",
      "features.countries": "150+ Países",
      "features.activation": "Ativação Instantânea",
      "features.support": "Suporte 24/7",
      "countdown.title": "O Nosso Site Chegará em Breve!",
      "countdown.days": "Dias",
      "countdown.hours": "Horas",
      "countdown.minutes": "Minutos",
      "countdown.seconds": "Segundos",
      "countdown.launch": "O Nosso Site Foi Lançado!",
      "countdown.loading": "A carregar...",
      "apps.title": "As Nossas Aplicações Móveis",
      "apps.ios.label": "Descarregar na",
      "apps.ios.name": "App Store",
      "apps.android.label": "DISPONÍVEL NO",
      "apps.android.name": "Google Play",
      "contact.title": "Contacte-nos Antes do Lançamento",
      "contact.whatsapp": "WhatsApp: +43 676 555 1 333",
      "contact.email": "E-mail: info@utkanesim.com",
      "about.hero.title": "Sobre a Utkan eSIM",
      "about.hero.description": "A segurança dos seus dados pessoais é muito importante para nós. Esta política explica como os seus dados são recolhidos, utilizados e protegidos.",
      "about.story.title": "A Nossa História",
      "about.story.content": "Fundada em 2024 por uma equipa de viajantes apaixonados e entusiastas da tecnologia, a Utkan eSIM tem como objetivo revolucionar a forma como as pessoas se ligam à Internet no estrangeiro. Ao oferecer planos de dados eSIM fiáveis e de alta qualidade para mais de 190 países e regiões, garantimos o seu acesso rápido à Internet desde o momento em que aterra.",
      "about.mission.title": "A Nossa Missão",
      "about.mission.content": "Fornecer aos viajantes conectividade global simples, acessível e instantânea, permitindo-lhes explorar, trabalhar e manterem-se ligados sem fronteiras.",
      "about.vision.title": "A Nossa Visão",
      "about.vision.content": "Ser a principal plataforma global de soluções de conectividade digital, tornando o mundo num lugar mais pequeno e mais ligado para todos.",
      "about.features.title": "Porquê Escolher-nos?",
      "about.features.instant.title": "Entrega Instantânea",
      "about.features.instant.content": "Obtenha o seu eSIM instantaneamente com um código QR após a compra.",
      "about.features.global.title": "Cobertura Global",
      "about.features.global.content": "Planos de dados para mais de 190 países e regiões.",
      "about.features.affordable.title": "Preços Acessíveis",
      "about.features.affordable.content": "Poupe até 90% nas taxas de roaming.",
      "about.features.support.title": "Suporte 24/7",
      "about.features.support.content": "A nossa equipa de suporte dedicada está sempre à sua disposição.",
      "about.features.secure.title": "Ligação Segura",
      "about.features.secure.content": "Ligação protegida pelos mais recentes protocolos de segurança.",
      "about.features.fast.title": "Internet Rápida",
      "about.features.fast.content": "Experiência de Internet ininterrupta a velocidades 4G/5G.",
      "about.cta.title": "Junte-se ao Futuro da Conectividade Digital",
      "about.cta.content": "Obrigado por escolher a Utkan eSIM. Boa viagem!",
      "about.cta.whatsapp": "Contactar via WhatsApp",
      "about.cta.email": "Enviar E-mail",
      "contact.hero.title": "Contacte-nos",
      "contact.hero.description": "Se tiver dúvidas sobre os nossos eSIMs, precisar de suporte técnico ou apenas quiser deixar a sua opinião, teremos todo o gosto em ouvi-lo.",
      "contact.info.title": "As Nossas Informações de Contacto",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Suporte Rápido 24/7",
      "contact.email.title": "E-mail",
      "contact.email.subtitle": "Contacto Geral",
      "contact.support.title": "Suporte Técnico",
      "contact.support.subtitle": "Problemas de eSIM",
      "contact.business.title": "Parceria Comercial",
      "contact.business.subtitle": "Contacto Empresarial",
      "contact.hours.title": "Horário de Suporte",
      "contact.hours.subtitle": "Suporte Técnico 24/7",
      "contact.hours.detail": "Segunda - Domingo: 00:00 - 23:59",
      "contact.form.title": "Enviar Mensagem",
      "contact.form.name": "Nome e Apelido",
      "contact.form.name.placeholder": "Introduza o seu nome e apelido",
      "contact.form.email": "O Seu Endereço de E-mail",
      "contact.form.email.placeholder": "exemplo@email.com",
      "contact.form.subject": "Assunto",
      "contact.form.subject.placeholder": "Selecione um assunto",
      "contact.form.subject.general": "Informação Geral",
      "contact.form.subject.technical": "Suporte Técnico",
      "contact.form.subject.billing": "Questões de Faturação",
      "contact.form.subject.partnership": "Parceria Comercial",
      "contact.form.subject.feedback": "Feedback",
      "contact.form.message": "A Sua Mensagem",
      "contact.form.message.placeholder": "Escreva a sua mensagem aqui...",
      "contact.form.submit": "Enviar Mensagem",
      "contact.faq.title": "Perguntas Frequentes",
      "contact.faq.esim.title": "Como funciona o eSIM?",
      "contact.faq.esim.content": "O eSIM é um cartão SIM digital que funciona no seu telemóvel sem a necessidade de um cartão SIM físico. É ativado instantaneamente com um código QR.",
      "contact.faq.phones.title": "Que telemóveis suportam eSIM?",
      "contact.faq.phones.content": "Os modelos iPhone XS e superiores, Samsung Galaxy S20 e superiores e Google Pixel 3 e superiores suportam eSIM.",
      "contact.faq.validity.title": "Durante quanto tempo é válido o meu plano de dados?",
      "contact.faq.validity.content": "O período de validade dos planos varia de 1 a 30 dias, dependendo do plano que escolher.",
      "contact.faq.payment.title": "Como é feito o pagamento?",
      "contact.faq.payment.content": "Pode pagar com segurança por cartão de crédito, PayPal e transferência bancária.",
      "privacy.hero.title": "Política de Privacidade",
      "privacy.hero.description": "A segurança dos seus dados pessoais é muito importante para nós. Esta política explica como os seus dados são recolhidos, utilizados e protegidos.",
      "privacy.overview.title": "Visão Geral",
      "privacy.overview.content": "Esta Política de Privacidade descreve as nossas políticas e procedimentos relativos à recolha, utilização e divulgação das suas informações quando utiliza o nosso Serviço. Também o informa sobre os seus direitos de privacidade e como a lei o protege.",
      "privacy.data.title": "Dados Que Recolhemos",
      "privacy.data.personal.title": "Informações Pessoais",
      "privacy.data.personal.name": "Nome e apelido",
      "privacy.data.personal.email": "Endereço de e-mail",
      "privacy.data.personal.phone": "Número de telemóvel",
      "privacy.data.personal.payment": "Informações de pagamento",
      "privacy.data.usage.title": "Dados de Utilização",
      "privacy.data.usage.ip": "Endereço IP",
      "privacy.data.usage.browser": "Tipo de navegador",
      "privacy.data.usage.device": "Informações do dispositivo",
      "privacy.data.usage.stats": "Estatísticas de utilização",
      "privacy.security.title": "Segurança de Dados",
      "privacy.security.ssl.title": "Encriptação SSL",
      "privacy.security.ssl.content": "Todas as transferências de dados estão protegidas por encriptação SSL de 256 bits.",
      "privacy.security.servers.title": "Servidores Seguros",
      "privacy.security.servers.content": "Os seus dados são armazenados em servidores seguros com certificação ISO 27001.",
      "privacy.security.access.title": "Controlo de Acesso",
      "privacy.security.access.content": "Apenas o pessoal autorizado pode aceder aos seus dados.",
      "privacy.usage.title": "Utilização de Dados",
      "privacy.usage.intro": "Utilizamos os dados que recolhemos para as seguintes finalidades:",
      "privacy.usage.service.title": "Prestação de Serviços",
      "privacy.usage.service.content": "Para fornecer e gerir os nossos serviços eSIM",
      "privacy.usage.support.title": "Apoio ao Cliente",
      "privacy.usage.support.content": "Para fornecer suporte técnico e serviço de apoio ao cliente",
      "privacy.usage.security.title": "Segurança",
      "privacy.usage.security.content": "Para proteger a sua conta e os nossos serviços",
      "privacy.usage.improvement.title": "Melhoria",
      "privacy.usage.improvement.content": "Para melhorar os nossos serviços e adicionar novas funcionalidades",
      "privacy.sharing.title": "Partilha de Dados",
      "privacy.sharing.intro": "Não partilhamos os seus dados pessoais com terceiros, mas a partilha pode ser necessária nos seguintes casos:",
      "privacy.sharing.legal": "Em caso de obrigação legal",
      "privacy.sharing.providers": "Com os nossos prestadores de serviços (como processadores de pagamento)",
      "privacy.sharing.threats": "Para prevenir ameaças de segurança",
      "privacy.sharing.consent": "Com o seu consentimento explícito",
      "privacy.rights.title": "Os Seus Direitos",
      "privacy.rights.access.title": "Direito de Acesso",
      "privacy.rights.access.content": "Pode solicitar acesso aos dados que mantemos sobre si.",
      "privacy.rights.correction.title": "Direito de Retificação",
      "privacy.rights.correction.content": "Podemos corrigir os seus dados imprecisos ou incompletos.",
      "privacy.rights.deletion.title": "Direito de Eliminação",
      "privacy.rights.deletion.content": "Podemos eliminar os seus dados sob determinadas condições.",
      "privacy.rights.objection.title": "Direito de Oposição",
      "privacy.rights.objection.content": "Pode opor-se às nossas atividades de processamento de dados.",
      "privacy.contact.title": "Contacto",
      "privacy.contact.intro": "Se tiver alguma dúvida sobre esta Política de Privacidade, pode contactar-nos através dos seguintes canais:",
      "nav.about": "Sobre Nós",
      "nav.contact": "Contacto",
      "nav.privacy": "Privacidade",
      "nav.login": "Iniciar Sessão",
      "nav.account": "A Minha Conta",
      "nav.logout": "Terminar Sessão",
      "auth.brand.eyebrow": "COBERTURA GLOBAL",
      "auth.brand.title": "Internet no momento em que aterra em mais de 150 países.",
      "auth.brand.subtitle": "Sem SIM físico, sem faturas de roaming. Ative o seu eSIM em segundos.",
      "auth.login.eyebrow": "INÍCIO DE SESSÃO",
      "auth.login.title": "Bem-vindo de volta",
      "auth.login.subtitle": "Faça a gestão dos seus eSIMs e descubra novos.",
      "auth.signup.eyebrow": "NOVA CONTA",
      "auth.signup.title": "Junte-se a nós",
      "auth.signup.subtitle": "Prepare o seu primeiro eSIM em poucos passos.",
      "auth.field.identifier": "E-mail ou telemóvel",
      "auth.field.identifier.ph": "exemplo@email.com ou +351…",
      "auth.field.email": "E-mail",
      "auth.field.email.ph": "exemplo@email.com",
      "auth.field.fullName": "Nome e apelido",
      "auth.field.fullName.ph": "O seu nome e apelido",
      "auth.field.password": "Palavra-passe",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Iniciar sessão",
      "auth.action.loggingIn": "A iniciar sessão…",
      "auth.action.signup": "Criar conta",
      "auth.action.signingUp": "A criar conta…",
      "auth.toSignup.q": "Não tem conta?",
      "auth.toSignup.link": "Registe-se",
      "auth.toLogin.q": "Já tem uma conta?",
      "auth.toLogin.link": "Iniciar sessão",
      "auth.password.show": "Mostrar palavra-passe",
      "auth.password.hide": "Ocultar palavra-passe",
      "auth.terms.prefix": "Ao continuar, aceito os ",
      "auth.terms.link": "Termos de Utilização e a Política de Privacidade",
      "auth.terms.suffix": ".",
      "auth.error.required": "Por favor, preencha os campos obrigatórios.",
      "auth.error.terms": "Tem de aceitar os termos para continuar.",
      "verify.eyebrow": "VERIFICAÇÃO DE E-MAIL",
      "verify.title": "Verifique o seu e-mail",
      "verify.subtitle": "Enviámos um código de 6 dígitos para {{email}}. Introduza o código para verificar.",
      "verify.code": "Código de verificação",
      "verify.code.ph": "••••••",
      "verify.action": "Verificar",
      "verify.verifying": "A verificar…",
      "verify.resend": "Reenviar código",
      "verify.resendIn": "Reenviar em {{seconds}} s",
      "verify.resent": "Novo código enviado.",
      "verify.skip": "Ignorar por agora",
      "auth.forgot.link": "Esqueceu-se da palavra-passe?",
      "forgot.eyebrow": "REPOSIÇÃO DE PALAVRA-PASSE",
      "forgot.email.title": "Reponha a sua palavra-passe",
      "forgot.email.subtitle": "Introduza o endereço de e-mail da sua conta; iremos enviar-lhe um código de reposição de 6 dígitos.",
      "forgot.email.action": "Enviar código",
      "forgot.email.sending": "A enviar…",
      "forgot.reset.title": "Defina a sua nova palavra-passe",
      "forgot.reset.subtitle": "Introduza o código de 6 dígitos que enviámos para {{email}} e a sua nova palavra-passe.",
      "forgot.reset.action": "Atualizar palavra-passe",
      "forgot.reset.updating": "A atualizar…",
      "forgot.field.code": "Código de reposição",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Nova palavra-passe",
      "forgot.field.newPassword.ph": "Pelo menos 6 carateres",
      "forgot.resend": "Reenviar código",
      "forgot.resendIn": "Reenviar em {{seconds}} s",
      "forgot.resent": "Novo código enviado.",
      "forgot.backToLogin": "Voltar ao início de sessão",
      "forgot.changeEmail": "Alterar e-mail",
      "forgot.help.noMail": "Se não recebeu o código, verifique a sua pasta de spam ou confirme o seu endereço de e-mail.",
      "reset.RESET_CODE_SENT": "Código enviado. Por favor, verifique o seu e-mail.",
      "reset.RATE_LIMITED": "Fez demasiadas tentativas. Por favor, aguarde um momento e tente novamente.",
      "reset.MAIL_SEND_FAILED": "Algo correu mal. Por favor, tente novamente mais tarde.",
      "reset.RESET_CODE_VALID": "Código verificado.",
      "reset.INVALID_RESET_CODE": "Código incorreto. Por favor, tente novamente.",
      "reset.EXPIRED_RESET_CODE": "O código expirou. Por favor, solicite um novo código.",
      "reset.WEAK_PASSWORD": "A palavra-passe deve ter pelo menos 6 carateres.",
      "reset.PASSWORD_RESET_SUCCESS": "A sua palavra-passe foi atualizada. Pode iniciar sessão com a nova palavra-passe.",
      "reset.generic": "Algo correu mal. Por favor, tente novamente.",
      "login.resetSuccess": "A sua palavra-passe foi atualizada. Pode iniciar sessão com a nova palavra-passe.",
      "store.nav.shop": "Loja",
      "home.hero.title1": "Ligue-se em poucos minutos,",
      "home.hero.title2": "mantenha-se além das fronteiras.",
      "home.hero.subtitle": "Planos eSIM fiáveis válidos em mais de 190 países. Sem SIM físico, sem faturas de roaming.",
      "home.search.placeholder": "Para onde viaja?",
      "home.tabs.local": "eSIMs locais",
      "home.tabs.regional": "eSIMs regionais",
      "home.tabs.lifetime": "eSIMs vitalícios",
      "home.empty": "Não foram encontrados resultados para a sua pesquisa.",
      "home.error.title": "Não foi possível carregar o conteúdo",
      "home.error.retry": "Tentar novamente",
      "home.from": "a partir de",
      "home.popular": "Destinos populares",
      "home.coverage": "190+ países · ativação instantânea",
      "home.detail.soon": "Os planos para esta seleção serão listados aqui muito em breve.",
      "home.detail.back": "Voltar à loja",
      "detail.plans": "Planos",
      "detail.count": "{{count}} plano(s)",
      "detail.validity": "{{days}} dias",
      "detail.validityLifetime": "Sem expiração",
      "detail.buy": "Comprar",
      "detail.empty": "Atualmente não existem planos para esta seleção.",
      "detail.checkoutSoon": "O fluxo de pagamento será adicionado muito em breve.",
      "detail.loginToBuy": "Tem de iniciar sessão para comprar.",
      "detail.basicFeatures": "Características Básicas",
      "detail.dataAmount": "Quantidade de dados",
      "detail.validityLabel": "Período de validade",
      "detail.coverageArea": "Área de cobertura",
      "detail.activationNetworks": "Ativação e Redes",
      "detail.activationMethod": "Método de ativação",
      "detail.esimActivation": "eSIM — instantâneo com código QR",
      "detail.supportedNetworks": "Redes suportadas",
      "detail.description": "Descrição",
      "detail.price": "Preço",
      "authprompt.title": "Inicie sessão para continuar",
      "authprompt.message": "Inicie sessão na sua conta para comprar um eSIM ou crie uma nova conta em segundos.",
      "authprompt.close": "Fechar",
      "footer.tagline": "eSIM rápido, seguro e acessível em todo o mundo. Ligue-se à Internet assim que aterrar.",
      "footer.explore": "Explorar",
      "footer.support": "Suporte",
      "footer.legal": "Legal",
      "footer.shop": "Loja",
      "footer.help": "Perguntas Frequentes",
      "footer.terms": "Termos de Utilização",
      "footer.rights": "© {{year}} Utkan eSIM. Todos os direitos reservados.",
      "footer.apps": "Descarregar a aplicação",
      "whatsapp.label": "Escrever no WhatsApp",
      "whatsapp.message": "Olá, tenho um pedido de suporte de eSIM.",
      "notfound.eyebrow": "SEM SINAL",
      "notfound.title": "Esta página não está disponível",
      "notfound.message": "A página que procura pode ter sido movida ou nunca existiu. Vamos levá-lo de volta à área de cobertura.",
      "order.congrats": "Parabéns!",
      "order.message": "O seu eSIM está pronto. Pode configurá-lo em poucos passos com o código QR abaixo.",
      "order.details": "Resumo da encomenda",
      "order.activation": "Ativação",
      "order.activationDesc": "Para configurar o seu eSIM, leia o código QR com a câmara do seu dispositivo ou introduza manualmente o código de configuração.",
      "order.qrTitle": "Código QR do eSIM",
      "order.manualLabel": "Código de configuração",
      "order.copy": "Copiar",
      "order.copied": "Copiado",
      "order.howTo": "Como ativar?",
      "order.step1": "Vá a Definições > Rede Móvel / Dados Móveis > Adicionar eSIM no seu dispositivo.",
      "order.step2": "Selecione \"Utilizar Código QR\" e leia o código QR acima (ou introduza manualmente o código de configuração).",
      "order.step3": "Quando a instalação estiver concluída, ative o seu plano eSIM.",
      "order.step4": "Certifique-se de que o roaming de dados está ativado — já está ligado!",
      "order.cta": "Voltar à página inicial",
      "checkout.title": "Pagamento",
      "checkout.summary": "Resumo da encomenda",
      "checkout.total": "Total",
      "checkout.eurNote": "O montante é cobrado em euros (€) no PayPal.",
      "checkout.processing": "A verificar o seu pagamento…",
      "checkout.error": "O pagamento não pôde ser concluído. Por favor, tente novamente.",
      "checkout.cancelled": "Pagamento cancelado.",
      "account.title": "A Minha Conta",
      "account.tab.profile": "Perfil",
      "account.tab.esims": "Os Meus eSIMs",
      "account.tab.security": "Segurança",
      "account.profile.title": "Informações do perfil",
      "account.field.phone": "Telemóvel",
      "account.field.phone.ph": "+351…",
      "account.memberSince": "Membro desde",
      "account.save": "Guardar",
      "account.saving": "A guardar…",
      "account.saved": "As suas informações foram atualizadas.",
      "account.esims.title": "Os Meus eSIMs",
      "account.esims.empty": "Ainda não tem um eSIM.",
      "account.esims.emptyCta": "Explorar a loja",
      "account.esims.data": "Dados",
      "account.esims.expires": "Data de fim",
      "account.esims.viewQr": "Mostrar código QR",
      "account.esims.hideQr": "Ocultar código QR",
      "account.esims.active": "Ativo",
      "account.esims.passive": "Inativo",
      "account.esims.noActive": "Não tem eSIMs ativos.",
      "account.esims.noPassive": "Não tem eSIMs inativos.",
      "account.esims.readyHint": "Pronto a utilizar — a duração começa na primeira utilização.",
      "account.esims.unavailableHint": "Não foi possível carregar o estado neste momento. Tente novamente mais tarde.",
      "esimStatus.active": "Ativo",
      "esimStatus.readyToUse": "Pronto a utilizar",
      "esimStatus.inactive": "Inativo",
      "esimStatus.unavailable": "Não foi possível carregar o estado",
      "account.security.title": "Alterar palavra-passe",
      "account.field.oldPassword": "Palavra-passe atual",
      "account.field.newPassword": "Nova palavra-passe",
      "account.field.confirmPassword": "Nova palavra-passe (repetir)",
      "account.changePassword": "Atualizar palavra-passe",
      "account.passwordChanged": "A sua palavra-passe foi atualizada.",
      "account.error.passwordMismatch": "As novas palavras-passe não coincidem.",
      "account.danger.title": "Ações da conta",
      "account.delete": "Eliminar conta",
      "account.delete.confirm": "Está prestes a eliminar a sua conta permanentemente. Esta ação não pode ser desfeita.",
      "account.delete.confirmBtn": "Sim, eliminar",
      "account.cancel": "Cancelar",
      "esimDetail.back": "Voltar",
      "esimDetail.dataUsage": "Utilização de dados",
      "esimDetail.left": "restantes",
      "esimDetail.leftData": "Dados restantes",
      "esimDetail.usedData": "Utilizados",
      "esimDetail.totalData": "Dados totais",
      "esimDetail.qrDesc": "Configure o seu eSIM lendo este código QR com a câmara do seu dispositivo.",
      "esimDetail.validity": "Validade",
      "esimDetail.daysLeft": "{{days}} dia(s) restante(s)",
      "esimDetail.expired": "Expirou",
      "esimDetail.notYetActive": "Ainda não ativo",
      "esimDetail.leftDate": "Tempo restante",
      "esimDetail.activationDate": "Data de ativação",
      "esimDetail.endDate": "Data de fim",
      "esimDetail.technical": "Informações técnicas",
      "esimDetail.activationCode": "Código de ativação (Android)",
      "esimDetail.smdp": "Endereço SM-DP+ (iOS)",
      "esimDetail.matchingId": "ID de correspondência (iOS)",
      "esimDetail.support": "Suporte técnico",
      "esimDetail.supportDesc": "Tem algum problema? Deixe-nos ajudar.",
      "esimDetail.email": "Enviar um e-mail",
      "guide.eyebrow": "GUIA eSIM",
      "guide.title": "O que é um eSIM e como instalá-lo?",
      "guide.intro.title": "O que é um eSIM?",
      "guide.intro.body": "O eSIM é um SIM digital integrado no seu dispositivo que funciona sem a necessidade de um cartão SIM físico. Configura a sua linha em segundos ao ler um código QR; liga-se à Internet em mais de 190 países sem trocar de cartão e sem faturas de roaming.",
      "guide.steps.title": "Como ativar?",
      "guide.devices.title": "Dispositivos suportados",
      "guide.devices.desc": "O seu dispositivo tem de ser compatível com eSIM para que este funcione. Verifique a sua marca.",
      "guide.faq.title": "Perguntas frequentes",
      "nav.guide": "Guia eSIM",
      "currency.label": "Moeda",
      "staticPage.loading": "A carregar página...",
      "staticPage.errorTitle": "Ocorreu um Erro",
      "staticPage.retry": "Tentar Novamente",
      "staticPage.loadFailed": "Não foi possível carregar o conteúdo da página. Por favor, tente novamente mais tarde.",
      "last.updated": "Última atualização: 8 de julho de 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "eSIMs ilimitados",
      "detail.unlimited": "Ilimitado",
      "detail.unlimitedNote": "Este pacote não tem limite de dados — internet ilimitada durante toda a validade.",
      "detail.notPriced": "Este pacote não está disponível para compra na web neste momento.",
      "checkout.priceUpdated": "O preço deste pacote foi atualizado. Volte à loja e selecione-o novamente.",
      "order.pending.title": "O seu eSIM está a ser preparado",
      "order.pending.message": "O seu pagamento foi concluído. Os pacotes ilimitados podem demorar alguns minutos a ativar.",
      "order.pending.waiting": "A verificar o estado da sua encomenda…",
      "order.pending.ready": "O seu eSIM está pronto!",
      "order.pending.timeout": "Está a demorar mais do que o esperado. O seu pagamento está seguro — o seu eSIM aparecerá em «Os meus eSIMs» assim que estiver pronto.",
      "order.pending.cta": "Ir para Os meus eSIMs",
      "account.esims.unlimited": "Ilimitado",
      "account.esims.unlimitedHint": "Dados ilimitados — este pacote não tem limite de dados.",
      "esimDetail.unlimitedData": "Este pacote não tem limite de dados; veja o tempo restante abaixo.",


      // Eliminação de conta (/hesap-sil · /account-deletion) — requisito do Google Play «Data deletion»
      "del.eyebrow": "Eliminação de conta",
      "del.title": "Eliminar a minha conta",
      "del.intro": "Aqui pode eliminar permanentemente a sua conta Utkan eSIM e os seus dados pessoais. Não precisa de ter a aplicação instalada — basta iniciar sessão com a conta que pretende eliminar.",
      "del.deleted.title": "Dados eliminados",
      "del.deleted.identity": "Nome, apelido, endereço de e-mail e número de telefone",
      "del.deleted.credentials": "A sua palavra-passe e os dados de sessão",
      "del.deleted.codes": "Os códigos de verificação de e-mail e de reposição da palavra-passe",
      "del.deleted.esim": "O seu número eSIM (MSISDN), o código QR/de ativação e os dados de utilização",
      "del.kept.title": "Dados que mantemos e porquê",
      "del.kept.orders": "Os registos de compra (número de encomenda, data, valor, estado do pagamento) são mantidos por obrigações fiscais e contabilísticas. Não contêm o seu nome, e-mail ou dados de pagamento — apenas um identificador que não pode ser associado a si.",
      "del.kept.period": "Prazo de conservação: 5 anos (Lei do Procedimento Tributário da Turquia, art. 253.º).",
      "del.warn.title": "Antes de eliminar",
      "del.warn.irreversible": "Esta ação não pode ser anulada.",
      "del.warn.esim": "Os eSIM ativos continuam a funcionar no seu dispositivo, mas deixará de ter acesso ao código QR e aos dados restantes. Guarde o código QR antes de eliminar.",
      "del.warn.rejoin": "Pode registar-se novamente com o mesmo e-mail, mas os eSIM anteriores não aparecerão na nova conta.",
      "del.support": "Se não conseguir iniciar sessão, também pode pedir a eliminação por e-mail:",
      "del.login.title": "Inicie sessão primeiro",
      "del.login.subtitle": "Introduza o seu e-mail e palavra-passe para confirmarmos que a conta é sua.",
      "del.login.action": "Iniciar sessão",
      "del.login.loading": "A iniciar sessão...",
      "del.forgot": "Esqueceu-se da palavra-passe?",
      "del.confirm.title": "Tem a certeza?",
      "del.confirm.subtitle": "A conta {{email}} e os seus dados pessoais serão eliminados permanentemente.",
      "del.confirm.field": "Escreva novamente o seu e-mail para confirmar",
      "del.confirm.action": "Eliminar a minha conta permanentemente",
      "del.confirm.deleting": "A eliminar...",
      "del.confirm.cancel": "Cancelar",
      "del.done.title": "A sua conta foi eliminada",
      "del.done.body": "Os seus dados pessoais foram eliminados permanentemente.",
      "del.done.retained": "Os seus dados pessoais foram eliminados permanentemente. Foram mantidos {{n}} registo(s) de compra por obrigações legais; não podem ser associados a si.",
      "del.done.home": "Voltar à loja",
      "del.error.required": "Introduza o seu e-mail e palavra-passe.",
      "del.error.credentials": "E-mail ou palavra-passe incorretos.",
      "del.error.suspended": "A sua conta foi suspensa. Contacte o apoio ao cliente.",
      "del.error.session": "A sua sessão expirou. Inicie sessão novamente.",
      "del.error.network": "Não foi possível ligar. Verifique a sua ligação à Internet e tente novamente.",
      "del.error.generic": "Ocorreu um erro. Tente novamente.",
      "footer.deleteAccount": "Eliminar conta",


      // Planos de voz (dados + chamadas e SMS ilimitados) — docs/ses-paketleri.md
      "home.tabs.voice": "eSIM com chamadas",
      "detail.voice": "Chamadas + SMS",
      "detail.voiceNote": "Este plano inclui chamadas e SMS ilimitados além dos dados: um único eSIM para internet e chamadas.",
      "detail.calls": "Chamadas",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Chamadas ilimitadas",
      "plan.unlimitedSms": "SMS ilimitados",
      "plan.minutes": "{{n}} min de chamadas",
      "plan.sms": "{{n}} SMS",
      "loading": "A carregar..."
    }
  },
  ar: {
    translation: {
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "مستقبل الاتصال الرقمي",
      "hero.description": "نحن نزيل الحدود من خلال تجربة اتصال رقمي من الجيل التالي.",
      "hero.description2": "حلول eSIM سريعة وآمنة وبأسعار معقولة في جميع أنحاء العالم.",
      "features.countries": "+150 دولة",
      "features.activation": "تفعيل فوري",
      "features.support": "دعم على مدار 24/7",
      "countdown.title": "موقعنا الإلكتروني قريباً جداً!",
      "countdown.days": "أيام",
      "countdown.hours": "ساعات",
      "countdown.minutes": "دقائق",
      "countdown.seconds": "ثواني",
      "countdown.launch": "تم إطلاق موقعنا الإلكتروني!",
      "countdown.loading": "جاري التحميل...",
      "apps.title": "تطبيقاتنا للهواتف المحمولة",
      "apps.ios.label": "تنزيل من",
      "apps.ios.name": "App Store",
      "apps.android.label": "احصل عليه من",
      "apps.android.name": "Google Play",
      "contact.title": "تواصل معنا قبل الإطلاق",
      "contact.whatsapp": "واتساب: 333 1 555 676 43+",
      "contact.email": "البريد الإلكتروني: info@utkanesim.com",
      "about.hero.title": "نبذة عن Utkan eSIM",
      "about.hero.description": "أمان بياناتك الشخصية مهم جداً بالنسبة لنا. توضح هذه السياسة كيف يتم جمع بياناتك واستخدامها وحمايتها.",
      "about.story.title": "قصتنا",
      "about.story.content": "تأسست Utkan eSIM في عام 2024 من قبل فريق من المسافرين الشغوفين وهواة التكنولوجيا، وتهدف إلى إحداث ثورة في طريقة اتصال الأشخاص بالإنترنت في الخارج. من خلال تقديم خطط بيانات eSIM موثوقة وعالية الجودة لأكثر من 190 دولة ومنطقة، نضمن لك وصولاً سريعاً إلى الإنترنت بمجرد هبوطك.",
      "about.mission.title": "مهمتنا",
      "about.mission.content": "تزويد المسافرين باتصال عالمي بسيط وبأسعار معقولة وفوري، مما يتيح لهم الاستكشاف والعمل والبقاء على اتصال بلا حدود.",
      "about.vision.title": "رؤيتنا",
      "about.vision.content": "أن نكون المنصة العالمية الرائدة لحلول الاتصال الرقمي، لنجعل العالم مكاناً أصغر وأكثر اتصالاً للجميع.",
      "about.features.title": "لماذا تختارنا؟",
      "about.features.instant.title": "تسليم فوري",
      "about.features.instant.content": "احصل على شريحة eSIM الخاصة بك فوراً مع رمز الاستجابة السريعة (QR) بعد الشراء.",
      "about.features.global.title": "تغطية عالمية",
      "about.features.global.content": "خطط بيانات لأكثر من 190 دولة ومنطقة.",
      "about.features.affordable.title": "أسعار معقولة",
      "about.features.affordable.content": "وفر حتى 90% من رسوم التجوال.",
      "about.features.support.title": "دعم على مدار 24/7",
      "about.features.support.content": "فريق الدعم المخصص لدينا متواجد دائماً لخدمتك.",
      "about.features.secure.title": "اتصال آمن",
      "about.features.secure.content": "اتصال محمي بأحدث بروتوكولات الأمان.",
      "about.features.fast.title": "إنترنت سريع",
      "about.features.fast.content": "تجربة إنترنت غير منقطعة بسرعات 4G/5G.",
      "about.cta.title": "انضم إلى مستقبل الاتصال الرقمي",
      "about.cta.content": "شكراً لاختيارك Utkan eSIM. رحلة سعيدة!",
      "about.cta.whatsapp": "تواصل عبر واتساب",
      "about.cta.email": "إرسال بريد إلكتروني",
      "contact.hero.title": "اتصل بنا",
      "contact.hero.description": "إذا كانت لديك أسئلة حول شرائح eSIM الخاصة بنا، أو تحتاج إلى دعم فني، أو ترغب فقط في تقديم ملاحظاتك، فسيسعدنا أن نسمع منك.",
      "contact.info.title": "معلومات الاتصال الخاصة بنا",
      "contact.whatsapp.title": "واتساب",
      "contact.whatsapp.subtitle": "دعم سريع 24/7",
      "contact.email.title": "البريد الإلكتروني",
      "contact.email.subtitle": "تواصل عام",
      "contact.support.title": "الدعم الفني",
      "contact.support.subtitle": "مشاكل eSIM",
      "contact.business.title": "شراكة تجارية",
      "contact.business.subtitle": "تواصل الشركات",
      "contact.hours.title": "ساعات الدعم",
      "contact.hours.subtitle": "دعم فني 24/7",
      "contact.hours.detail": "الإثنين - الأحد: 00:00 - 23:59",
      "contact.form.title": "أرسل رسالة",
      "contact.form.name": "الاسم واللقب",
      "contact.form.name.placeholder": "أدخل اسمك ولقبك",
      "contact.form.email": "عنوان بريدك الإلكتروني",
      "contact.form.email.placeholder": "example@email.com",
      "contact.form.subject": "الموضوع",
      "contact.form.subject.placeholder": "اختر موضوعاً",
      "contact.form.subject.general": "معلومات عامة",
      "contact.form.subject.technical": "الدعم الفني",
      "contact.form.subject.billing": "أسئلة الفواتير",
      "contact.form.subject.partnership": "شراكة تجارية",
      "contact.form.subject.feedback": "ملاحظات",
      "contact.form.message": "رسالتك",
      "contact.form.message.placeholder": "اكتب رسالتك هنا...",
      "contact.form.submit": "إرسال الرسالة",
      "contact.faq.title": "الأسئلة الشائعة",
      "contact.faq.esim.title": "كيف تعمل eSIM؟",
      "contact.faq.esim.content": "إن eSIM عبارة عن شريحة SIM رقمية تعمل في هاتفك دون الحاجة إلى بطاقة SIM فعلية. يتم تفعيلها فوراً باستخدام رمز الاستجابة السريعة (QR).",
      "contact.faq.phones.title": "ما هي الهواتف التي تدعم eSIM؟",
      "contact.faq.phones.content": "تدعم هواتف iPhone XS والأحدث، وSamsung Galaxy S20 والأحدث، وGoogle Pixel 3 والأحدث تقنية eSIM.",
      "contact.faq.validity.title": "ما هي مدة صلاحية باقة البيانات الخاصة بي؟",
      "contact.faq.validity.content": "تتراوح فترة صلاحية الباقات بين 1 إلى 30 يوماً بناءً على الخطة التي تختارها.",
      "contact.faq.payment.title": "كيف يتم الدفع؟",
      "contact.faq.payment.content": "يمكنك الدفع بأمان باستخدام بطاقة الائتمان، وPayPal، والتحويل المصرفي.",
      "privacy.hero.title": "سياسة الخصوصية",
      "privacy.hero.description": "أمان بياناتك الشخصية مهم جداً بالنسبة لنا. توضح هذه السياسة كيف يتم جمع بياناتك واستخدامها وحمايتها.",
      "privacy.overview.title": "نظرة عامة",
      "privacy.overview.content": "تصف سياسة الخصوصية هذه سياساتنا وإجراءاتنا المتعلقة بجمع معلوماتك واستخدامها والإفصاح عنها عند استخدامك لخدمتنا. كما تخبرك عن حقوق الخصوصية الخاصة بك وكيف يحميك القانون.",
      "privacy.data.title": "البيانات التي نجمعها",
      "privacy.data.personal.title": "المعلومات الشخصية",
      "privacy.data.personal.name": "الاسم واللقب",
      "privacy.data.personal.email": "عنوان البريد الإلكتروني",
      "privacy.data.personal.phone": "رقم الهاتف",
      "privacy.data.personal.payment": "معلومات الدفع",
      "privacy.data.usage.title": "بيانات الاستخدام",
      "privacy.data.usage.ip": "عنوان IP",
      "privacy.data.usage.browser": "نوع المتصفح",
      "privacy.data.usage.device": "معلومات الجهاز",
      "privacy.data.usage.stats": "إحصائيات الاستخدام",
      "privacy.security.title": "أمان البيانات",
      "privacy.security.ssl.title": "تشفير SSL",
      "privacy.security.ssl.content": "تتم حماية جميع عمليات نقل البيانات بتشفير SSL 256-bit.",
      "privacy.security.servers.title": "خوادم آمنة",
      "privacy.security.servers.content": "يتم تخزين بياناتك في خوادم آمنة معتمدة من ISO 27001.",
      "privacy.security.access.title": "التحكم في الوصول",
      "privacy.security.access.content": "يمكن للموظفين المصرح لهم فقط الوصول إلى بياناتك.",
      "privacy.usage.title": "استخدام البيانات",
      "privacy.usage.intro": "نستخدم البيانات التي نجمعها للأغراض التالية:",
      "privacy.usage.service.title": "تقديم الخدمة",
      "privacy.usage.service.content": "لتقديم وإدارة خدمات eSIM الخاصة بنا",
      "privacy.usage.support.title": "دعم العملاء",
      "privacy.usage.support.content": "لتقديم الدعم الفني وخدمة العملاء",
      "privacy.usage.security.title": "الأمان",
      "privacy.usage.security.content": "لحماية حسابك وخدماتنا",
      "privacy.usage.improvement.title": "التحسين",
      "privacy.usage.improvement.content": "لتحسين خدماتنا وإضافة ميزات جديدة",
      "privacy.sharing.title": "مشاركة البيانات",
      "privacy.sharing.intro": "نحن لا نشارك بياناتك الشخصية مع جهات خارجية، ولكن قد تكون المشاركة ضرورية في الحالات التالية:",
      "privacy.sharing.legal": "في حالة وجود التزام قانوني",
      "privacy.sharing.providers": "مع مزودي الخدمة لدينا (مثل معالجات الدفع)",
      "privacy.sharing.threats": "لمنع التهديدات الأمنية",
      "privacy.sharing.consent": "بموافقتك الصريحة",
      "privacy.rights.title": "حقوقك",
      "privacy.rights.access.title": "حق الوصول",
      "privacy.rights.access.content": "يمكنك طلب الوصول إلى البيانات التي نحتفظ بها عنك.",
      "privacy.rights.correction.title": "حق التصحيح",
      "privacy.rights.correction.content": "يمكننا تصحيح بياناتك غير الدقيقة أو غير المكتملة.",
      "privacy.rights.deletion.title": "حق الحذف",
      "privacy.rights.deletion.content": "يمكننا حذف بياناتك في ظل ظروف معينة.",
      "privacy.rights.objection.title": "حق الاعتراض",
      "privacy.rights.objection.content": "يمكنك الاعتراض على أنشطة معالجة البيانات الخاصة بنا.",
      "privacy.contact.title": "اتصل بنا",
      "privacy.contact.intro": "إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يمكنك الاتصال بنا عبر القنوات التالية:",
      "nav.about": "نبذة عنا",
      "nav.contact": "اتصل بنا",
      "nav.privacy": "الخصوصية",
      "nav.login": "تسجيل الدخول",
      "nav.account": "حسابي",
      "nav.logout": "تسجيل الخروج",
      "auth.brand.eyebrow": "تغطية عالمية",
      "auth.brand.title": "إنترنت بمجرد هبوطك في أكثر من 150 دولة.",
      "auth.brand.subtitle": "لا توجد شريحة SIM فعلية، ولا فواتير تجوال. قم بتفعيل eSIM الخاصة بك في ثوانٍ.",
      "auth.login.eyebrow": "تسجيل الدخول إلى الحساب",
      "auth.login.title": "مرحباً بعودتك",
      "auth.login.subtitle": "قم بإدارة شرائح eSIM الخاصة بك واكتشف شرائح جديدة.",
      "auth.signup.eyebrow": "حساب جديد",
      "auth.signup.title": "انضم إلينا",
      "auth.signup.subtitle": "قم بإعداد أول eSIM لك في خطوات قليلة.",
      "auth.field.identifier": "البريد الإلكتروني أو الهاتف",
      "auth.field.identifier.ph": "example@email.com أو +90…",
      "auth.field.email": "البريد الإلكتروني",
      "auth.field.email.ph": "example@email.com",
      "auth.field.fullName": "الاسم واللقب",
      "auth.field.fullName.ph": "اسمك ولقبك",
      "auth.field.password": "كلمة المرور",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "تسجيل الدخول",
      "auth.action.loggingIn": "جاري تسجيل الدخول…",
      "auth.action.signup": "إنشاء حساب",
      "auth.action.signingUp": "جاري إنشاء الحساب…",
      "auth.toSignup.q": "ليس لديك حساب؟",
      "auth.toSignup.link": "سجل الآن",
      "auth.toLogin.q": "هل لديك حساب بالفعل؟",
      "auth.toLogin.link": "تسجيل الدخول",
      "auth.password.show": "إظهار كلمة المرور",
      "auth.password.hide": "إخفاء كلمة المرور",
      "auth.terms.prefix": "بالمتابعة، أنا أوافق على ",
      "auth.terms.link": "شروط الاستخدام وسياسة الخصوصية",
      "auth.terms.suffix": ".",
      "auth.error.required": "يرجى ملء الحقول المطلوبة.",
      "auth.error.terms": "يجب عليك قبول الشروط للمتابعة.",
      "verify.eyebrow": "التحقق من البريد الإلكتروني",
      "verify.title": "تحقق من بريدك الإلكتروني",
      "verify.subtitle": "لقد أرسلنا رمزاً مكوناً من 6 أرقام إلى {{email}}. أدخل الرمز للتحقق.",
      "verify.code": "رمز التحقق",
      "verify.code.ph": "••••••",
      "verify.action": "تحقق",
      "verify.verifying": "جاري التحقق…",
      "verify.resend": "إعادة إرسال الرمز",
      "verify.resendIn": "إعادة الإرسال بعد {{seconds}} ثانية",
      "verify.resent": "تم إرسال رمز جديد.",
      "verify.skip": "تخطي الآن",
      "auth.forgot.link": "هل نسيت كلمة المرور؟",
      "forgot.eyebrow": "إعادة تعيين كلمة المرور",
      "forgot.email.title": "أعد تعيين كلمة المرور",
      "forgot.email.subtitle": "أدخل عنوان البريد الإلكتروني لحسابك؛ وسنرسل لك رمز إعادة تعيين مكون من 6 أرقام.",
      "forgot.email.action": "إرسال الرمز",
      "forgot.email.sending": "جاري الإرسال…",
      "forgot.reset.title": "تعيين كلمة مرور جديدة",
      "forgot.reset.subtitle": "أدخل الرمز المكون من 6 أرقام الذي أرسلناه إلى {{email}} وكلمة المرور الجديدة.",
      "forgot.reset.action": "تحديث كلمة المرور",
      "forgot.reset.updating": "جاري التحديث…",
      "forgot.field.code": "رمز إعادة التعيين",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "كلمة مرور جديدة",
      "forgot.field.newPassword.ph": "6 أحرف على الأقل",
      "forgot.resend": "إعادة إرسال الرمز",
      "forgot.resendIn": "إعادة الإرسال بعد {{seconds}} ثانية",
      "forgot.resent": "تم إرسال رمز جديد.",
      "forgot.backToLogin": "العودة إلى تسجيل الدخول",
      "forgot.changeEmail": "تغيير البريد الإلكتروني",
      "forgot.help.noMail": "إذا لم يصل الرمز، تحقق من مجلد الرسائل غير المرغوب فيها أو تأكد من عنوان بريدك الإلكتروني.",
      "reset.RESET_CODE_SENT": "تم إرسال الرمز. يرجى التحقق من بريدك الإلكتروني.",
      "reset.RATE_LIMITED": "لقد قمت بمحاولات كثيرة. يرجى الانتظار قليلاً والمحاولة مرة أخرى.",
      "reset.MAIL_SEND_FAILED": "حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقاً.",
      "reset.RESET_CODE_VALID": "تم التحقق من الرمز.",
      "reset.INVALID_RESET_CODE": "رمز غير صحيح. يرجى المحاولة مرة أخرى.",
      "reset.EXPIRED_RESET_CODE": "انتهت صلاحية الرمز. يرجى طلب رمز جديد.",
      "reset.WEAK_PASSWORD": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
      "reset.PASSWORD_RESET_SUCCESS": "تم تحديث كلمة المرور الخاصة بك. يمكنك تسجيل الدخول بكلمة المرور الجديدة.",
      "reset.generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      "login.resetSuccess": "تم تحديث كلمة المرور الخاصة بك. يمكنك تسجيل الدخول بكلمة المرور الجديدة.",
      "store.nav.shop": "المتجر",
      "home.hero.title1": "اتصل في بضع دقائق،",
      "home.hero.title2": "ابق على اتصال خارج الحدود.",
      "home.hero.subtitle": "باقات eSIM موثوقة صالحة في أكثر من 190 دولة. لا توجد بطاقة SIM فعلية، ولا فواتير تجوال.",
      "home.search.placeholder": "إلى أين تسافر؟",
      "home.tabs.local": "eSIM محلية",
      "home.tabs.regional": "eSIM إقليمية",
      "home.tabs.lifetime": "eSIM مدى الحياة",
      "home.empty": "لم يتم العثور على نتائج تطابق بحثك.",
      "home.error.title": "تعذر تحميل المحتوى",
      "home.error.retry": "حاول مرة أخرى",
      "home.from": "تبدأ من",
      "home.popular": "الوجهات الشهيرة",
      "home.coverage": "+190 دولة · تفعيل فوري",
      "home.detail.soon": "سيتم إدراج باقات هذا التحديد هنا قريباً جداً.",
      "home.detail.back": "العودة إلى المتجر",
      "detail.plans": "الباقات",
      "detail.count": "{{count}} باقة",
      "detail.validity": "{{days}} يوم",
      "detail.validityLifetime": "بلا انتهاء",
      "detail.buy": "شراء",
      "detail.empty": "لا توجد باقات متاحة لهذا التحديد حالياً.",
      "detail.checkoutSoon": "سيتم إضافة عملية الدفع قريباً جداً.",
      "detail.loginToBuy": "يجب عليك تسجيل الدخول للشراء.",
      "detail.basicFeatures": "الميزات الأساسية",
      "detail.dataAmount": "حجم البيانات",
      "detail.validityLabel": "فترة الصلاحية",
      "detail.coverageArea": "منطقة التغطية",
      "detail.activationNetworks": "التفعيل والشبكات",
      "detail.activationMethod": "طريقة التفعيل",
      "detail.esimActivation": "eSIM — فوري باستخدام رمز QR",
      "detail.supportedNetworks": "الشبكات المدعومة",
      "detail.description": "الوصف",
      "detail.price": "السعر",
      "authprompt.title": "قم بتسجيل الدخول للمتابعة",
      "authprompt.message": "قم بتسجيل الدخول إلى حسابك لشراء eSIM أو قم بإنشاء حساب جديد في ثوانٍ.",
      "authprompt.close": "إغلاق",
      "footer.tagline": "eSIM سريع وآمن وبأسعار معقولة حول العالم. اتصل بالإنترنت بمجرد هبوطك.",
      "footer.explore": "استكشف",
      "footer.support": "الدعم",
      "footer.legal": "قانوني",
      "footer.shop": "المتجر",
      "footer.help": "الأسئلة الشائعة",
      "footer.terms": "شروط الاستخدام",
      "footer.rights": "© {{year}} Utkan eSIM. جميع الحقوق محفوظة.",
      "footer.apps": "تنزيل التطبيق",
      "whatsapp.label": "راسلنا عبر واتساب",
      "whatsapp.message": "مرحباً، لدي طلب دعم لـ eSIM.",
      "notfound.eyebrow": "لا توجد إشارة",
      "notfound.title": "هذه الصفحة غير متوفرة",
      "notfound.message": "ربما تم نقل الصفحة التي تبحث عنها أو أنها لم تكن موجودة أبداً. دعنا نعيدك إلى منطقة التغطية.",
      "order.congrats": "تهانينا!",
      "order.message": "شريحة eSIM الخاصة بك جاهزة. يمكنك إعدادها في بضع خطوات باستخدام رمز QR أدناه.",
      "order.details": "ملخص الطلب",
      "order.activation": "التفعيل",
      "order.activationDesc": "لإعداد eSIM الخاصة بك، قم بمسح رمز QR باستخدام كاميرا جهازك أو أدخل رمز الإعداد يدوياً.",
      "order.qrTitle": "رمز الاستجابة السريعة (QR) لـ eSIM",
      "order.manualLabel": "رمز الإعداد",
      "order.copy": "نسخ",
      "order.copied": "تم النسخ",
      "order.howTo": "كيفية التفعيل؟",
      "order.step1": "اذهب إلى الإعدادات > البيانات الخلوية / بيانات الجوال > إضافة eSIM على جهازك.",
      "order.step2": "اختر \"استخدام رمز QR\" وقم بمسح رمز QR أعلاه (أو أدخل رمز الإعداد يدوياً).",
      "order.step3": "بمجرد اكتمال الإعداد، قم بتفعيل خطة eSIM الخاصة بك.",
      "order.step4": "تأكد من تشغيل تجوال البيانات — أنت الآن متصل!",
      "order.cta": "العودة إلى الصفحة الرئيسية",
      "checkout.title": "الدفع",
      "checkout.summary": "ملخص الطلب",
      "checkout.total": "الإجمالي",
      "checkout.eurNote": "يتم تحصيل المبلغ باليورو (€) على PayPal.",
      "checkout.processing": "جاري التحقق من الدفع…",
      "checkout.error": "تعذر إكمال الدفع. يرجى المحاولة مرة أخرى.",
      "checkout.cancelled": "تم إلغاء الدفع.",
      "account.title": "حسابي",
      "account.tab.profile": "الملف الشخصي",
      "account.tab.esims": "شرائح eSIM الخاصة بي",
      "account.tab.security": "الأمان",
      "account.profile.title": "معلومات الملف الشخصي",
      "account.field.phone": "الهاتف",
      "account.field.phone.ph": "+90…",
      "account.memberSince": "عضو منذ",
      "account.save": "حفظ",
      "account.saving": "جاري الحفظ…",
      "account.saved": "تم تحديث معلوماتك.",
      "account.esims.title": "شرائح eSIM الخاصة بي",
      "account.esims.empty": "ليس لديك شريحة eSIM بعد.",
      "account.esims.emptyCta": "تصفح المتجر",
      "account.esims.data": "البيانات",
      "account.esims.expires": "تاريخ الانتهاء",
      "account.esims.viewQr": "إظهار رمز QR",
      "account.esims.hideQr": "إخفاء رمز QR",
      "account.esims.active": "نشط",
      "account.esims.passive": "غير نشط",
      "account.esims.noActive": "ليس لديك شرائح eSIM نشطة.",
      "account.esims.noPassive": "ليس لديك شرائح eSIM غير نشطة.",
      "account.esims.readyHint": "جاهز للاستخدام — تبدأ المدة عند الاستخدام الأول.",
      "account.esims.unavailableHint": "تعذر تحميل الحالة في الوقت الحالي. حاول مرة أخرى لاحقاً.",
      "esimStatus.active": "نشط",
      "esimStatus.readyToUse": "جاهز للاستخدام",
      "esimStatus.inactive": "غير نشط",
      "esimStatus.unavailable": "تعذر تحميل الحالة",
      "account.security.title": "تغيير كلمة المرور",
      "account.field.oldPassword": "كلمة المرور الحالية",
      "account.field.newPassword": "كلمة مرور جديدة",
      "account.field.confirmPassword": "كلمة مرور جديدة (تأكيد)",
      "account.changePassword": "تحديث كلمة المرور",
      "account.passwordChanged": "تم تحديث كلمة المرور الخاصة بك.",
      "account.error.passwordMismatch": "كلمات المرور الجديدة غير متطابقة.",
      "account.danger.title": "إجراءات الحساب",
      "account.delete": "حذف الحساب",
      "account.delete.confirm": "أنت على وشك حذف حسابك بشكل دائم. لا يمكن التراجع عن هذا الإجراء.",
      "account.delete.confirmBtn": "نعم، احذف",
      "account.cancel": "إلغاء",
      "esimDetail.back": "رجوع",
      "esimDetail.dataUsage": "استخدام البيانات",
      "esimDetail.left": "متبقي",
      "esimDetail.leftData": "البيانات المتبقية",
      "esimDetail.usedData": "المستخدم",
      "esimDetail.totalData": "إجمالي البيانات",
      "esimDetail.qrDesc": "قم بإعداد eSIM الخاص بك عن طريق مسح رمز QR هذا باستخدام كاميرا جهازك.",
      "esimDetail.validity": "الصلاحية",
      "esimDetail.daysLeft": "باقي {{days}} يوم",
      "esimDetail.expired": "منتهي الصلاحية",
      "esimDetail.notYetActive": "غير نشط بعد",
      "esimDetail.leftDate": "الوقت المتبقي",
      "esimDetail.activationDate": "تاريخ التفعيل",
      "esimDetail.endDate": "تاريخ الانتهاء",
      "esimDetail.technical": "معلومات فنية",
      "esimDetail.activationCode": "رمز التفعيل (Android)",
      "esimDetail.smdp": "عنوان SM-DP+ (iOS)",
      "esimDetail.matchingId": "معرف المطابقة (iOS)",
      "esimDetail.support": "الدعم الفني",
      "esimDetail.supportDesc": "هل تواجه مشكلة؟ دعنا نساعدك.",
      "esimDetail.email": "إرسال بريد إلكتروني",
      "guide.eyebrow": "دليل eSIM",
      "guide.title": "ما هي eSIM وكيف يتم تثبيتها؟",
      "guide.intro.title": "ما هي eSIM؟",
      "guide.intro.body": "إن eSIM عبارة عن شريحة SIM رقمية مدمجة في جهازك وتعمل دون الحاجة إلى بطاقة SIM فعلية. تقوم بإعداد خطك في ثوانٍ عن طريق مسح رمز QR؛ وتتيح لك الاتصال بالإنترنت في أكثر من 190 دولة دون تغيير البطاقات ودون فواتير تجوال.",
      "guide.steps.title": "كيفية التفعيل؟",
      "guide.devices.title": "الأجهزة المدعومة",
      "guide.devices.desc": "يجب أن يكون جهازك متوافقاً مع eSIM لكي تعمل. تحقق من العلامة التجارية لجهازك.",
      "guide.faq.title": "الأسئلة الشائعة",
      "nav.guide": "دليل eSIM",
      "currency.label": "العملة",
      "staticPage.loading": "جاري تحميل الصفحة...",
      "staticPage.errorTitle": "حدث خطأ",
      "staticPage.retry": "حاول مرة أخرى",
      "staticPage.loadFailed": "تعذر تحميل محتوى الصفحة. يرجى المحاولة مرة أخرى لاحقاً.",
      "last.updated": "آخر تحديث: 8 يوليو 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "شرائح eSIM غير محدودة",
      "detail.unlimited": "غير محدود",
      "detail.unlimitedNote": "لا يوجد حد للبيانات في هذه الباقة — إنترنت غير محدود طوال مدة الصلاحية.",
      "detail.notPriced": "هذه الباقة غير متاحة للشراء عبر الويب حالياً.",
      "checkout.priceUpdated": "تم تحديث سعر هذه الباقة. يرجى العودة إلى المتجر واختيارها مرة أخرى.",
      "order.pending.title": "يتم تجهيز شريحة eSIM الخاصة بك",
      "order.pending.message": "تم استلام دفعتك. قد يستغرق تفعيل الباقات غير المحدودة بضع دقائق.",
      "order.pending.waiting": "جاري التحقق من حالة طلبك…",
      "order.pending.ready": "شريحة eSIM جاهزة!",
      "order.pending.timeout": "يستغرق الأمر وقتاً أطول من المتوقع. دفعتك آمنة — ستظهر شريحة eSIM في «شرائحي» بمجرد أن تصبح جاهزة.",
      "order.pending.cta": "الذهاب إلى شرائحي",
      "account.esims.unlimited": "غير محدود",
      "account.esims.unlimitedHint": "بيانات غير محدودة — لا يوجد حد للبيانات في هذه الباقة.",
      "esimDetail.unlimitedData": "لا يوجد حد للبيانات في هذه الباقة؛ اطلع على المدة المتبقية أدناه.",


      // صفحة حذف الحساب (/hesap-sil · /account-deletion) — متطلب Google Play «Data deletion»
      "del.eyebrow": "حذف الحساب",
      "del.title": "حذف حسابي",
      "del.intro": "يمكنك من هنا حذف حسابك في Utkan eSIM وبياناتك الشخصية نهائيًا. لا حاجة لتثبيت التطبيق — يكفي تسجيل الدخول بالحساب الذي تريد حذفه.",
      "del.deleted.title": "البيانات التي يتم حذفها",
      "del.deleted.identity": "الاسم واللقب وعنوان البريد الإلكتروني ورقم الهاتف",
      "del.deleted.credentials": "كلمة المرور وبيانات الجلسة",
      "del.deleted.codes": "رموز تأكيد البريد الإلكتروني وإعادة تعيين كلمة المرور",
      "del.deleted.esim": "رقم شريحة eSIM (MSISDN) ورمز QR/التفعيل وبيانات الاستخدام",
      "del.kept.title": "البيانات التي نحتفظ بها وسببها",
      "del.kept.orders": "يتم الاحتفاظ بسجلات الشراء (رقم الطلب والتاريخ والمبلغ وحالة الدفع) للوفاء بالالتزامات الضريبية والمحاسبية. لا تتضمن هذه السجلات اسمك أو بريدك الإلكتروني أو بيانات الدفع، بل معرّفًا لا يمكن ربطه بك.",
      "del.kept.period": "مدة الاحتفاظ: 5 سنوات (قانون الإجراءات الضريبية التركي، المادة 253).",
      "del.warn.title": "قبل الحذف",
      "del.warn.irreversible": "لا يمكن التراجع عن هذا الإجراء.",
      "del.warn.esim": "تستمر شرائح eSIM النشطة في العمل على جهازك، لكن لن تتمكن بعد الآن من الوصول إلى رمز QR أو رصيدك المتبقي. احفظ رمز QR قبل الحذف.",
      "del.warn.rejoin": "يمكنك التسجيل مرة أخرى بالبريد الإلكتروني نفسه، لكن شرائح eSIM السابقة لن تظهر في الحساب الجديد.",
      "del.support": "إذا تعذّر عليك تسجيل الدخول، يمكنك أيضًا طلب الحذف عبر البريد الإلكتروني:",
      "del.login.title": "سجّل الدخول أولًا",
      "del.login.subtitle": "أدخل بريدك الإلكتروني وكلمة المرور للتأكد من أن الحساب يخصّك.",
      "del.login.action": "تسجيل الدخول",
      "del.login.loading": "جاري تسجيل الدخول...",
      "del.forgot": "هل نسيت كلمة المرور؟",
      "del.confirm.title": "هل أنت متأكد؟",
      "del.confirm.subtitle": "سيتم حذف الحساب {{email}} وبياناتك الشخصية نهائيًا.",
      "del.confirm.field": "اكتب بريدك الإلكتروني مرة أخرى للتأكيد",
      "del.confirm.action": "حذف حسابي نهائيًا",
      "del.confirm.deleting": "جاري الحذف...",
      "del.confirm.cancel": "إلغاء",
      "del.done.title": "تم حذف حسابك",
      "del.done.body": "تم حذف بياناتك الشخصية نهائيًا.",
      "del.done.retained": "تم حذف بياناتك الشخصية نهائيًا. تم الاحتفاظ بـ {{n}} من سجلات الشراء للوفاء بالالتزامات القانونية، ولا يمكن ربطها بك.",
      "del.done.home": "العودة إلى المتجر",
      "del.error.required": "يرجى إدخال بريدك الإلكتروني وكلمة المرور.",
      "del.error.credentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
      "del.error.suspended": "تم تعليق حسابك. يرجى التواصل مع الدعم.",
      "del.error.session": "انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.",
      "del.error.network": "تعذّر الاتصال. تحقق من اتصالك بالإنترنت وحاول مرة أخرى.",
      "del.error.generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      "footer.deleteAccount": "حذف الحساب",


      // باقات الصوت (بيانات + مكالمات ورسائل غير محدودة) — docs/ses-paketleri.md
      "home.tabs.voice": "شرائح eSIM مع المكالمات",
      "detail.voice": "مكالمات + رسائل",
      "detail.voiceNote": "تتضمن هذه الباقة مكالمات ورسائل SMS غير محدودة إضافة إلى الإنترنت — شريحة واحدة للإنترنت والمكالمات.",
      "detail.calls": "المكالمات",
      "detail.sms": "الرسائل",
      "plan.unlimitedCalls": "مكالمات غير محدودة",
      "plan.unlimitedSms": "رسائل SMS غير محدودة",
      "plan.minutes": "{{n}} دقيقة مكالمات",
      "plan.sms": "{{n}} رسالة SMS",
      "loading": "جاري التحميل..."
    }
  },
  it: {
    translation: {

      "hero.title": "Utkan eSIM",
      "hero.subtitle": "Il Futuro della Connettività Digitale",
      "hero.description": "Eliminiamo i confini con un'esperienza di connettività digitale di nuova generazione.",
      "hero.description2": "Soluzioni eSIM veloci, sicure e convenienti in tutto il mondo.",
      "features.countries": "150+ Paesi",
      "features.activation": "Attivazione Istantanea",
      "features.support": "Supporto 24/7",
      "countdown.title": "Il Nostro Sito Web Arriverà Presto!",
      "countdown.days": "Giorni",
      "countdown.hours": "Ore",
      "countdown.minutes": "Minuti",
      "countdown.seconds": "Secondi",
      "countdown.launch": "Il Nostro Sito Web È Aperto!",
      "countdown.loading": "Caricamento...",
      "apps.title": "Le Nostre Applicazioni Mobili",
      "apps.ios.label": "Scarica su",
      "apps.ios.name": "App Store",
      "apps.android.label": "DISPONIBILE SU",
      "apps.android.name": "Google Play",
      "contact.title": "Contattaci Prima del Lancio",
      "contact.whatsapp": "WhatsApp: +43 676 555 1 333",
      "contact.email": "E-mail: info@utkanesim.com",
      "about.hero.title": "Informazioni su Utkan eSIM",
      "about.hero.description": "La sicurezza dei tuoi dati personali è molto importante per noi. Questa politica spiega come i tuoi dati vengono raccolti, utilizzati e protetti.",
      "about.story.title": "La Nostra Storia",
      "about.story.content": "Fondata nel 2024 da un team di viaggiatori appassionati e appassionati di tecnologia, Utkan eSIM mira a rivoluzionare il modo in cui le persone si connettono a Internet all'estero. Offrendo piani dati eSIM affidabili e di alta qualità per oltre 190 paesi e regioni, garantiamo il tuo accesso rapido a Internet dal momento in cui atterri.",
      "about.mission.title": "La Nostra Missione",
      "about.mission.content": "Fornire ai viaggiatori una connettività globale semplice, conveniente e istantanea, consentendo loro di esplorare, lavorare e rimanere in contatto senza confini.",
      "about.vision.title": "La Nostra Visione",
      "about.vision.content": "Essere la piattaforma globale leader per le soluzioni di connettività digitale, rendendo il mondo un posto più piccolo e più connesso per tutti.",
      "about.features.title": "Perché Sceglierci?",
      "about.features.instant.title": "Consegna Istantanea",
      "about.features.instant.content": "Ottieni la tua eSIM istantaneamente con un codice QR dopo l'acquisto.",
      "about.features.global.title": "Copertura Globale",
      "about.features.global.content": "Piani dati per oltre 190 paesi e regioni.",
      "about.features.affordable.title": "Prezzi Convenienti",
      "about.features.affordable.content": "Risparmia fino al 90% sulle tariffe di roaming.",
      "about.features.support.title": "Supporto 24/7",
      "about.features.support.content": "Il nostro team di supporto dedicato è sempre a tua disposizione.",
      "about.features.secure.title": "Connessione Sicura",
      "about.features.secure.content": "Connessione protetta dagli ultimi protocolli di sicurezza.",
      "about.features.fast.title": "Internet Veloce",
      "about.features.fast.content": "Esperienza Internet ininterrotta a velocità 4G/5G.",
      "about.cta.title": "Unisciti al Futuro della Connettività Digitale",
      "about.cta.content": "Grazie per aver scelto Utkan eSIM. Buon viaggio!",
      "about.cta.whatsapp": "Contatta tramite WhatsApp",
      "about.cta.email": "Invia un'E-mail",
      "contact.hero.title": "Contattaci",
      "contact.hero.description": "Se hai domande sulle nostre eSIM, hai bisogno di supporto tecnico o vuoi semplicemente lasciare un feedback, saremo felici di ascoltarti.",
      "contact.info.title": "Le Nostre Informazioni di Contatto",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "Supporto Rapido 24/7",
      "contact.email.title": "E-mail",
      "contact.email.subtitle": "Contatto Generale",
      "contact.support.title": "Supporto Tecnico",
      "contact.support.subtitle": "Problemi eSIM",
      "contact.business.title": "Partnership Commerciale",
      "contact.business.subtitle": "Contatto Aziendale",
      "contact.hours.title": "Orari di Supporto",
      "contact.hours.subtitle": "Supporto Tecnico 24/7",
      "contact.hours.detail": "Lunedì - Domenica: 00:00 - 23:59",
      "contact.form.title": "Invia un Messaggio",
      "contact.form.name": "Nome e Cognome",
      "contact.form.name.placeholder": "Inserisci il tuo nome e cognome",
      "contact.form.email": "Il Tuo Indirizzo E-mail",
      "contact.form.email.placeholder": "esempio@email.com",
      "contact.form.subject": "Oggetto",
      "contact.form.subject.placeholder": "Seleziona un oggetto",
      "contact.form.subject.general": "Informazioni Generali",
      "contact.form.subject.technical": "Supporto Tecnico",
      "contact.form.subject.billing": "Domande sulla Fatturazione",
      "contact.form.subject.partnership": "Partnership Commerciale",
      "contact.form.subject.feedback": "Feedback",
      "contact.form.message": "Il Tuo Messaggio",
      "contact.form.message.placeholder": "Scrivi qui il tuo messaggio...",
      "contact.form.submit": "Invia Messaggio",
      "contact.faq.title": "Domande Frequenti",
      "contact.faq.esim.title": "Come funziona la eSIM?",
      "contact.faq.esim.content": "La eSIM è una scheda SIM digitale che funziona nel tuo telefono senza la necessità di una scheda SIM fisica. Viene attivata istantaneamente con un codice QR.",
      "contact.faq.phones.title": "Quali telefoni supportano la eSIM?",
      "contact.faq.phones.content": "I modelli iPhone XS e successivi, Samsung Galaxy S20 e successivi, Google Pixel 3 e successivi supportano la eSIM.",
      "contact.faq.validity.title": "Per quanto tempo è valido il mio piano dati?",
      "contact.faq.validity.content": "Il periodo di validità dei piani varia da 1 a 30 giorni a seconda del piano scelto.",
      "contact.faq.payment.title": "Come si effettua il pagamento?",
      "contact.faq.payment.content": "Puoi pagare in modo sicuro con carta di credito, PayPal e bonifico bancario.",
      "privacy.hero.title": "Informativa sulla Privacy",
      "privacy.hero.description": "La sicurezza dei tuoi dati personali è molto importante per noi. Questa politica spiega come i tuoi dati vengono raccolti, utilizzati e protetti.",
      "privacy.overview.title": "Panoramica",
      "privacy.overview.content": "Questa Informativa sulla Privacy descrive le nostre politiche e procedure sulla raccolta, l'uso e la divulgazione delle tue informazioni quando utilizzi il nostro Servizio. Ti informa inoltre sui tuoi diritti alla privacy e su come la legge ti protegge.",
      "privacy.data.title": "Dati che Raccogliamo",
      "privacy.data.personal.title": "Informazioni Personali",
      "privacy.data.personal.name": "Nome e cognome",
      "privacy.data.personal.email": "Indirizzo e-mail",
      "privacy.data.personal.phone": "Numero di telefono",
      "privacy.data.personal.payment": "Informazioni di pagamento",
      "privacy.data.usage.title": "Dati di Utilizzo",
      "privacy.data.usage.ip": "Indirizzo IP",
      "privacy.data.usage.browser": "Tipo di browser",
      "privacy.data.usage.device": "Informazioni sul dispositivo",
      "privacy.data.usage.stats": "Statistiche di utilizzo",
      "privacy.security.title": "Sicurezza dei Dati",
      "privacy.security.ssl.title": "Crittografia SSL",
      "privacy.security.ssl.content": "Tutti i trasferimenti di dati sono protetti da crittografia SSL a 256 bit.",
      "privacy.security.servers.title": "Server Sicuri",
      "privacy.security.servers.content": "I tuoi dati sono archiviati su server sicuri certificati ISO 27001.",
      "privacy.security.access.title": "Controllo degli Accessi",
      "privacy.security.access.content": "Solo il personale autorizzato può accedere ai tuoi dati.",
      "privacy.usage.title": "Utilizzo dei Dati",
      "privacy.usage.intro": "Utilizziamo i dati che raccogliamo per i seguenti scopi:",
      "privacy.usage.service.title": "Fornitura del Servizio",
      "privacy.usage.service.content": "Per fornire e gestire i nostri servizi eSIM",
      "privacy.usage.support.title": "Assistenza Clienti",
      "privacy.usage.support.content": "Per fornire supporto tecnico e servizio clienti",
      "privacy.usage.security.title": "Sicurezza",
      "privacy.usage.security.content": "Per proteggere il tuo account e i nostri servizi",
      "privacy.usage.improvement.title": "Miglioramento",
      "privacy.usage.improvement.content": "Per migliorare i nostri servizi e aggiungere nuove funzionalità",
      "privacy.sharing.title": "Condivisione dei Dati",
      "privacy.sharing.intro": "Non condividiamo i tuoi dati personali con terze parti, ma la condivisione potrebbe essere necessaria nei seguenti casi:",
      "privacy.sharing.legal": "In caso di obbligo legale",
      "privacy.sharing.providers": "Con i nostri fornitori di servizi (come i processori di pagamento)",
      "privacy.sharing.threats": "Per prevenire minacce alla sicurezza",
      "privacy.sharing.consent": "Con il tuo esplicito consenso",
      "privacy.rights.title": "I Tuoi Diritti",
      "privacy.rights.access.title": "Diritto di Accesso",
      "privacy.rights.access.content": "Puoi richiedere l'accesso ai dati che conserviamo su di te.",
      "privacy.rights.correction.title": "Diritto di Rettifica",
      "privacy.rights.correction.content": "Possiamo correggere i tuoi dati inesatti o incompleti.",
      "privacy.rights.deletion.title": "Diritto di Cancellazione",
      "privacy.rights.deletion.content": "Possiamo cancellare i tuoi dati a determinate condizioni.",
      "privacy.rights.objection.title": "Diritto di Opposizione",
      "privacy.rights.objection.content": "Puoi opporti alle nostre attività di trattamento dei dati.",
      "privacy.contact.title": "Contatto",
      "privacy.contact.intro": "In caso di domande sulla presente Informativa sulla Privacy, è possibile contattarci tramite i seguenti canali:",
      "nav.about": "Chi Siamo",
      "nav.contact": "Contatti",
      "nav.privacy": "Privacy",
      "nav.login": "Accedi",
      "nav.account": "Il Mio Account",
      "nav.logout": "Esci",
      "auth.brand.eyebrow": "COPERTURA GLOBALE",
      "auth.brand.title": "Internet dal momento in cui atterri in più di 150 paesi.",
      "auth.brand.subtitle": "Nessuna SIM fisica, nessuna bolletta di roaming. Attiva la tua eSIM in pochi secondi.",
      "auth.login.eyebrow": "ACCESSO ALL'ACCOUNT",
      "auth.login.title": "Bentornato",
      "auth.login.subtitle": "Gestisci le tue eSIM e scoprine di nuove.",
      "auth.signup.eyebrow": "NUOVO ACCOUNT",
      "auth.signup.title": "Unisciti a noi",
      "auth.signup.subtitle": "Prepara la tua prima eSIM in pochi passaggi.",
      "auth.field.identifier": "E-mail o telefono",
      "auth.field.identifier.ph": "esempio@email.com o +39…",
      "auth.field.email": "E-mail",
      "auth.field.email.ph": "esempio@email.com",
      "auth.field.fullName": "Nome e cognome",
      "auth.field.fullName.ph": "Il tuo nome e cognome",
      "auth.field.password": "Password",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "Accedi",
      "auth.action.loggingIn": "Accesso in corso…",
      "auth.action.signup": "Crea account",
      "auth.action.signingUp": "Creazione account…",
      "auth.toSignup.q": "Non hai un account?",
      "auth.toSignup.link": "Registrati",
      "auth.toLogin.q": "Hai già un account?",
      "auth.toLogin.link": "Accedi",
      "auth.password.show": "Mostra password",
      "auth.password.hide": "Nascondi password",
      "auth.terms.prefix": "Continuando, accetto i ",
      "auth.terms.link": "Termini di Utilizzo e l'Informativa sulla Privacy",
      "auth.terms.suffix": ".",
      "auth.error.required": "Si prega di compilare i campi richiesti.",
      "auth.error.terms": "Devi accettare i termini per continuare.",
      "verify.eyebrow": "VERIFICA E-MAIL",
      "verify.title": "Verifica la tua e-mail",
      "verify.subtitle": "Abbiamo inviato un codice a 6 cifre a {{email}}. Inserisci il codice per verificare.",
      "verify.code": "Codice di verifica",
      "verify.code.ph": "••••••",
      "verify.action": "Verifica",
      "verify.verifying": "Verifica in corso…",
      "verify.resend": "Invia di nuovo il codice",
      "verify.resendIn": "Invia di nuovo in {{seconds}} s",
      "verify.resent": "Nuovo codice inviato.",
      "verify.skip": "Salta per ora",
      "auth.forgot.link": "Hai dimenticato la password?",
      "forgot.eyebrow": "REIMPOSTA PASSWORD",
      "forgot.email.title": "Reimposta la tua password",
      "forgot.email.subtitle": "Inserisci l'indirizzo e-mail del tuo account; ti invieremo un codice di ripristino a 6 cifre.",
      "forgot.email.action": "Invia codice",
      "forgot.email.sending": "Invio in corso…",
      "forgot.reset.title": "Imposta la tua nuova password",
      "forgot.reset.subtitle": "Inserisci il codice a 6 cifre che abbiamo inviato a {{email}} e la tua nuova password.",
      "forgot.reset.action": "Aggiorna password",
      "forgot.reset.updating": "Aggiornamento in corso…",
      "forgot.field.code": "Codice di ripristino",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "Nuova password",
      "forgot.field.newPassword.ph": "Almeno 6 caratteri",
      "forgot.resend": "Invia di nuovo il codice",
      "forgot.resendIn": "Invia di nuovo in {{seconds}} s",
      "forgot.resent": "Nuovo codice inviato.",
      "forgot.backToLogin": "Torna all'accesso",
      "forgot.changeEmail": "Cambia e-mail",
      "forgot.help.noMail": "Se il codice non è arrivato, controlla la cartella spam o verifica il tuo indirizzo e-mail.",
      "reset.RESET_CODE_SENT": "Codice inviato. Controlla la tua e-mail.",
      "reset.RATE_LIMITED": "Hai effettuato troppi tentativi. Attendi un momento e riprova.",
      "reset.MAIL_SEND_FAILED": "Qualcosa è andato storto. Riprova più tardi.",
      "reset.RESET_CODE_VALID": "Codice verificato.",
      "reset.INVALID_RESET_CODE": "Codice errato. Riprova.",
      "reset.EXPIRED_RESET_CODE": "Il codice è scaduto. Richiedi un nuovo codice.",
      "reset.WEAK_PASSWORD": "La password deve contenere almeno 6 caratteri.",
      "reset.PASSWORD_RESET_SUCCESS": "La tua password è stata aggiornata. Puoi accedere con la tua nuova password.",
      "reset.generic": "Qualcosa è andato storto. Riprova.",
      "login.resetSuccess": "La tua password è stata aggiornata. Puoi accedere con la tua nuova password.",
      "store.nav.shop": "Negozio",
      "home.hero.title1": "Connettiti in pochi minuti,",
      "home.hero.title2": "rimani oltre i confini.",
      "home.hero.subtitle": "Piani eSIM affidabili validi in oltre 190 paesi. Nessuna SIM fisica, nessuna bolletta di roaming.",
      "home.search.placeholder": "Dove viaggi?",
      "home.tabs.local": "eSIM locali",
      "home.tabs.regional": "eSIM regionali",
      "home.tabs.lifetime": "eSIM a vita",
      "home.empty": "Nessun risultato trovato per la tua ricerca.",
      "home.error.title": "Impossibile caricare i contenuti",
      "home.error.retry": "Riprova",
      "home.from": "da",
      "home.popular": "Destinazioni popolari",
      "home.coverage": "190+ paesi · attivazione istantanea",
      "home.detail.soon": "I piani per questa selezione verranno elencati qui a breve.",
      "home.detail.back": "Torna al negozio",
      "detail.plans": "Piani",
      "detail.count": "{{count}} piano/i",
      "detail.validity": "{{days}} giorni",
      "detail.validityLifetime": "Senza scadenza",
      "detail.buy": "Acquista",
      "detail.empty": "Al momento non ci sono piani per questa selezione.",
      "detail.checkoutSoon": "Il flusso di pagamento verrà aggiunto a breve.",
      "detail.loginToBuy": "Devi accedere per acquistare.",
      "detail.basicFeatures": "Caratteristiche di base",
      "detail.dataAmount": "Quantità di dati",
      "detail.validityLabel": "Periodo di validità",
      "detail.coverageArea": "Area di copertura",
      "detail.activationNetworks": "Attivazione e Reti",
      "detail.activationMethod": "Metodo di attivazione",
      "detail.esimActivation": "eSIM — istantaneo con codice QR",
      "detail.supportedNetworks": "Reti supportate",
      "detail.description": "Descrizione",
      "detail.price": "Prezzo",
      "authprompt.title": "Accedi per continuare",
      "authprompt.message": "Accedi al tuo account per acquistare una eSIM o crea un nuovo account in pochi secondi.",
      "authprompt.close": "Chiudi",
      "footer.tagline": "eSIM veloce, sicura e conveniente in tutto il mondo. Connettiti a Internet non appena atterri.",
      "footer.explore": "Esplora",
      "footer.support": "Supporto",
      "footer.legal": "Legale",
      "footer.shop": "Negozio",
      "footer.help": "Domande Frequenti",
      "footer.terms": "Termini di Utilizzo",
      "footer.rights": "© {{year}} Utkan eSIM. Tutti i diritti riservati.",
      "footer.apps": "Scarica l'app",
      "whatsapp.label": "Scrivici su WhatsApp",
      "whatsapp.message": "Ciao, ho una richiesta di supporto per la eSIM.",
      "notfound.eyebrow": "NESSUN SEGNALE",
      "notfound.title": "Questa pagina non è disponibile",
      "notfound.message": "La pagina che stai cercando potrebbe essere stata spostata o non è mai esistita. Ti riportiamo nell'area di copertura.",
      "order.congrats": "Congratulazioni!",
      "order.message": "La tua eSIM è pronta. Puoi configurarla in pochi passaggi con il codice QR qui sotto.",
      "order.details": "Riepilogo dell'ordine",
      "order.activation": "Attivazione",
      "order.activationDesc": "Per configurare la tua eSIM, scansiona il codice QR con la fotocamera del tuo dispositivo o inserisci manualmente il codice di configurazione.",
      "order.qrTitle": "Codice QR eSIM",
      "order.manualLabel": "Codice di configurazione",
      "order.copy": "Copia",
      "order.copied": "Copiato",
      "order.howTo": "Come attivare?",
      "order.step1": "Vai su Impostazioni > Cellulare / Dati mobili > Aggiungi eSIM sul tuo dispositivo.",
      "order.step2": "Seleziona \"Usa codice QR\" e scansiona il codice QR sopra (o inserisci manualmente il codice di configurazione).",
      "order.step3": "Una volta completata l'installazione, attiva il tuo piano eSIM.",
      "order.step4": "Assicurati che il roaming dati sia attivo — ora sei connesso!",
      "order.cta": "Torna alla home page",
      "checkout.title": "Pagamento",
      "checkout.summary": "Riepilogo dell'ordine",
      "checkout.total": "Totale",
      "checkout.eurNote": "L'importo viene addebitato in euro (€) su PayPal.",
      "checkout.processing": "Verifica del pagamento in corso…",
      "checkout.error": "Non è stato possibile completare il pagamento. Riprova.",
      "checkout.cancelled": "Pagamento annullato.",
      "account.title": "Il Mio Account",
      "account.tab.profile": "Profilo",
      "account.tab.esims": "Le Mie eSIM",
      "account.tab.security": "Sicurezza",
      "account.profile.title": "Informazioni del profilo",
      "account.field.phone": "Telefono",
      "account.field.phone.ph": "+39…",
      "account.memberSince": "Membro dal",
      "account.save": "Salva",
      "account.saving": "Salvataggio in corso…",
      "account.saved": "Le tue informazioni sono state aggiornate.",
      "account.esims.title": "Le Mie eSIM",
      "account.esims.empty": "Non hai ancora una eSIM.",
      "account.esims.emptyCta": "Esplora il negozio",
      "account.esims.data": "Dati",
      "account.esims.expires": "Data di fine",
      "account.esims.viewQr": "Mostra codice QR",
      "account.esims.hideQr": "Nascondi codice QR",
      "account.esims.active": "Attivo",
      "account.esims.passive": "Inattivo",
      "account.esims.noActive": "Non hai eSIM attive.",
      "account.esims.noPassive": "Non hai eSIM inattive.",
      "account.esims.readyHint": "Pronto per l'uso — la durata inizia al primo utilizzo.",
      "account.esims.unavailableHint": "Al momento non è stato possibile caricare lo stato. Riprova più tardi.",
      "esimStatus.active": "Attivo",
      "esimStatus.readyToUse": "Pronto per l'uso",
      "esimStatus.inactive": "Inattivo",
      "esimStatus.unavailable": "Impossibile caricare lo stato",
      "account.security.title": "Cambia password",
      "account.field.oldPassword": "Password attuale",
      "account.field.newPassword": "Nuova password",
      "account.field.confirmPassword": "Nuova password (ripeti)",
      "account.changePassword": "Aggiorna password",
      "account.passwordChanged": "La tua password è stata aggiornata.",
      "account.error.passwordMismatch": "Le nuove password non corrispondono.",
      "account.danger.title": "Azioni sull'account",
      "account.delete": "Elimina account",
      "account.delete.confirm": "Stai per eliminare definitivamente il tuo account. Questa azione non può essere annullata.",
      "account.delete.confirmBtn": "Sì, elimina",
      "account.cancel": "Annulla",
      "esimDetail.back": "Indietro",
      "esimDetail.dataUsage": "Utilizzo dati",
      "esimDetail.left": "rimanente",
      "esimDetail.leftData": "Dati rimanenti",
      "esimDetail.usedData": "Utilizzato",
      "esimDetail.totalData": "Dati totali",
      "esimDetail.qrDesc": "Configura la tua eSIM scansionando questo codice QR con la fotocamera del tuo dispositivo.",
      "esimDetail.validity": "Validità",
      "esimDetail.daysLeft": "{{days}} giorno/i rimanente/i",
      "esimDetail.expired": "Scaduto",
      "esimDetail.notYetActive": "Non ancora attivo",
      "esimDetail.leftDate": "Tempo rimanente",
      "esimDetail.activationDate": "Data di attivazione",
      "esimDetail.endDate": "Data di fine",
      "esimDetail.technical": "Informazioni tecniche",
      "esimDetail.activationCode": "Codice di attivazione (Android)",
      "esimDetail.smdp": "Indirizzo SM-DP+ (iOS)",
      "esimDetail.matchingId": "ID di corrispondenza (iOS)",
      "esimDetail.support": "Supporto tecnico",
      "esimDetail.supportDesc": "Hai qualche problema? Lasciati aiutare.",
      "esimDetail.email": "Invia un'e-mail",
      "guide.eyebrow": "GUIDA eSIM",
      "guide.title": "Cos'è una eSIM e come installarla?",
      "guide.intro.title": "Cos'è una eSIM?",
      "guide.intro.body": "La eSIM è una SIM digitale integrata nel tuo dispositivo che funziona senza la necessità di una scheda SIM fisica. Configura la tua linea in pochi secondi scansionando un codice QR; ti connetti a Internet in oltre 190 paesi senza cambiare scheda e senza bollette di roaming.",
      "guide.steps.title": "Come attivarla?",
      "guide.devices.title": "Dispositivi supportati",
      "guide.devices.desc": "Il tuo dispositivo deve essere compatibile con eSIM affinché funzioni. Controlla il tuo marchio.",
      "guide.faq.title": "Domande frequenti",
      "nav.guide": "Guida eSIM",
      "currency.label": "Valuta",
      "staticPage.loading": "Caricamento della pagina...",
      "staticPage.errorTitle": "Si È Verificato Un Errore",
      "staticPage.retry": "Riprova",
      "staticPage.loadFailed": "Impossibile caricare il contenuto della pagina. Riprova più tardi.",
      "last.updated": "Ultimo aggiornamento: 8 luglio 2024",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "eSIM illimitate",
      "detail.unlimited": "Illimitato",
      "detail.unlimitedNote": "Questo pacchetto non ha limiti di dati: internet illimitato per tutta la durata di validità.",
      "detail.notPriced": "Questo pacchetto non è al momento acquistabile dal web.",
      "checkout.priceUpdated": "Il prezzo di questo pacchetto è cambiato. Torna al negozio e selezionalo di nuovo.",
      "order.pending.title": "La tua eSIM è in preparazione",
      "order.pending.message": "Il pagamento è andato a buon fine. I pacchetti illimitati possono richiedere qualche minuto per l'attivazione.",
      "order.pending.waiting": "Verifica dello stato dell'ordine…",
      "order.pending.ready": "La tua eSIM è pronta!",
      "order.pending.timeout": "Sta impiegando più tempo del previsto. Il pagamento è al sicuro: la tua eSIM comparirà in «Le mie eSIM» non appena sarà pronta.",
      "order.pending.cta": "Vai a Le mie eSIM",
      "account.esims.unlimited": "Illimitato",
      "account.esims.unlimitedHint": "Dati illimitati: questo pacchetto non ha limiti di dati.",
      "esimDetail.unlimitedData": "Questo pacchetto non ha limiti di dati; vedi il tempo rimanente qui sotto.",


      // Eliminazione account (/hesap-sil · /account-deletion) — requisito Google Play «Data deletion»
      "del.eyebrow": "Eliminazione account",
      "del.title": "Elimina il mio account",
      "del.intro": "Qui puoi eliminare definitivamente il tuo account Utkan eSIM e i tuoi dati personali. Non serve avere l'app installata: basta accedere con l'account che vuoi eliminare.",
      "del.deleted.title": "Dati che vengono eliminati",
      "del.deleted.identity": "Nome, cognome, indirizzo e-mail e numero di telefono",
      "del.deleted.credentials": "La tua password e i dati di sessione",
      "del.deleted.codes": "I codici di verifica e-mail e di reimpostazione della password",
      "del.deleted.esim": "Il numero eSIM (MSISDN), il codice QR/di attivazione e i dati di utilizzo",
      "del.kept.title": "Dati che conserviamo e perché",
      "del.kept.orders": "I documenti di acquisto (numero d'ordine, data, importo, stato del pagamento) vengono conservati per obblighi fiscali e contabili. Non contengono nome, e-mail o dati di pagamento: solo un identificativo che non può essere ricondotto a te.",
      "del.kept.period": "Periodo di conservazione: 5 anni (legge turca sulla procedura fiscale, art. 253).",
      "del.warn.title": "Prima di eliminare",
      "del.warn.irreversible": "Questa operazione non può essere annullata.",
      "del.warn.esim": "Le eSIM attive continuano a funzionare sul tuo dispositivo, ma non potrai più accedere al codice QR né ai dati residui. Salva il codice QR prima di procedere.",
      "del.warn.rejoin": "Puoi registrarti di nuovo con la stessa e-mail, ma le eSIM precedenti non compariranno nel nuovo account.",
      "del.support": "Se non riesci ad accedere, puoi richiedere la cancellazione anche via e-mail:",
      "del.login.title": "Prima accedi",
      "del.login.subtitle": "Inserisci e-mail e password per confermare che l'account è tuo.",
      "del.login.action": "Accedi",
      "del.login.loading": "Accesso in corso...",
      "del.forgot": "Password dimenticata?",
      "del.confirm.title": "Sei sicuro?",
      "del.confirm.subtitle": "L'account {{email}} e i tuoi dati personali verranno eliminati definitivamente.",
      "del.confirm.field": "Digita di nuovo il tuo indirizzo e-mail per confermare",
      "del.confirm.action": "Elimina definitivamente il mio account",
      "del.confirm.deleting": "Eliminazione...",
      "del.confirm.cancel": "Annulla",
      "del.done.title": "Il tuo account è stato eliminato",
      "del.done.body": "I tuoi dati personali sono stati eliminati definitivamente.",
      "del.done.retained": "I tuoi dati personali sono stati eliminati definitivamente. {{n}} documento/i di acquisto sono stati conservati per obblighi di legge e non possono essere ricondotti a te.",
      "del.done.home": "Torna allo store",
      "del.error.required": "Inserisci e-mail e password.",
      "del.error.credentials": "E-mail o password non corretti.",
      "del.error.suspended": "Il tuo account è stato sospeso. Contatta il supporto.",
      "del.error.session": "La tua sessione è scaduta. Accedi di nuovo.",
      "del.error.network": "Impossibile connettersi. Controlla la connessione a Internet e riprova.",
      "del.error.generic": "Si è verificato un errore. Riprova.",
      "footer.deleteAccount": "Elimina account",


      // Piani voce (dati + chiamate e SMS illimitati) — docs/ses-paketleri.md
      "home.tabs.voice": "eSIM con chiamate",
      "detail.voice": "Chiamate + SMS",
      "detail.voiceNote": "Questo piano include chiamate e SMS illimitati oltre ai dati: una sola eSIM per internet e chiamate.",
      "detail.calls": "Chiamate",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "Chiamate illimitate",
      "plan.unlimitedSms": "SMS illimitati",
      "plan.minutes": "{{n}} min di chiamate",
      "plan.sms": "{{n}} SMS",
      "loading": "Caricamento..."
    }
  },
  zh: {
    translation: {
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "数字连接的未来",
      "hero.description": "我们通过新一代数字连接体验打破界限。",
      "hero.description2": "全球快速、安全且实惠的 eSIM 解决方案。",
      "features.countries": "150+ 国家",
      "features.activation": "即时激活",
      "features.support": "7/24 支持",
      "countdown.title": "我们的网站即将上线！",
      "countdown.days": "天",
      "countdown.hours": "小时",
      "countdown.minutes": "分钟",
      "countdown.seconds": "秒",
      "countdown.launch": "我们的网站已开通！",
      "countdown.loading": "加载中...",
      "apps.title": "我们的移动应用",
      "apps.ios.label": "下载于",
      "apps.ios.name": "App Store",
      "apps.android.label": "获取于",
      "apps.android.name": "Google Play",
      "contact.title": "在发布前联系我们",
      "contact.whatsapp": "WhatsApp：+43 676 555 1 333",
      "contact.email": "电子邮箱：info@utkanesim.com",
      "about.hero.title": "关于 Utkan eSIM",
      "about.hero.description": "您的个人数据安全对我们至关重要。本政策解释了您的数据是如何被收集、使用和保护的。",
      "about.story.title": "我们的故事",
      "about.story.content": "Utkan eSIM 由一群热情的旅行者和技术爱好者于 2024 年创立，旨在彻底改变人们在海外连接互联网的方式。通过为 190 多个国家和地区提供高质量、可靠的 eSIM 数据套餐，我们确保您在降落的那一刻就能快速接入互联网。",
      "about.mission.title": "我们的使命",
      "about.mission.content": "为全球旅行者提供简单、实惠且即时的连接，让他们能够无国界地探索、工作和保持联系。",
      "about.vision.title": "我们的愿景",
      "about.vision.content": "成为数字连接解决方案的领先全球平台，让世界对每个人来说变得更小、联系更紧密。",
      "about.features.title": "为什么选择我们？",
      "about.features.instant.title": "即时交付",
      "about.features.instant.content": "购买后通过二维码即时获取您的 eSIM。",
      "about.features.global.title": "全球覆盖",
      "about.features.global.content": "覆盖 190 多个国家和地区的数据套餐。",
      "about.features.affordable.title": "实惠价格",
      "about.features.affordable.content": "漫游费用最高可省 90%。",
      "about.features.support.title": "7/24 支持",
      "about.features.support.content": "我们的专属支持团队随时为您提供帮助。",
      "about.features.secure.title": "安全连接",
      "about.features.secure.content": "受最新安全协议保护的连接。",
      "about.features.fast.title": "高速上网",
      "about.features.fast.content": "4G/5G 速度下的无缝互联网体验。",
      "about.cta.title": "加入数字连接的未来",
      "about.cta.content": "感谢您选择 Utkan eSIM。祝您旅途愉快！",
      "about.cta.whatsapp": "通过 WhatsApp 联系",
      "about.cta.email": "发送电子邮件",
      "contact.hero.title": "联系我们",
      "contact.hero.description": "如果您对我们的 eSIM 有任何疑问、需要技术支持或只是想提供反馈，我们随时期待您的来信。",
      "contact.info.title": "我们的联系方式",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "7/24 快速支持",
      "contact.email.title": "电子邮箱",
      "contact.email.subtitle": "一般联系",
      "contact.support.title": "技术支持",
      "contact.support.subtitle": "eSIM 问题",
      "contact.business.title": "业务合作",
      "contact.business.subtitle": "企业联络",
      "contact.hours.title": "支持时间",
      "contact.hours.subtitle": "7/24 技术支持",
      "contact.hours.detail": "周一 - 周日：00:00 - 23:59",
      "contact.form.title": "发送消息",
      "contact.form.name": "您的姓名",
      "contact.form.name.placeholder": "请输入您的姓名",
      "contact.form.email": "您的电子邮箱",
      "contact.form.email.placeholder": "ornek@email.com",
      "contact.form.subject": "主题",
      "contact.form.subject.placeholder": "选择主题",
      "contact.form.subject.general": "一般信息",
      "contact.form.subject.technical": "技术支持",
      "contact.form.subject.billing": "账单问题",
      "contact.form.subject.partnership": "业务合作",
      "contact.form.subject.feedback": "反馈意见",
      "contact.form.message": "您的消息",
      "contact.form.message.placeholder": "在此处输入您的消息...",
      "contact.form.submit": "发送消息",
      "contact.faq.title": "常见问题",
      "contact.faq.esim.title": "eSIM 是如何工作的？",
      "contact.faq.esim.content": "eSIM 是一种无需实体 SIM 卡即可在手机上运行的数字 SIM 卡。它通过二维码即时激活。",
      "contact.faq.phones.title": "哪些手机支持 eSIM？",
      "contact.faq.phones.content": "iPhone XS 及更新机型、Samsung Galaxy S20 及更新机型、Google Pixel 3 及更新机型均支持 eSIM。",
      "contact.faq.validity.title": "我的数据套餐有效期是多久？",
      "contact.faq.validity.content": "套餐有效期根据您选择的计划在 1 至 30 天之间变化。",
      "contact.faq.payment.title": "如何进行支付？",
      "contact.faq.payment.content": "您可以使用信用卡、PayPal 和银行转账进行安全支付。",
      "privacy.hero.title": "隐私政策",
      "privacy.hero.description": "您的个人数据安全对我们至关重要。本政策解释了您的数据是如何被收集、使用和保护的。",
      "privacy.overview.title": "概述",
      "privacy.overview.content": "本隐私政策描述了当您使用我们的服务时，关于收集、使用和披露您的信息的政策和程序。它还告知您的隐私权以及法律如何保护您。",
      "privacy.data.title": "我们收集的数据",
      "privacy.data.personal.title": "个人信息",
      "privacy.data.personal.name": "姓名",
      "privacy.data.personal.email": "电子邮箱地址",
      "privacy.data.personal.phone": "电话号码",
      "privacy.data.personal.payment": "支付信息",
      "privacy.data.usage.title": "使用数据",
      "privacy.data.usage.ip": "IP 地址",
      "privacy.data.usage.browser": "浏览器类型",
      "privacy.data.usage.device": "设备信息",
      "privacy.data.usage.stats": "使用统计",
      "privacy.security.title": "数据安全",
      "privacy.security.ssl.title": "SSL 加密",
      "privacy.security.ssl.content": "所有数据传输均受到 256 位 SSL 加密保护。",
      "privacy.security.servers.title": "安全服务器",
      "privacy.security.servers.content": "您的数据存储在通过 ISO 27001 认证的安全服务器上。",
      "privacy.security.access.title": "访问控制",
      "privacy.security.access.content": "只有授权人员才能访问您的数据。",
      "privacy.usage.title": "数据使用",
      "privacy.usage.intro": "我们将收集的数据用于以下目的：",
      "privacy.usage.service.title": "提供服务",
      "privacy.usage.service.content": "为您提供和管理我们的 eSIM 服务",
      "privacy.usage.support.title": "客户支持",
      "privacy.usage.support.content": "提供技术支持和客户服务",
      "privacy.usage.security.title": "安全保障",
      "privacy.usage.security.content": "保护您的账户和我们的服务",
      "privacy.usage.improvement.title": "改进优化",
      "privacy.usage.improvement.content": "改进我们的服务并添加新功能",
      "privacy.sharing.title": "数据共享",
      "privacy.sharing.intro": "我们不会与第三方分享您的个人数据，但在以下情况下可能需要共享：",
      "privacy.sharing.legal": "在法律强制要求的情况下",
      "privacy.sharing.providers": "与我们的服务提供商（例如支付处理商）",
      "privacy.sharing.threats": "为了防范安全威胁",
      "privacy.sharing.consent": "在您明确同意的情况下",
      "privacy.rights.title": "您的权利",
      "privacy.rights.access.title": "访问权",
      "privacy.rights.access.content": "您可以请求访问我们持有的关于您的数据。",
      "privacy.rights.correction.title": "更正权",
      "privacy.rights.correction.content": "我们可以更正您不准确或不完整的数据。",
      "privacy.rights.deletion.title": "删除权",
      "privacy.rights.deletion.content": "在特定条件下我们可以删除您的数据。",
      "privacy.rights.objection.title": "异议权",
      "privacy.rights.objection.content": "您可以对我们的数据处理活动提出异议。",
      "privacy.contact.title": "联系方式",
      "privacy.contact.intro": "如果您对本隐私政策有任何疑问，可以通过以下渠道与我们联系：",
      "nav.about": "关于我们",
      "nav.contact": "联系我们",
      "nav.privacy": "隐私政策",
      "nav.login": "登录",
      "nav.account": "我的账户",
      "nav.logout": "退出登录",
      "auth.brand.eyebrow": "全球覆盖",
      "auth.brand.title": "覆盖 150 多个国家，落地即上网。",
      "auth.brand.subtitle": "无实体 SIM 卡，无漫游费。在几秒钟内激活您的 eSIM。",
      "auth.login.eyebrow": "账户登录",
      "auth.login.title": "欢迎回来",
      "auth.login.subtitle": "管理您的 eSIM 并发现新套餐。",
      "auth.signup.eyebrow": "新账户",
      "auth.signup.title": "加入我们",
      "auth.signup.subtitle": "只需几步即可准备好您的第一个 eSIM。",
      "auth.field.identifier": "电子邮箱或电话",
      "auth.field.identifier.ph": "ornek@email.com 或 +86…",
      "auth.field.email": "电子邮箱",
      "auth.field.email.ph": "ornek@email.com",
      "auth.field.fullName": "姓名",
      "auth.field.fullName.ph": "您的姓名",
      "auth.field.password": "密码",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "登录",
      "auth.action.loggingIn": "正在登录…",
      "auth.action.signup": "创建账户",
      "auth.action.signingUp": "正在创建账户…",
      "auth.toSignup.q": "没有账户？",
      "auth.toSignup.link": "注册",
      "auth.toLogin.q": "已经有账户了？",
      "auth.toLogin.link": "登录",
      "auth.password.show": "显示密码",
      "auth.password.hide": "隐藏密码",
      "auth.terms.prefix": "继续即表示我同意 ",
      "auth.terms.link": "使用条款与隐私政策",
      "auth.terms.suffix": "。",
      "auth.error.required": "请填写必填字段。",
      "auth.error.terms": "您必须接受条款才能继续。",
      "verify.eyebrow": "邮箱验证",
      "verify.title": "验证您的电子邮箱",
      "verify.subtitle": "我们已向 {{email}} 发送了 6 位验证码。请输入验证码进行验证。",
      "verify.code": "验证码",
      "verify.code.ph": "••••••",
      "verify.action": "验证",
      "verify.verifying": "正在验证…",
      "verify.resend": "重新发送验证码",
      "verify.resendIn": "{{seconds}} 秒后可重新发送",
      "verify.resent": "已发送新验证码。",
      "verify.skip": "暂时跳过",
      "auth.forgot.link": "忘记密码？",
      "forgot.eyebrow": "重置密码",
      "forgot.email.title": "重置您的密码",
      "forgot.email.subtitle": "输入您账户的电子邮箱地址；我们将向您发送一个 6 位数的重置验证码。",
      "forgot.email.action": "发送验证码",
      "forgot.email.sending": "正在发送…",
      "forgot.reset.title": "设置新密码",
      "forgot.reset.subtitle": "输入我们发送至 {{email}} 的 6 位验证码以及您的新密码。",
      "forgot.reset.action": "更新密码",
      "forgot.reset.updating": "正在更新…",
      "forgot.field.code": "重置验证码",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "新密码",
      "forgot.field.newPassword.ph": "至少 6 个字符",
      "forgot.resend": "重新发送验证码",
      "forgot.resendIn": "{{seconds}} 秒后可重新发送",
      "forgot.resent": "已发送新验证码。",
      "forgot.backToLogin": "返回登录",
      "forgot.changeEmail": "更改电子邮箱",
      "forgot.help.noMail": "如果未收到验证码，请检查垃圾邮件箱或确认您的电子邮箱地址。",
      "reset.RESET_CODE_SENT": "验证码已发送。请检查您的电子邮箱。",
      "reset.RATE_LIMITED": "尝试次数过多。请稍候再试。",
      "reset.MAIL_SEND_FAILED": "出了点问题。请稍后再试。",
      "reset.RESET_CODE_VALID": "验证码已确认。",
      "reset.INVALID_RESET_CODE": "验证码错误。请重试。",
      "reset.EXPIRED_RESET_CODE": "验证码已过期的。请请求新验证码。",
      "reset.WEAK_PASSWORD": "密码必须至少包含 6 个字符。",
      "reset.PASSWORD_RESET_SUCCESS": "您的密码已更新。您可以使用新密码登录。",
      "reset.generic": "出了点问题。请重试。",
      "login.resetSuccess": "您的密码已更新。您可以使用新密码登录。",
      "store.nav.shop": "商店",
      "home.hero.title1": "几分钟即可连接，",
      "home.hero.title2": "超越国界，时刻相连。",
      "home.hero.subtitle": "覆盖 190 多个国家的可靠 eSIM 套餐。无实体 SIM 卡，无漫游费。",
      "home.search.placeholder": "您要去哪里旅行？",
      "home.tabs.local": "本地 eSIM",
      "home.tabs.regional": "区域 eSIM",
      "home.tabs.lifetime": "终身 eSIM",
      "home.empty": "未找到与您的搜索相匹配的结果。",
      "home.error.title": "无法加载内容",
      "home.error.retry": "重试",
      "home.from": "起",
      "home.popular": "热门目的地",
      "home.coverage": "190+ 国家 · 即时激活",
      "home.detail.soon": "此选项的套餐很快将在这里列出。",
      "home.detail.back": "返回商店",
      "detail.plans": "套餐",
      "detail.count": "{{count}} 个套餐",
      "detail.validity": "{{days}} 天",
      "detail.validityLifetime": "无期限",
      "detail.buy": "购买",
      "detail.empty": "当前没有适用于此选项的套餐。",
      "detail.checkoutSoon": "支付流程即将添加。",
      "detail.loginToBuy": "您必须登录才能购买。",
      "detail.basicFeatures": "基本功能",
      "detail.dataAmount": "数据量",
      "detail.validityLabel": "有效期",
      "detail.coverageArea": "覆盖区域",
      "detail.activationNetworks": "激活与网络",
      "detail.activationMethod": "激活方式",
      "detail.esimActivation": "eSIM — 通过二维码即时激活",
      "detail.supportedNetworks": "支持的网络",
      "detail.description": "描述",
      "detail.price": "价格",
      "authprompt.title": "登录以继续",
      "authprompt.message": "登录您的账户以购买 eSIM，或在几秒钟内创建一个新账户。",
      "authprompt.close": "关闭",
      "footer.tagline": "全球快速、安全且实惠的 eSIM。落地即可连接互联网。",
      "footer.explore": "探索",
      "footer.support": "支持",
      "footer.legal": "法律条款",
      "footer.shop": "商店",
      "footer.help": "常见问题",
      "footer.terms": "使用条款",
      "footer.rights": "© {{year}} Utkan eSIM. 保留所有权利。",
      "footer.apps": "下载应用",
      "whatsapp.label": "通过 WhatsApp 联系",
      "whatsapp.message": "您好，我有一个 eSIM 支持请求。",
      "notfound.eyebrow": "无信号",
      "notfound.title": "无法访问此页面",
      "notfound.message": "您寻找的页面可能已被移动或从未存在。让我们带您回到覆盖范围内。",
      "order.congrats": "恭喜！",
      "order.message": "您的 eSIM 已准备就绪。您可以通过下方的二维码通过几个步骤进行安装。",
      "order.details": "订单摘要",
      "order.activation": "激活",
      "order.activationDesc": "要安装您的 eSIM，请使用设备相机扫描二维码或手动输入安装代码。",
      "order.qrTitle": "eSIM 二维码",
      "order.manualLabel": "安装代码",
      "order.copy": "复制",
      "order.copied": "已复制",
      "order.howTo": "如何激活？",
      "order.step1": "在您的设备上前往 设置 > 蜂窝网络 / 移动数据 > 添加 eSIM。",
      "order.step2": "选择“使用二维码”并扫描上方的二维码（或手动输入安装代码）。",
      "order.step3": "安装完成后，激活您的 eSIM 套餐。",
      "order.step4": "确保数据漫游已开启 — 您现在已连网！",
      "order.cta": "返回首页",
      "checkout.title": "结账",
      "checkout.summary": "订单摘要",
      "checkout.total": "总计",
      "checkout.eurNote": "金额在 PayPal 中以欧元 (€) 收取。",
      "checkout.processing": "正在验证您的支付…",
      "checkout.error": "支付未能完成。请重试。",
      "checkout.cancelled": "支付已取消。",
      "account.title": "我的账户",
      "account.tab.profile": "个人资料",
      "account.tab.esims": "我的 eSIM",
      "account.tab.security": "安全",
      "account.profile.title": "个人资料信息",
      "account.field.phone": "电话",
      "account.field.phone.ph": "+86…",
      "account.memberSince": "注册会员时间",
      "account.save": "保存",
      "account.saving": "正在保存…",
      "account.saved": "您的信息已更新。",
      "account.esims.title": "我的 eSIM",
      "account.esims.empty": "您还没有 eSIM。",
      "account.esims.emptyCta": "浏览商店",
      "account.esims.data": "数据",
      "account.esims.expires": "到期日期",
      "account.esims.viewQr": "显示二维码",
      "account.esims.hideQr": "隐藏二维码",
      "account.esims.active": "活动",
      "account.esims.passive": "非活动",
      "account.esims.noActive": "您没有活动的 eSIM。",
      "account.esims.noPassive": "您没有非活动的 eSIM。",
      "account.esims.readyHint": "准备就绪 — 时效从首次使用开始计算。",
      "account.esims.unavailableHint": "当前无法加载状态。请稍后重试。",
      "esimStatus.active": "活动",
      "esimStatus.readyToUse": "准备就绪",
      "esimStatus.inactive": "非活动",
      "esimStatus.unavailable": "无法加载状态",
      "account.security.title": "修改密码",
      "account.field.oldPassword": "当前密码",
      "account.field.newPassword": "新密码",
      "account.field.confirmPassword": "新密码（确认）",
      "account.changePassword": "更新密码",
      "account.passwordChanged": "您的密码已更新。",
      "account.error.passwordMismatch": "两次输入的新密码不一致。",
      "account.danger.title": "账户操作",
      "account.delete": "删除账户",
      "account.delete.confirm": "您即将永久删除您的账户。此操作无法撤销。",
      "account.delete.confirmBtn": "是的，删除",
      "account.cancel": "取消",
      "esimDetail.back": "返回",
      "esimDetail.dataUsage": "数据使用量",
      "esimDetail.left": "剩余",
      "esimDetail.leftData": "剩余数据",
      "esimDetail.usedData": "已使用",
      "esimDetail.totalData": "总数据",
      "esimDetail.qrDesc": "使用设备相机扫描此二维码以安装您的 eSIM。",
      "esimDetail.validity": "有效期",
      "esimDetail.daysLeft": "剩余 {{days}} 天",
      "esimDetail.expired": "已过期",
      "esimDetail.notYetActive": "尚未激活",
      "esimDetail.leftDate": "剩余时间",
      "esimDetail.activationDate": "激活日期",
      "esimDetail.endDate": "到期日期",
      "esimDetail.technical": "技术信息",
      "esimDetail.activationCode": "激活代码 (Android)",
      "esimDetail.smdp": "SM-DP+ 地址 (iOS)",
      "esimDetail.matchingId": "匹配 ID (iOS)",
      "esimDetail.support": "技术支持",
      "esimDetail.supportDesc": "遇到问题了吗？让我们来帮您。",
      "esimDetail.email": "发送电子邮件",
      "guide.eyebrow": "eSIM 指南",
      "guide.title": "什么是 eSIM，如何安装？",
      "guide.intro.title": "什么是 eSIM？",
      "guide.intro.body": "eSIM 是一种嵌入您设备中的数字 SIM 卡，无需实体 SIM 卡即可运行。扫描二维码即可在几秒钟内设置您的线路；在 190 多个国家/地区连接互联网，无需更换卡片，也无漫游费。",
      "guide.steps.title": "如何激活？",
      "guide.devices.title": "支持的设备",
      "guide.devices.desc": "您的设备必须支持 eSIM 才能正常使用。请查看您的品牌。",
      "guide.faq.title": "常见问题",
      "nav.guide": "eSIM 指南",
      "currency.label": "货币",
      "staticPage.loading": "页面加载中...",
      "staticPage.errorTitle": "发生错误",
      "staticPage.retry": "重试",
      "staticPage.loadFailed": "页面内容加载失败。请稍后重试。",
      "last.updated": "最后更新：2024年7月8日",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "无限流量 eSIM",
      "detail.unlimited": "无限流量",
      "detail.unlimitedNote": "此套餐没有流量上限——在整个有效期内畅享无限上网。",
      "detail.notPriced": "该套餐目前无法在网页端购买。",
      "checkout.priceUpdated": "该套餐价格已更新。请返回商店重新选择。",
      "order.pending.title": "正在准备您的 eSIM",
      "order.pending.message": "支付已成功。无限流量套餐可能需要几分钟才能开通。",
      "order.pending.waiting": "正在查询订单状态…",
      "order.pending.ready": "您的 eSIM 已就绪！",
      "order.pending.timeout": "耗时比预期长。您的付款已受保护——eSIM 准备就绪后会出现在“我的 eSIM”中。",
      "order.pending.cta": "前往我的 eSIM",
      "account.esims.unlimited": "无限流量",
      "account.esims.unlimitedHint": "无限流量——此套餐没有流量上限。",
      "esimDetail.unlimitedData": "此套餐没有流量上限；剩余时间见下方。",


      // 账户删除页面 (/hesap-sil · /account-deletion) — Google Play「Data deletion」要求
      "del.eyebrow": "账户删除",
      "del.title": "删除我的账户",
      "del.intro": "您可以在此永久删除您的 Utkan eSIM 账户及个人数据。无需安装应用程序，只需使用要删除的账户登录即可。",
      "del.deleted.title": "将被删除的数据",
      "del.deleted.identity": "您的姓名、电子邮箱和电话号码",
      "del.deleted.credentials": "您的密码和登录会话信息",
      "del.deleted.codes": "您的邮箱验证码和密码重置码",
      "del.deleted.esim": "您的 eSIM 号码 (MSISDN)、二维码/激活码以及使用数据",
      "del.kept.title": "我们保留的数据及原因",
      "del.kept.orders": "购买记录（订单号、日期、金额、支付状态）因税务和会计义务而保留。这些记录不包含您的姓名、邮箱或支付信息，仅包含无法与您关联的标识符。",
      "del.kept.period": "保留期限：5 年（土耳其税收程序法第 253 条）。",
      "del.warn.title": "删除前请注意",
      "del.warn.irreversible": "此操作无法撤销。",
      "del.warn.esim": "已激活的 eSIM 仍可在您的设备上继续使用，但您将无法再访问二维码和剩余流量。请在删除前保存您的二维码。",
      "del.warn.rejoin": "您可以使用同一邮箱重新注册，但原有的 eSIM 不会出现在新账户中。",
      "del.support": "如果您无法登录，也可以通过电子邮件申请删除：",
      "del.login.title": "请先登录",
      "del.login.subtitle": "请输入邮箱和密码，以确认该账户属于您。",
      "del.login.action": "登录",
      "del.login.loading": "正在登录...",
      "del.forgot": "忘记密码？",
      "del.confirm.title": "确定要删除吗？",
      "del.confirm.subtitle": "账户 {{email}} 及您的个人数据将被永久删除。",
      "del.confirm.field": "请再次输入您的邮箱以确认",
      "del.confirm.action": "永久删除我的账户",
      "del.confirm.deleting": "正在删除...",
      "del.confirm.cancel": "取消",
      "del.done.title": "您的账户已删除",
      "del.done.body": "您的个人数据已被永久删除。",
      "del.done.retained": "您的个人数据已被永久删除。因法律义务保留了 {{n}} 条购买记录，这些记录无法与您关联。",
      "del.done.home": "返回商店",
      "del.error.required": "请输入您的邮箱和密码。",
      "del.error.credentials": "邮箱或密码有误。",
      "del.error.suspended": "您的账户已被停用，请联系客服。",
      "del.error.session": "登录状态已过期，请重新登录。",
      "del.error.network": "无法连接。请检查网络后重试。",
      "del.error.generic": "出现问题，请重试。",
      "footer.deleteAccount": "删除账户",


      // 通话套餐（流量 + 无限通话和短信）— docs/ses-paketleri.md
      "home.tabs.voice": "通话 eSIM",
      "detail.voice": "通话 + 短信",
      "detail.voiceNote": "此套餐在流量之外还包含无限通话和短信——一张 eSIM 同时满足上网与通话。",
      "detail.calls": "通话",
      "detail.sms": "短信",
      "plan.unlimitedCalls": "无限通话",
      "plan.unlimitedSms": "无限短信",
      "plan.minutes": "{{n}} 分钟通话",
      "plan.sms": "{{n}} 条短信",
      "loading": "加载中..."
    }
  },
  ja: {
    translation: {
      "hero.title": "Utkan eSIM",
      "hero.subtitle": "デジタル接続の未来",
      "hero.description": "次世代のデジタル接続体験で、境界線をなくします。",
      "hero.description2": "世界中で迅速、安全、かつ手頃な価格の eSIM ソリューション。",
      "features.countries": "150+ か国",
      "features.activation": "即時アクティベーション",
      "features.support": "24時間365日サポート",
      "countdown.title": "ウェブサイトはまもなく公開！",
      "countdown.days": "日",
      "countdown.hours": "時間",
      "countdown.minutes": "分",
      "countdown.seconds": "秒",
      "countdown.launch": "ウェブサイトがオープンしました！",
      "countdown.loading": "読み込み中...",
      "apps.title": "モバイルアプリ",
      "apps.ios.label": "ダウンロード:",
      "apps.ios.name": "App Store",
      "apps.android.label": "入手方法:",
      "apps.android.name": "Google Play",
      "contact.title": "ローンチ前のお問い合わせ",
      "contact.whatsapp": "WhatsApp: +43 676 555 1 333",
      "contact.email": "メール: info@utkanesim.com",
      "about.hero.title": "Utkan eSIM について",
      "about.hero.description": "お客様の個人情報の保護は私たちにとって非常に重要です。この方針では、データの収集、使用、保護の方法について説明します。",
      "about.story.title": "私たちのストーリー",
      "about.story.content": "情熱的な旅行者とテクノロジー愛好家のチームによって2024年に設立された Utkan eSIM は、海外でのインターネット接続方法を革新することを目指しています。190以上の国と地域に向けて高品質で信頼性の高い eSIM データプランを提供し、到着した瞬間から迅速なインターネットアクセスを保証します。",
      "about.mission.title": "私たちのミッション",
      "about.mission.content": "世界中の旅行者にシンプル、手頃、そして即時の接続を提供し、国境なしで探索、仕事、連絡が取れるようにすること。",
      "about.vision.title": "私たちのビジョン",
      "about.vision.content": "デジタル接続ソリューションの主要なグローバルプラットフォームとなり、世界をすべての人にとってより小さく、よりつながりのある場所にすること。",
      "about.features.title": "選ばれる理由",
      "about.features.instant.title": "即時配信",
      "about.features.instant.content": "購入後、QRコードで eSIM をすぐに入手できます。",
      "about.features.global.title": "グローバルカバレッジ",
      "about.features.global.content": "190以上の国と地域向けのデータプラン。",
      "about.features.affordable.title": "手頃な価格",
      "about.features.affordable.content": "ローミング料金を最大90%節約。",
      "about.features.support.title": "24時間365日サポート",
      "about.features.support.content": "専任のサポートチームがいつでもお手伝いします。",
      "about.features.secure.title": "安全な接続",
      "about.features.secure.content": "最新のセキュリティプロトコルで保護された接続。",
      "about.features.fast.title": "高速インターネット",
      "about.features.fast.content": "4G/5G の速度で中断のないインターネット体験。",
      "about.cta.title": "デジタル接続の未来に参加しよう",
      "about.cta.content": "Utkan eSIM をお選びいただきありがとうございます。良い旅を！",
      "about.cta.whatsapp": "WhatsAppで連絡",
      "about.cta.email": "メールを送信",
      "contact.hero.title": "お問い合わせ",
      "contact.hero.description": "eSIM に関するご質問、技術サポートが必要な場合、またはフィードバックをお寄せいただける場合は、お気軽にお問い合わせください。",
      "contact.info.title": "連絡先情報",
      "contact.whatsapp.title": "WhatsApp",
      "contact.whatsapp.subtitle": "24時間365日迅速サポート",
      "contact.email.title": "メール",
      "contact.email.subtitle": "一般お問い合わせ",
      "contact.support.title": "技術サポート",
      "contact.support.subtitle": "eSIM の問題",
      "contact.business.title": "ビジネスパートナーシップ",
      "contact.business.subtitle": "法人向け連絡先",
      "contact.hours.title": "サポート時間",
      "contact.hours.subtitle": "24時間365日技術サポート",
      "contact.hours.detail": "月曜日 - 日曜日: 00:00 - 23:59",
      "contact.form.title": "メッセージを送信",
      "contact.form.name": "お名前",
      "contact.form.name.placeholder": "お名前を入力してください",
      "contact.form.email": "メールアドレス",
      "contact.form.email.placeholder": "ornek@email.com",
      "contact.form.subject": "件名",
      "contact.form.subject.placeholder": "件名を選択",
      "contact.form.subject.general": "一般情報",
      "contact.form.subject.technical": "技術サポート",
      "contact.form.subject.billing": "請求に関する質問",
      "contact.form.subject.partnership": "ビジネスパートナーシップ",
      "contact.form.subject.feedback": "フィードバック",
      "contact.form.message": "メッセージ",
      "contact.form.message.placeholder": "ここにメッセージを入力してください...",
      "contact.form.submit": "メッセージを送信",
      "contact.faq.title": "よくある質問",
      "contact.faq.esim.title": "eSIM はどのように機能しますか？",
      "contact.faq.esim.content": "eSIM は、物理的な SIM カードを必要とせずにお使いの携帯電話で動作するデジタル SIM カードです。QRコードで即座に有効化されます。",
      "contact.faq.phones.title": "どの携帯電話が eSIM をサポートしていますか？",
      "contact.faq.phones.content": "iPhone XS 以降、Samsung Galaxy S20 以降、Google Pixel 3 以降のモデルが eSIM をサポートしています。",
      "contact.faq.validity.title": "データプランの有効期間はどのくらいですか？",
      "contact.faq.validity.content": "プランの有効期間は、選択したプランに応じて1〜30日です。",
      "contact.faq.payment.title": "支払いはどのように行われますか？",
      "contact.faq.payment.content": "クレジットカード、PayPal、銀行振込で安全にお支払いいただけます。",
      "privacy.hero.title": "プライバシーポリシー",
      "privacy.hero.description": "お客様の個人情報の保護は私たちにとって非常に重要です。この方針では、データの収集、使用、保護の方法について説明します。",
      "privacy.overview.title": "概要",
      "privacy.overview.content": "このプライバシーポリシーは、本サービスを利用する際のお客様情報の収集、使用、開示に関する当社のポリシーと手順について説明しています。また、お客様のプライバシーに関する権利と法律による保護の方法についてもお知らせします。",
      "privacy.data.title": "収集するデータ",
      "privacy.data.personal.title": "個人情報",
      "privacy.data.personal.name": "氏名",
      "privacy.data.personal.email": "メールアドレス",
      "privacy.data.personal.phone": "電話番号",
      "privacy.data.personal.payment": "支払い情報",
      "privacy.data.usage.title": "利用データ",
      "privacy.data.usage.ip": "IP アドレス",
      "privacy.data.usage.browser": "ブラウザの種類",
      "privacy.data.usage.device": "デバイス情報",
      "privacy.data.usage.stats": "利用統計",
      "privacy.security.title": "データセキュリティ",
      "privacy.security.ssl.title": "SSL 暗号化",
      "privacy.security.ssl.content": "すべてのデータ転送は 256-bit SSL 暗号化によって保護されます。",
      "privacy.security.servers.title": "安全なサーバー",
      "privacy.security.servers.content": "データは ISO 27001 認証済みの安全なサーバーに保存されます。",
      "privacy.security.access.title": "アクセス制御",
      "privacy.security.access.content": "権限を持つ担当者のみがデータにアクセスできます。",
      "privacy.usage.title": "データの利用",
      "privacy.usage.intro": "収集したデータは以下の目的で使用されます：",
      "privacy.usage.service.title": "サービスの提供",
      "privacy.usage.service.content": "eSIM サービスの提供および管理",
      "privacy.usage.support.title": "カスタマーサポート",
      "privacy.usage.support.content": "技術サポートおよびカスタマーサービスの提供",
      "privacy.usage.security.title": "セキュリティ",
      "privacy.usage.security.content": "アカウントとサービスの保護",
      "privacy.usage.improvement.title": "改善",
      "privacy.usage.improvement.content": "サービスの向上と新機能の追加",
      "privacy.sharing.title": "データの共有",
      "privacy.sharing.intro": "個人データを第三者と共有することはありませんが、以下の場合には共有が必要となることがあります：",
      "privacy.sharing.legal": "法的義務がある場合",
      "privacy.sharing.providers": "サービスプロバイダー（決済代行業者など）と",
      "privacy.sharing.threats": "セキュリティ上の脅威を防ぐため",
      "privacy.sharing.consent": "お客様の明確な同意がある場合",
      "privacy.rights.title": "お客様の権利",
      "privacy.rights.access.title": "アクセス権",
      "privacy.rights.access.content": "当社が保有するお客様のデータへのアクセスを要求できます。",
      "privacy.rights.correction.title": "訂正権",
      "privacy.rights.correction.content": "不正確または不完全なデータを訂正することができます。",
      "privacy.rights.deletion.title": "削除権",
      "privacy.rights.deletion.content": "一定の条件の下でデータを削除できます。",
      "privacy.rights.objection.title": "異議申立権",
      "privacy.rights.objection.content": "データ処理活動に対して異議を申し立てることができます。",
      "privacy.contact.title": "お問い合わせ",
      "privacy.contact.intro": "このプライバシーポリシーについてご質問がある場合は、以下のチャネルからお問い合わせください：",
      "nav.about": "私たちについて",
      "nav.contact": "お問い合わせ",
      "nav.privacy": "プライバシー",
      "nav.login": "ログイン",
      "nav.account": "マイアカウント",
      "nav.logout": "ログアウト",
      "auth.brand.eyebrow": "グローバルカバレッジ",
      "auth.brand.title": "150か国以上で、降り立った瞬間にインターネット。",
      "auth.brand.subtitle": "物理SIMなし、ローミング料金なし。数秒で eSIM を有効化。",
      "auth.login.eyebrow": "アカウントログイン",
      "auth.login.title": "おかえりなさい",
      "auth.login.subtitle": "eSIM を管理し、新しいプランを見つけましょう。",
      "auth.signup.eyebrow": "新規アカウント",
      "auth.signup.title": "参加する",
      "auth.signup.subtitle": "いくつかのステップで最初の eSIM の準備を整えましょう。",
      "auth.field.identifier": "メールまたは電話番号",
      "auth.field.identifier.ph": "ornek@email.com または +81…",
      "auth.field.email": "メールアドレス",
      "auth.field.email.ph": "ornek@email.com",
      "auth.field.fullName": "氏名",
      "auth.field.fullName.ph": "あなたの氏名",
      "auth.field.password": "パスワード",
      "auth.field.password.ph": "••••••••",
      "auth.action.login": "ログイン",
      "auth.action.loggingIn": "ログイン中…",
      "auth.action.signup": "アカウント作成",
      "auth.action.signingUp": "アカウント作成中…",
      "auth.toSignup.q": "アカウントをお持ちですか？いいえ",
      "auth.toSignup.link": "登録",
      "auth.toLogin.q": "すでにアカウントをお持ちですか？",
      "auth.toLogin.link": "ログイン",
      "auth.password.show": "パスワードを表示",
      "auth.password.hide": "パスワードを隠す",
      "auth.terms.prefix": "続行することで、",
      "auth.terms.link": "利用規約およびプライバシーポリシー",
      "auth.terms.suffix": "に同意したことになります。",
      "auth.error.required": "必須項目を入力してください。",
      "auth.error.terms": "続行するには規約に同意する必要があります。",
      "verify.eyebrow": "メール確認",
      "verify.title": "メールアドレスを確認",
      "verify.subtitle": "{{email}} に6桁のコードを送信しました。確認のためにコードを入力してください。",
      "verify.code": "確認コード",
      "verify.code.ph": "••••••",
      "verify.action": "確認",
      "verify.verifying": "確認中…",
      "verify.resend": "コードを再送信",
      "verify.resendIn": "{{seconds}} 秒後に再送信",
      "verify.resent": "新しいコードを送信しました。",
      "verify.skip": "今はスキップ",
      "auth.forgot.link": "パスワードをお忘れですか？",
      "forgot.eyebrow": "パスワードリセット",
      "forgot.email.title": "パスワードをリセット",
      "forgot.email.subtitle": "アカウントのメールアドレスを入力してください。6桁のリセットコードを送信します。",
      "forgot.email.action": "コードを送信",
      "forgot.email.sending": "送信中…",
      "forgot.reset.title": "新しいパスワードを設定",
      "forgot.reset.subtitle": "{{email}} に送信した6桁のコードと新しいパスワードを入力してください。",
      "forgot.reset.action": "パスワードを更新",
      "forgot.reset.updating": "更新中…",
      "forgot.field.code": "リセットコード",
      "forgot.field.code.ph": "••••••",
      "forgot.field.newPassword": "新しいパスワード",
      "forgot.field.newPassword.ph": "6文字以上",
      "forgot.resend": "コードを再送信",
      "forgot.resendIn": "{{seconds}} 秒後に再送信",
      "forgot.resent": "新しいコードを送信しました。",
      "forgot.backToLogin": "ログインに戻る",
      "forgot.changeEmail": "メールアドレスを変更",
      "forgot.help.noMail": "コードが届かない場合は、スパムフォルダを確認するか、メールアドレスを確認してください。",
      "reset.RESET_CODE_SENT": "コードを送信しました。メールをご確認ください。",
      "reset.RATE_LIMITED": "試行回数が多すぎます。しばらく待ってからもう一度お試しください。",
      "reset.MAIL_SEND_FAILED": "問題が発生しました。後でもう一度お試しください。",
      "reset.RESET_CODE_VALID": "コードが確認されました。",
      "reset.INVALID_RESET_CODE": "コードが間違っています。もう一度お試しください。",
      "reset.EXPIRED_RESET_CODE": "コードの有効期限が切れました。新しいコードをリクエストしてください。",
      "reset.WEAK_PASSWORD": "パスワードは6文字以上である必要があります。",
      "reset.PASSWORD_RESET_SUCCESS": "パスワードが更新されました。新しいパスワードでログインできます。",
      "reset.generic": "問題が発生しました。もう一度お試しください。",
      "login.resetSuccess": "パスワードが更新されました。新しいパスワードでログインできます。",
      "store.nav.shop": "ストア",
      "home.hero.title1": "数分で接続、",
      "home.hero.title2": "境界線を越えてつながる。",
      "home.hero.subtitle": "190か国以上で有効な信頼できる eSIM パッケージ。物理SIMなし、ローミング料金なし。",
      "home.search.placeholder": "どこへ旅行しますか？",
      "home.tabs.local": "ローカル eSIM",
      "home.tabs.regional": "リージョナル eSIM",
      "home.tabs.lifetime": "生涯 eSIM",
      "home.empty": "検索に一致する結果が見つかりませんでした。",
      "home.error.title": "コンテンツを読み込めませんでした",
      "home.error.retry": "再試行",
      "home.from": "から",
      "home.popular": "人気の目的地",
      "home.coverage": "190+ か国 · 即時アクティベーション",
      "home.detail.soon": "この選択のパッケージはまもなくここに表示されます。",
      "home.detail.back": "ストアに戻る",
      "detail.plans": "プラン",
      "detail.count": "{{count}} 件のプラン",
      "detail.validity": "{{days}} 日間",
      "detail.validityLifetime": "無期限",
      "detail.buy": "購入",
      "detail.empty": "この選択肢に対するプランは現在ありません。",
      "detail.checkoutSoon": "決済フローはまもなく追加されます。",
      "detail.loginToBuy": "購入するにはログインする必要があります。",
      "detail.basicFeatures": "基本機能",
      "detail.dataAmount": "データ量",
      "detail.validityLabel": "有効期間",
      "detail.coverageArea": "カバレッジエリア",
      "detail.activationNetworks": "アクティベーションとネットワーク",
      "detail.activationMethod": "アクティベーション方法",
      "detail.esimActivation": "eSIM — QRコードで即座に",
      "detail.supportedNetworks": "サポートされているネットワーク",
      "detail.description": "説明",
      "detail.price": "価格",
      "authprompt.title": "続行するにはログイン",
      "authprompt.message": "eSIM を購入するにはアカウントにログインするか、数秒で新しいアカウントを作成してください。",
      "authprompt.close": "閉じる",
      "footer.tagline": "世界中で迅速、安全、手頃な価格の eSIM。降り立った瞬間にインターネットに接続。",
      "footer.explore": "探索",
      "footer.support": "サポート",
      "footer.legal": "法的情報",
      "footer.shop": "ストア",
      "footer.help": "よくある質問",
      "footer.terms": "利用規約",
      "footer.rights": "© {{year}} Utkan eSIM. All rights reserved.",
      "footer.apps": "アプリをダウンロード",
      "whatsapp.label": "WhatsAppでメッセージ",
      "whatsapp.message": "こんにちは、eSIM のサポートリクエストがあります。",
      "notfound.eyebrow": "信号なし",
      "notfound.title": "このページにはアクセスできません",
      "notfound.message": "お探しのページは移動されたか、存在しない可能性があります。カバレッジエリアにお連れします。",
      "order.congrats": "おめでとうございます！",
      "order.message": "eSIM の準備ができました。以下の QR コードを使っていくつかのステップで設定できます。",
      "order.details": "注文概要",
      "order.activation": "アクティベーション",
      "order.activationDesc": "eSIM を設定するには、デバイスのカメラで QR コードをスキャンするか、セットアップコードを手動で入力します。",
      "order.qrTitle": "eSIM QRコード",
      "order.manualLabel": "セットアップコード",
      "order.copy": "コピー",
      "order.copied": "コピーしました",
      "order.howTo": "有効化の方法",
      "order.step1": "デバイスで「設定」>「モバイル通信」>「eSIMを追加」に移動します。",
      "order.step2": "「QRコードを使用」を選択し、上記の QR コードをスキャンします（またはセットアップコードを手動で入力）。",
      "order.step3": "インストールが完了したら、eSIM プランを有効にします。",
      "order.step4": "データローミングがオンになっていることを確認してください。これで接続完了です！",
      "order.cta": "ホームページに戻る",
      "checkout.title": "チェックアウト",
      "checkout.summary": "注文概要",
      "checkout.total": "合計",
      "checkout.eurNote": "金額は PayPal でユーロ（€）建てで請求されます。",
      "checkout.processing": "支払いの確認中…",
      "checkout.error": "支払いを完了できませんでした。もう一度お試しください。",
      "checkout.cancelled": "支払いがキャンセルされました。",
      "account.title": "マイアカウント",
      "account.tab.profile": "プロフィール",
      "account.tab.esims": "マイ eSIM",
      "account.tab.security": "セキュリティ",
      "account.profile.title": "プロフィール情報",
      "account.field.phone": "電話番号",
      "account.field.phone.ph": "+81…",
      "account.memberSince": "会員登録日",
      "account.save": "保存",
      "account.saving": "保存中…",
      "account.saved": "情報が更新されました。",
      "account.esims.title": "マイ eSIM",
      "account.esims.empty": "eSIM はまだありません。",
      "account.esims.emptyCta": "ストアを見る",
      "account.esims.data": "データ",
      "account.esims.expires": "有効期限",
      "account.esims.viewQr": "QRコードを表示",
      "account.esims.hideQr": "QRコードを隠す",
      "account.esims.active": "アクティブ",
      "account.esims.passive": "非アクティブ",
      "account.esims.noActive": "アクティブな eSIM はありません。",
      "account.esims.noPassive": "非アクティブな eSIM はありません。",
      "account.esims.readyHint": "利用準備完了 — 有効期間は初回の使用時に開始されます。",
      "account.esims.unavailableHint": "現在ステータスを読み込めません。後でもう一度お試しください。",
      "esimStatus.active": "アクティブ",
      "esimStatus.readyToUse": "利用準備完了",
      "esimStatus.inactive": "非アクティブ",
      "esimStatus.unavailable": "ステータスを読み込めません",
      "account.security.title": "パスワードの変更",
      "account.field.oldPassword": "現在のパスワード",
      "account.field.newPassword": "新しいパスワード",
      "account.field.confirmPassword": "新しいパスワード（確認）",
      "account.changePassword": "パスワードを更新",
      "account.passwordChanged": "パスワードが更新されました。",
      "account.error.passwordMismatch": "新しいパスワードが一致しません。",
      "account.danger.title": "アカウントの操作",
      "account.delete": "アカウントを削除",
      "account.delete.confirm": "アカウントを完全に削除しようとしています。この操作は元に戻せません。",
      "account.delete.confirmBtn": "はい、削除します",
      "account.cancel": "キャンセル",
      "esimDetail.back": "戻る",
      "esimDetail.dataUsage": "データ使用量",
      "esimDetail.left": "残り",
      "esimDetail.leftData": "残りデータ",
      "esimDetail.usedData": "使用済み",
      "esimDetail.totalData": "合計データ",
      "esimDetail.qrDesc": "デバイスのカメラでこの QR コードをスキャンして eSIM を設定します。",
      "esimDetail.validity": "有効性",
      "esimDetail.daysLeft": "残り {{days}} 日",
      "esimDetail.expired": "期限切れ",
      "esimDetail.notYetActive": "まだ有効ではありません",
      "esimDetail.leftDate": "残り時間",
      "esimDetail.activationDate": "アクティベーション日",
      "esimDetail.endDate": "終了日",
      "esimDetail.technical": "技術情報",
      "esimDetail.activationCode": "アクティベーションコード (Android)",
      "esimDetail.smdp": "SM-DP+ アドレス (iOS)",
      "esimDetail.matchingId": "マッチング ID (iOS)",
      "esimDetail.support": "技術サポート",
      "esimDetail.supportDesc": "問題がありますか？お手伝いします。",
      "esimDetail.email": "メールを送信",
      "guide.eyebrow": "eSIM ガイド",
      "guide.title": "eSIM とは？設定方法は？",
      "guide.intro.title": "eSIM とは？",
      "guide.intro.body": "eSIM は、物理的な SIM カードなしでデバイスに内蔵されているデジタル SIM です。QR コードをスキャンするだけで数秒で回線が設定され、カードの交換やローミング料金なしで 190 か国以上でインターネットに接続できます。",
      "guide.steps.title": "有効化の方法",
      "guide.devices.title": "サポートされているデバイス",
      "guide.devices.desc": "eSIM を動作させるには、デバイスが eSIM に対応している必要があります。ブランドを確認してください。",
      "guide.faq.title": "よくある質問",
      "nav.guide": "eSIM ガイド",
      "currency.label": "通貨",
      "staticPage.loading": "ページを読み込んでいます...",
      "staticPage.errorTitle": "エラーが発生しました",
      "staticPage.retry": "再試行",
      "staticPage.loadFailed": "ページコンテンツを読み込めませんでした。後でもう一度お試しください。",
      "last.updated": "最終更新日: 2024年7月8日",

      // Sınırsız paketler (katalog v2) — src/FRONTEND_INTEGRATION.md
      "home.tabs.unlimited": "無制限 eSIM",
      "detail.unlimited": "無制限",
      "detail.unlimitedNote": "このプランにデータ上限はありません。有効期間中は無制限でインターネットをご利用いただけます。",
      "detail.notPriced": "このプランは現在ウェブでは購入できません。",
      "checkout.priceUpdated": "このプランの価格が更新されました。ストアに戻ってもう一度選択してください。",
      "order.pending.title": "eSIM を準備しています",
      "order.pending.message": "お支払いが完了しました。無制限プランは開通までに数分かかる場合があります。",
      "order.pending.waiting": "ご注文の状況を確認しています…",
      "order.pending.ready": "eSIM の準備ができました！",
      "order.pending.timeout": "予想より時間がかかっています。お支払いは保護されています。準備ができ次第、「マイ eSIM」に表示されます。",
      "order.pending.cta": "マイ eSIM へ",
      "account.esims.unlimited": "無制限",
      "account.esims.unlimitedHint": "無制限データ — このプランにデータ上限はありません。",
      "esimDetail.unlimitedData": "このプランにデータ上限はありません。残り期間は下記をご覧ください。",


      // アカウント削除ページ (/hesap-sil · /account-deletion) — Google Play「Data deletion」要件
      "del.eyebrow": "アカウント削除",
      "del.title": "アカウントを削除",
      "del.intro": "ここで Utkan eSIM のアカウントと個人データを完全に削除できます。アプリのインストールは不要です。削除したいアカウントでログインするだけです。",
      "del.deleted.title": "削除されるデータ",
      "del.deleted.identity": "氏名、メールアドレス、電話番号",
      "del.deleted.credentials": "パスワードおよびセッション情報",
      "del.deleted.codes": "メール認証コードおよびパスワード再設定コード",
      "del.deleted.esim": "eSIM 番号 (MSISDN)、QR/アクティベーションコード、利用データ",
      "del.kept.title": "保持されるデータとその理由",
      "del.kept.orders": "購入記録（注文番号、日付、金額、支払い状況）は税務・会計上の義務により保持されます。これらの記録には氏名、メールアドレス、支払い情報は含まれず、お客様と結び付けられない識別子のみが含まれます。",
      "del.kept.period": "保持期間：5 年（トルコ税務手続法 第253条）。",
      "del.warn.title": "削除前にご確認ください",
      "del.warn.irreversible": "この操作は取り消せません。",
      "del.warn.esim": "有効な eSIM は端末上で引き続き利用できますが、QR コードや残りのデータ量にはアクセスできなくなります。削除前に QR コードを保存してください。",
      "del.warn.rejoin": "同じメールアドレスで再登録できますが、以前の eSIM は新しいアカウントには表示されません。",
      "del.support": "ログインできない場合は、メールでも削除をご依頼いただけます:",
      "del.login.title": "まずログイン",
      "del.login.subtitle": "アカウントがご本人のものであることを確認するため、メールアドレスとパスワードを入力してください。",
      "del.login.action": "ログイン",
      "del.login.loading": "ログイン中...",
      "del.forgot": "パスワードをお忘れですか？",
      "del.confirm.title": "本当によろしいですか？",
      "del.confirm.subtitle": "アカウント {{email}} と個人データが完全に削除されます。",
      "del.confirm.field": "確認のためメールアドレスをもう一度入力してください",
      "del.confirm.action": "アカウントを完全に削除する",
      "del.confirm.deleting": "削除中...",
      "del.confirm.cancel": "キャンセル",
      "del.done.title": "アカウントを削除しました",
      "del.done.body": "個人データは完全に削除されました。",
      "del.done.retained": "個人データは完全に削除されました。法的義務により購入記録 {{n}} 件が保持されていますが、お客様と結び付けることはできません。",
      "del.done.home": "ストアに戻る",
      "del.error.required": "メールアドレスとパスワードを入力してください。",
      "del.error.credentials": "メールアドレスまたはパスワードが正しくありません。",
      "del.error.suspended": "アカウントが停止されています。サポートにお問い合わせください。",
      "del.error.session": "セッションの有効期限が切れました。再度ログインしてください。",
      "del.error.network": "接続できませんでした。インターネット接続を確認して再試行してください。",
      "del.error.generic": "問題が発生しました。もう一度お試しください。",
      "footer.deleteAccount": "アカウント削除",


      // 通話プラン（データ + 通話・SMS 無制限）— docs/ses-paketleri.md
      "home.tabs.voice": "通話付き eSIM",
      "detail.voice": "通話 + SMS",
      "detail.voiceNote": "このプランはデータに加えて通話と SMS が無制限です。1 枚の eSIM でインターネットも通話も使えます。",
      "detail.calls": "通話",
      "detail.sms": "SMS",
      "plan.unlimitedCalls": "通話無制限",
      "plan.unlimitedSms": "SMS 無制限",
      "plan.minutes": "通話 {{n}} 分",
      "plan.sms": "SMS {{n}} 通",
      "loading": "読み込み中..."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'tr',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
    },
  });

export default i18n; 